// AQUASOL CALCULATOR v3.2 — 26/06/2026
document.addEventListener("DOMContentLoaded", function(){

// ── DETECT LANGUAGE ──
var AA_LANG_RAW = document.documentElement.getAttribute("lang") || "es";
AA_LANG_RAW = AA_LANG_RAW.split("-")[0].toLowerCase();
var AA_LANG = AA_LANG_RAW;
if(AA_LANG_RAW === "pt") AA_LANG = "pt";
if(AA_LANG_RAW === "ca") AA_LANG = "ca";
if(AA_LANG_RAW === "el") AA_LANG = "el";
if(AA_LANG_RAW === "gr") AA_LANG = "el";

// ── CURRENCY MAP BY COUNTRY (sélecteur Shopify) ──
// Symboles : € pour EUR, sinon code
var COUNTRY_CURRENCY = {
  // ── EUROPE ZONE EURO ──
  'ES': { code: '€',   iso: 'EUR' },
  'FR': { code: '€',   iso: 'EUR' },
  'IT': { code: '€',   iso: 'EUR' },
  'PT': { code: '€',   iso: 'EUR' },
  'GR': { code: '€',   iso: 'EUR' },
  'DE': { code: '€',   iso: 'EUR' },
  'BE': { code: '€',   iso: 'EUR' },
  'NL': { code: '€',   iso: 'EUR' },
  'AT': { code: '€',   iso: 'EUR' },
  'FI': { code: '€',   iso: 'EUR' },
  'IE': { code: '€',   iso: 'EUR' },
  'LU': { code: '€',   iso: 'EUR' },
  'CY': { code: '€',   iso: 'EUR' },
  'MT': { code: '€',   iso: 'EUR' },
  'SK': { code: '€',   iso: 'EUR' },
  'SI': { code: '€',   iso: 'EUR' },
  'EE': { code: '€',   iso: 'EUR' },
  'LV': { code: '€',   iso: 'EUR' },
  'LT': { code: '€',   iso: 'EUR' },
  'HR': { code: '€',   iso: 'EUR' },
  'AD': { code: '€',   iso: 'EUR' },
  'MC': { code: '€',   iso: 'EUR' },
  'SM': { code: '€',   iso: 'EUR' },
  'VA': { code: '€',   iso: 'EUR' },
  'ME': { code: '€',   iso: 'EUR' },
  'XK': { code: '€',   iso: 'EUR' },
  // ── EUROPE HORS EURO ──
  'GB': { code: '£',   iso: 'GBP' },
  'CH': { code: 'CHF', iso: 'CHF' },
  'SE': { code: 'SEK', iso: 'SEK' },
  'NO': { code: 'NOK', iso: 'NOK' },
  'DK': { code: 'DKK', iso: 'DKK' },
  'PL': { code: 'PLN', iso: 'PLN' },
  'CZ': { code: 'CZK', iso: 'CZK' },
  'HU': { code: 'HUF', iso: 'HUF' },
  'RO': { code: 'RON', iso: 'RON' },
  'BG': { code: 'BGN', iso: 'BGN' },
  'RS': { code: 'RSD', iso: 'RSD' },
  'BA': { code: 'BAM', iso: 'BAM' },
  'MK': { code: 'MKD', iso: 'MKD' },
  'AL': { code: 'ALL', iso: 'ALL' },
  'IS': { code: 'ISK', iso: 'ISK' },
  'UA': { code: 'UAH', iso: 'UAH' },
  'MD': { code: 'MDL', iso: 'MDL' },
  'BY': { code: 'BYN', iso: 'BYN' },
  'GE': { code: 'GEL', iso: 'GEL' },
  'AM': { code: 'AMD', iso: 'AMD' },
  'AZ': { code: 'AZN', iso: 'AZN' },
  // ── MAGHREB ──
  'MA': { code: 'MAD', iso: 'MAD' },
  'DZ': { code: 'DZD', iso: 'DZD' },
  'TN': { code: 'TND', iso: 'TND' },
  'LY': { code: 'LYD', iso: 'LYD' },
  'MR': { code: 'MRU', iso: 'MRU' },
  // ── AFRIQUE SUBSAHARIENNE ──
  'SN': { code: 'XOF', iso: 'XOF' },
  'CI': { code: 'XOF', iso: 'XOF' },
  'ML': { code: 'XOF', iso: 'XOF' },
  'BF': { code: 'XOF', iso: 'XOF' },
  'NE': { code: 'XOF', iso: 'XOF' },
  'GN': { code: 'GNF', iso: 'GNF' },
  'TG': { code: 'XOF', iso: 'XOF' },
  'BJ': { code: 'XOF', iso: 'XOF' },
  'CM': { code: 'XAF', iso: 'XAF' },
  'GA': { code: 'XAF', iso: 'XAF' },
  'CG': { code: 'XAF', iso: 'XAF' },
  'CD': { code: 'CDF', iso: 'CDF' },
  'CF': { code: 'XAF', iso: 'XAF' },
  'TD': { code: 'XAF', iso: 'XAF' },
  'GQ': { code: 'XAF', iso: 'XAF' },
  'AO': { code: 'AOA', iso: 'AOA' },
  'ZA': { code: 'ZAR', iso: 'ZAR' },
  'ZW': { code: 'ZWL', iso: 'ZWL' },
  'ZM': { code: 'ZMW', iso: 'ZMW' },
  'MZ': { code: 'MZN', iso: 'MZN' },
  'TZ': { code: 'TZS', iso: 'TZS' },
  'KE': { code: 'KES', iso: 'KES' },
  'UG': { code: 'UGX', iso: 'UGX' },
  'RW': { code: 'RWF', iso: 'RWF' },
  'BI': { code: 'BIF', iso: 'BIF' },
  'ET': { code: 'ETB', iso: 'ETB' },
  'SO': { code: 'SOS', iso: 'SOS' },
  'SD': { code: 'SDG', iso: 'SDG' },
  'SS': { code: 'SSP', iso: 'SSP' },
  'ER': { code: 'ERN', iso: 'ERN' },
  'DJ': { code: 'DJF', iso: 'DJF' },
  'GH': { code: 'GHS', iso: 'GHS' },
  'NG': { code: 'NGN', iso: 'NGN' },
  'MG': { code: 'MGA', iso: 'MGA' },
  'MU': { code: 'MUR', iso: 'MUR' },
  'SC': { code: 'SCR', iso: 'SCR' },
  'CV': { code: 'CVE', iso: 'CVE' },
  'GM': { code: 'GMD', iso: 'GMD' },
  'GW': { code: 'XOF', iso: 'XOF' },
  'SL': { code: 'SLL', iso: 'SLL' },
  'LR': { code: 'LRD', iso: 'LRD' },
  'MW': { code: 'MWK', iso: 'MWK' },
  'NA': { code: 'NAD', iso: 'NAD' },
  'BW': { code: 'BWP', iso: 'BWP' },
  'LS': { code: 'LSL', iso: 'LSL' },
  'SZ': { code: 'SZL', iso: 'SZL' },
  'KM': { code: 'KMF', iso: 'KMF' },
  'ST': { code: 'STN', iso: 'STN' },
  // ── MOYEN-ORIENT ──
  'TR': { code: 'TRY', iso: 'TRY' },
  'SA': { code: 'SAR', iso: 'SAR' },
  'AE': { code: 'AED', iso: 'AED' },
  'EG': { code: 'EGP', iso: 'EGP' },
  'JO': { code: 'JOD', iso: 'JOD' },
  'LB': { code: 'LBP', iso: 'LBP' },
  'IL': { code: '₪',   iso: 'ILS' },
  'IQ': { code: 'IQD', iso: 'IQD' },
  'IR': { code: 'IRR', iso: 'IRR' },
  'KW': { code: 'KWD', iso: 'KWD' },
  'QA': { code: 'QAR', iso: 'QAR' },
  'BH': { code: 'BHD', iso: 'BHD' },
  'OM': { code: 'OMR', iso: 'OMR' },
  'YE': { code: 'YER', iso: 'YER' },
  'SY': { code: 'SYP', iso: 'SYP' },
  'PS': { code: '₪',   iso: 'ILS' },
  // ── ASIE CENTRALE ──
  'KZ': { code: 'KZT', iso: 'KZT' },
  'UZ': { code: 'UZS', iso: 'UZS' },
  'TM': { code: 'TMT', iso: 'TMT' },
  'TJ': { code: 'TJS', iso: 'TJS' },
  'KG': { code: 'KGS', iso: 'KGS' },
  'AF': { code: 'AFN', iso: 'AFN' },
  'PK': { code: 'PKR', iso: 'PKR' },
  // ── ASIE DU SUD ──
  'IN': { code: '₹',   iso: 'INR' },
  'BD': { code: 'BDT', iso: 'BDT' },
  'LK': { code: 'LKR', iso: 'LKR' },
  'NP': { code: 'NPR', iso: 'NPR' },
  'MV': { code: 'MVR', iso: 'MVR' },
  'BT': { code: 'BTN', iso: 'BTN' },
  // ── ASIE DU SUD-EST ──
  'ID': { code: 'IDR', iso: 'IDR' },
  'MY': { code: 'MYR', iso: 'MYR' },
  'TH': { code: '฿',   iso: 'THB' },
  'VN': { code: 'VND', iso: 'VND' },
  'PH': { code: '₱',   iso: 'PHP' },
  'SG': { code: 'SGD', iso: 'SGD' },
  'MM': { code: 'MMK', iso: 'MMK' },
  'KH': { code: 'KHR', iso: 'KHR' },
  'LA': { code: 'LAK', iso: 'LAK' },
  'BN': { code: 'BND', iso: 'BND' },
  'TL': { code: '$',   iso: 'USD' },
  // ── ASIE DE L'EST ──
  'CN': { code: '¥',   iso: 'CNY' },
  'JP': { code: '¥',   iso: 'JPY' },
  'KR': { code: '₩',   iso: 'KRW' },
  'TW': { code: 'TWD', iso: 'TWD' },
  'HK': { code: 'HKD', iso: 'HKD' },
  'MO': { code: 'MOP', iso: 'MOP' },
  'MN': { code: 'MNT', iso: 'MNT' },
  // ── OCÉANIE ──
  'AU': { code: 'AUD', iso: 'AUD' },
  'NZ': { code: 'NZD', iso: 'NZD' },
  'FJ': { code: 'FJD', iso: 'FJD' },
  'PG': { code: 'PGK', iso: 'PGK' },
  'SB': { code: 'SBD', iso: 'SBD' },
  'VU': { code: 'VUV', iso: 'VUV' },
  'WS': { code: 'WST', iso: 'WST' },
  'TO': { code: 'TOP', iso: 'TOP' },
  'PF': { code: 'XPF', iso: 'XPF' },
  'NC': { code: 'XPF', iso: 'XPF' },
  // ── AMÉRIQUES ──
  'US': { code: '$',   iso: 'USD' },
  'CA': { code: 'CAD', iso: 'CAD' },
  'MX': { code: 'MXN', iso: 'MXN' },
  'BR': { code: 'R$',  iso: 'BRL' },
  'AR': { code: 'ARS', iso: 'ARS' },
  'CL': { code: 'CLP', iso: 'CLP' },
  'CO': { code: 'COP', iso: 'COP' },
  'PE': { code: 'PEN', iso: 'PEN' },
  'VE': { code: 'VES', iso: 'VES' },
  'EC': { code: '$',   iso: 'USD' },
  'BO': { code: 'BOB', iso: 'BOB' },
  'PY': { code: 'PYG', iso: 'PYG' },
  'UY': { code: 'UYU', iso: 'UYU' },
  'GY': { code: 'GYD', iso: 'GYD' },
  'SR': { code: 'SRD', iso: 'SRD' },
  'GT': { code: 'GTQ', iso: 'GTQ' },
  'HN': { code: 'HNL', iso: 'HNL' },
  'SV': { code: '$',   iso: 'USD' },
  'NI': { code: 'NIO', iso: 'NIO' },
  'CR': { code: 'CRC', iso: 'CRC' },
  'PA': { code: 'PAB', iso: 'PAB' },
  'CU': { code: 'CUP', iso: 'CUP' },
  'DO': { code: 'DOP', iso: 'DOP' },
  'HT': { code: 'HTG', iso: 'HTG' },
  'JM': { code: 'JMD', iso: 'JMD' },
  'TT': { code: 'TTD', iso: 'TTD' },
  'BB': { code: 'BBD', iso: 'BBD' },
  'BS': { code: 'BSD', iso: 'BSD' },
  'BZ': { code: 'BZD', iso: 'BZD' },
  'TC': { code: '$',   iso: 'USD' },
  // ── RUSSIE & CEI ──
  'RU': { code: '₽',   iso: 'RUB' },
  // ── AUTRES ──
  'GI': { code: '£',   iso: 'GIP' },
  'JE': { code: '£',   iso: 'GBP' },
  'GG': { code: '£',   iso: 'GBP' },
  'IM': { code: '£',   iso: 'GBP' },
};

// Fallback par langue
var LANG_CURRENCY = {
  es: '€', fr: '€', en: '£', pt: '€',
  ar: 'MAD', el: '€', it: '€', tr: 'TRY', ca: '€'
};

var AA_LANG_FULL = (document.documentElement.getAttribute("lang") || navigator.language || "es").toLowerCase();

// ── DÉTECTION DU PAYS SÉLECTIONNÉ → DEVISE LOCALE ──
// On lit le CODE PAYS du sélecteur Shopify et on mappe vers la devise locale
// Peu importe la devise Shopify configurée (EUR, etc.) — toujours la devise du pays

var COUNTRY_NAMES_MAP = {
  'Espana':'ES','España':'ES','Spain':'ES','France':'FR','Italia':'IT','Italy':'IT',
  'Portugal':'PT','Grecia':'GR','Greece':'GR','Grèce':'GR','Alemania':'DE','Germany':'DE',
  'Allemagne':'DE','Belgica':'BE','Belgium':'BE','Belgique':'BE','Holanda':'NL',
  'Netherlands':'NL','Pays-Bas':'NL','Austria':'AT','Autriche':'AT','Finlandia':'FI',
  'Finland':'FI','Finlande':'FI','Irlanda':'IE','Ireland':'IE','Irlande':'IE',
  'Suiza':'CH','Switzerland':'CH','Suisse':'CH','Suecia':'SE','Sweden':'SE','Suède':'SE',
  'Noruega':'NO','Norway':'NO','Norvège':'NO','Dinamarca':'DK','Denmark':'DK',
  'Danemark':'DK','Polonia':'PL','Poland':'PL','Pologne':'PL','Rumania':'RO',
  'Romania':'RO','Roumanie':'RO','Hungria':'HU','Hungary':'HU','Hongrie':'HU',
  'Chequia':'CZ','Czech Republic':'CZ','Tchéquie':'CZ','Bulgaria':'BG','Bulgaria':'BG',
  'Croacia':'HR','Croatia':'HR','Ucrania':'UA','Ukraine':'UA',
  'Marruecos':'MA','Morocco':'MA','Maroc':'MA',
  'Argelia':'DZ','Algeria':'DZ','Algérie':'DZ',
  'Tunez':'TN','Tunisia':'TN','Tunisie':'TN',
  'Libia':'LY','Libya':'LY','Libye':'LY',
  'Turquia':'TR','Turkey':'TR','Turquie':'TR',
  'Arabia Saudi':'SA','Saudi Arabia':'SA','Arabie Saoudite':'SA',
  'Emiratos':'AE','United Arab Emirates':'AE','Emirats':'AE',
  'Egipto':'EG','Egypt':'EG','Egypte':'EG',
  'Jordania':'JO','Jordan':'JO','Jordanie':'JO',
  'Libano':'LB','Lebanon':'LB','Liban':'LB',
  'Kuwait':'KW','Koweit':'KW',
  'Qatar':'QA','Bahrein':'BH','Bahrain':'BH','Bahreïn':'BH',
  'Oman':'OM','Yemen':'YE','Yémen':'YE',
  'Irak':'IQ','Iraq':'IQ','Iran':'IR',
  'Israel':'IL','Israël':'IL','Siria':'SY','Syria':'SY','Syrie':'SY',
  'Reino Unido':'GB','United Kingdom':'GB','Grande-Bretagne':'GB',
  'Estados Unidos':'US','United States':'US','Etats-Unis':'US',
  'Canada':'CA','Canada':'CA',
  'Mexico':'MX','México':'MX','Mexique':'MX',
  'Brasil':'BR','Brazil':'BR','Brésil':'BR',
  'Argentina':'AR','Argentine':'AR',
  'Chile':'CL','Chili':'CL',
  'Colombia':'CO','Colombie':'CO',
  'Peru':'PE','Pérou':'PE',
  'Venezuela':'VE','Bolivia':'BO','Bolivie':'BO',
  'Paraguay':'PY','Uruguay':'UY',
  'India':'IN','Inde':'IN',
  'China':'CN','Chine':'CN',
  'Japon':'JP','Japan':'JP','Japon':'JP',
  'Corea':'KR','Korea':'KR','Corée':'KR',
  'Australia':'AU','Australie':'AU',
  'Nueva Zelanda':'NZ','New Zealand':'NZ','Nouvelle-Zélande':'NZ',
  'Senegal':'SN','Sénégal':'SN',
  'Côte d\'Ivoire':'CI','Costa de Marfil':'CI',
  'Ghana':'GH','Nigeria':'NG','Nigéria':'NG',
  'Kenya':'KE','Sudafrica':'ZA','South Africa':'ZA','Afrique du Sud':'ZA',
  'Camerun':'CM','Cameroon':'CM','Cameroun':'CM',
  'Rusia':'RU','Russia':'RU','Russie':'RU',
  'Georgia':'GE','Géorgie':'GE',
  'Kazajstan':'KZ','Kazakhstan':'KZ',
  'Pakistan':'PK','Indonesia':'ID','Indonésie':'ID',
  'Malasia':'MY','Malaysia':'MY','Malaisie':'MY',
  'Tailandia':'TH','Thailand':'TH','Thaïlande':'TH',
  'Vietnam':'VN','Filipinas':'PH','Philippines':'PH',
  'Singapur':'SG','Singapore':'SG','Singapour':'SG'
};

function detectCountryCode() {
  // 1. Input/select caché country_code dans le form Shopify
  var ccInputs = document.querySelectorAll(
    'input[name="country_code"], select[name="country_code"], [data-country-code]'
  );
  for (var i = 0; i < ccInputs.length; i++) {
    var v = ccInputs[i].value || ccInputs[i].getAttribute('data-country-code') || '';
    v = v.trim().toUpperCase();
    if (v.length === 2 && COUNTRY_CURRENCY[v]) return v;
  }

  // 2. Lire le texte du bouton sélecteur et chercher un nom de pays connu
  var btnSels = [
    '.localization-selector button',
    '.localization-form button',
    '.disclosure__toggle',
    '[data-localization-toggle]',
    'button[aria-expanded][aria-controls*="country"]',
    'button[aria-expanded][aria-controls*="localization"]',
    '.header__icon--localization button'
  ];
  for (var b = 0; b < btnSels.length; b++) {
    var el = document.querySelector(btnSels[b]);
    if (!el) continue;
    var txt = (el.textContent || el.innerText || '').trim();
    for (var name in COUNTRY_NAMES_MAP) {
      if (txt.indexOf(name) !== -1) return COUNTRY_NAMES_MAP[name];
    }
  }

  // 3. Chercher dans toutes les options sélectionnées du dropdown
  var selOptions = document.querySelectorAll(
    '.localization-form option[selected], select[name="country_code"] option:checked'
  );
  for (var o = 0; o < selOptions.length; o++) {
    var ov = (selOptions[o].value || '').toUpperCase();
    if (ov.length === 2 && COUNTRY_CURRENCY[ov]) return ov;
    var otxt = selOptions[o].textContent || '';
    for (var n2 in COUNTRY_NAMES_MAP) {
      if (otxt.indexOf(n2) !== -1) return COUNTRY_NAMES_MAP[n2];
    }
  }

  // 4. Shopify.locale → ex: "es-ES", "fr-FR", "ar-DZ"
  if (typeof Shopify !== 'undefined' && Shopify.locale) {
    var parts = Shopify.locale.split('-');
    if (parts.length >= 2) {
      var cc = parts[parts.length-1].toUpperCase();
      if (COUNTRY_CURRENCY[cc]) return cc;
    }
  }

  // 5. lang attribute → ex: lang="ar-DZ"
  var langAttr = document.documentElement.getAttribute('lang') || '';
  var lp = langAttr.split('-');
  if (lp.length >= 2) {
    var lcc = lp[lp.length-1].toUpperCase();
    if (COUNTRY_CURRENCY[lcc]) return lcc;
  }

  return null;
}

function resolveCurrency() {
  var cc = detectCountryCode();
  if (cc && COUNTRY_CURRENCY[cc]) return COUNTRY_CURRENCY[cc].code;
  // Fallback par langue
  if (AA_LANG === 'ar') {
    if (AA_LANG_FULL.indexOf('tn') !== -1) return 'TND';
    if (AA_LANG_FULL.indexOf('dz') !== -1) return 'DZD';
    return 'MAD';
  }
  return LANG_CURRENCY[AA_LANG] || 'EUR';
}

var CN = resolveCurrency();

// ── TAUX DE CHANGE (base EUR, ~2024) ──
var EUR_RATES = {
  '€':1,'EUR':1,
  '£':0.86,'GBP':0.86,
  'CHF':0.96,'SEK':11.5,'NOK':11.8,'DKK':7.46,
  'PLN':4.25,'CZK':25.1,'HUF':390,'RON':4.97,
  'BGN':1.96,'UAH':44,'RSD':117,'BAM':1.96,
  'MKD':61.5,'ALL':108,'ISK':150,'MDL':19,
  'BYN':3.6,'GEL':2.9,'AMD':425,'AZN':1.83,
  'MAD':10.8,'DZD':147,'TND':3.35,'LYD':5.2,'MRU':42,
  'TRY':36.5,'SAR':4.08,'AED':4.0,'EGP':53,
  'JOD':0.77,'LBP':97500,'₪':3.97,'ILS':3.97,
  'IQD':1430,'IRR':45000,'KWD':0.33,'QAR':3.97,
  'BHD':0.41,'OMR':0.42,'YER':272,'SYP':14200,
  'KZT':520,'UZS':13800,'TMT':3.8,'TJS':11.8,
  'KGS':94,'AFN':78,'PKR':304,
  '₹':91,'INR':91,'BDT':120,'LKR':330,'NPR':145,'MVR':16.8,'BTN':91,
  'IDR':17200,'MYR':5.0,'฿':38.5,'THB':38.5,
  'VND':27200,'₱':62,'PHP':62,'SGD':1.46,'MMK':2280,'KHR':4400,'LAK':22000,'BND':1.46,
  '¥':8.0,'CNY':7.9,'JPY':163,'₩':1440,'KRW':1440,'TWD':35,'HKD':8.5,'MOP':8.8,'MNT':3700,
  'AUD':1.64,'NZD':1.78,'FJD':2.43,'PGK':4.3,'SBD':9.2,'VUV':128,'WST':3.0,'TOP':2.55,'XPF':119,
  '$':1.08,'USD':1.08,'CAD':1.48,'R$':5.9,'BRL':5.9,'ARS':1050,'MXN':21,'CLP':1020,
  'COP':4650,'PEN':4.0,'VES':42,'BOB':7.5,'PYG':8300,'UYU':44,'GYD':226,'SRD':37,
  'GTQ':8.4,'HNL':27,'NIO':39,'CRC':555,'PAB':1.08,'CUP':28,'DOP':64,'HTG':144,
  'JMD':168,'TTD':7.3,'BBD':2.16,'BSD':1.08,'BZD':2.18,
  '₽':108,'RUB':108,
  'ZAR':20.5,'NGN':1850,'KES':140,'GHS':16.8,'XOF':655,'XAF':655,
  'ETB':132,'TZS':2850,'UGX':4100,'RWF':1450,'BIF':3200,'SOS':617,
  'SDG':648,'SSP':3700,'ERN':16.2,'DJF':192,'MGA':5100,'MUR':51,'SCR':16,
  'CVE':110,'GMD':76,'GNF':9350,'SLL':22800,'LRD':210,'MWK':1880,
  'NAD':20.5,'BWP':14.9,'LSL':20.5,'SZL':20.5,'KMF':492,'STN':24.5,
  'AOA':1040,'CDF':3100,'ZMW':28,'MZN':69,'ZWL':390,'GIP':0.86
};

// Convertir EUR → devise locale CN
function toLocalCurrency(amountEUR) {
  var rate = EUR_RATES[CN] || 1;
  return amountEUR * rate;
}

// Formater un montant converti intelligemment
function fmtCurr(amountEUR) {
  var v = toLocalCurrency(amountEUR);
  if(v >= 100000) return Math.round(v/1000)*1000;
  if(v >= 10000)  return Math.round(v/100)*100;
  if(v >= 1000)   return Math.round(v/10)*10;
  if(v >= 100)    return Math.round(v);
  if(v >= 10)     return parseFloat(v.toFixed(1));
  return parseFloat(v.toFixed(2));
}

// Réécouter les changements de pays en temps réel
function listenCountryChange() {
  // Select direct
  document.querySelectorAll('select[name="country_code"]').forEach(function(sel) {
    sel.addEventListener('change', function() {
      var cc = (this.value || '').toUpperCase();
      if (cc && COUNTRY_CURRENCY[cc]) {
        CN = COUNTRY_CURRENCY[cc].code;
        resetDefaultResultsByLang();
        applyTranslations();
  renderHistory();
      }
    });
  });
  // Boutons pays dans le dropdown Shopify Dawn
  document.querySelectorAll('[data-country-code]').forEach(function(el) {
    el.addEventListener('click', function() {
      var cc = (this.getAttribute('data-country-code') || this.value || '').toUpperCase();
      if (cc && COUNTRY_CURRENCY[cc]) {
        CN = COUNTRY_CURRENCY[cc].code;
        resetDefaultResultsByLang();
        applyTranslations();
      }
    });
  });
  // Submit du form de localisation → lire le pays avant rechargement
  document.querySelectorAll('form[action*="/localization"]').forEach(function(form) {
    form.addEventListener('submit', function() {
      var inp = form.querySelector('input[name="country_code"], select[name="country_code"]');
      if (inp && inp.value && COUNTRY_CURRENCY[inp.value.toUpperCase()]) {
        CN = COUNTRY_CURRENCY[inp.value.toUpperCase()].code;
      }
    });
  });
}
setTimeout(listenCountryChange, 800);

// ── TRANSLATIONS ──
var TXT = {};

TXT.es = {
  back:"Volver",
  title:"CALCULA <span>TUS AHORROS</span>",
  subtitle:"Calcula en menos de 30 segundos la dosis, el formato recomendado y el ahorro potencial de tu explotación.",
  cultivo:"Cultivo", producto:"Producto", aplicacion:"Tipo de aplicación",
  manualApp:"Aplicación manual", mecanizada:"Aplicación mecanizada",
  suelo:"Tipo de suelo", franco:"Franco / equilibrado", arenoso:"Arenoso", pedregoso:"Pedregoso", arcilloso:"Arcilloso",
  salino:'Salino / alcalino',
  ecLabel:'Conductividad eléctrica (CE) del suelo', ec0:'CE 0-2 (no salino)', ec2:'CE 2-4 (ligeramente salino)', ec4:'CE 4-8 (moderadamente salino)', ec8:'CE 8-16 (fuertemente salino)',
  salinAviso:'⚠️ Suelo salino: se aplica AQUASOL SAL, con dosis ajustada mediante un factor ×{factor} según la conductividad eléctrica (CE) del suelo.',
  salinAdultoSat205:'⚠️ Con CE 8-16, el uso de AQUASOL SAL es especialmente recomendable en árboles adultos, ya que el hidrogel estándar pierde más eficacia en estas condiciones de alta salinidad.',
  selectEC:'Selecciona el nivel de conductividad eléctrica (CE) del suelo. ',
  bonusAviso:'⚙️ Dosis ajustada según las condiciones de su suelo y clima.',
  clima:"Clima", medio:"Mediterráneo medio", seco:"Seco", muyseco:"Muy seco / sequía",
  edad:"Tipo de planta", joven:"Planta joven / pequeña", desarrollo:"Planta en desarrollo / mediana", adulto:"Árbol adulto / grande",
  sistema:"Sistema de riego", goteo:"Goteo", manual:"Manual", aspersion:"Aspersión", sinriego:"Sin riego fijo",
  hectareas:"Hectáreas", m2:"Superficie m²", sustrato:"Sustrato m³", plantas:"Número de plantas",
  riego:"Riego actual m³/ha/año", precio:"Precio del agua "+CN+"/m³",
  calcular:"CALCULAR AHORRO",
  impactBase:"El producto ayuda a mejorar la eficiencia hídrica según las condiciones seleccionadas.",
  visualSin:"Consumo estimado sin AQUASOL", visualCon:"Consumo estimado con AQUASOL",
  agua:"AGUA AHORRADA", dinero:"AHORRO ECONÓMICO", eficiencia:"EFICIENCIA HÍDRICA",
  hectarea:"AHORRO POR HECTÁREA", planta:"AHORRO POR PLANTA",
  dosis:"DOSIS ORIENTATIVA", dosisMec:"DOSIS MECANIZADA",
  productoNecesario:"PRODUCTO NECESARIO", formato:"FORMATO RECOMENDADO",
  coste:"COSTE PRODUCTO", beneficio:"BENEFICIO AGRONÓMICO",
  roi:"RETORNO POTENCIAL", roiSmall:"Según degradación progresiva estimada",
  leadTitle:"RECIBE TUS RESULTADOS Y UN PRESUPUESTO PERSONALIZADO",
  leadText:"Deja tus datos para recibir una propuesta adaptada a tu explotación.",
  empresa:"Empresa", nombre:"Nombre y apellido", telefono:"Teléfono",
  presupuesto:"SOLICITAR PRESUPUESTO", imprimir:"IMPRIMIR / PDF",
  note:"*Resultados orientativos. HYDRO y ECO retienen hasta 400 veces su peso en agua.",
  noAplica:"No aplica", menorMortalidad:"Menor mortalidad", plantasTxt:"plantas",
  saco1:"1 saco de 1 kg", saco2:"1 saco de 2 kg", saco5:"1 saco de 5 kg", sacos25:"saco(s) de 25 kg",
  alertDatos:"Por favor, completa tus datos.", alertTodos:"Por favor, completa todos los datos.",
  solicitud:"Solicitud AQUASOL AGRO",
  hastaReducir:"Según tu selección, AQUASOL puede ayudar a reducir el consumo de agua hasta aproximadamente un ",
  selectCultivo:"Selecciona un cultivo.", selectProducto:"Selecciona un producto.",
  selectAplicacion:"Selecciona tipo de aplicación.", selectSuelo:"Selecciona tipo de suelo.",
  selectClima:"Selecciona el clima.", selectSistema:"Selecciona sistema de riego.",
  selectEdad:"Selecciona tipo de planta.",
  sinRiegoAviso:"Sin riego fijo: no se calcula ahorro de agua. ",
  precio0:"Precio 0: ahorro económico mostrado a 0. ",
  introSustrato:"Introduce el volumen de sustrato en m³. ",
  introPlantasHort:"Introduce el número de plantas. ",
  introM2:"Introduce la superficie en m². ",
  introPlantasManual:"Introduce el número de plantas. ",
  introHaMec:"Introduce las hectáreas. ",
  validaTecnica:"Se recomienda validación técnica para esta combinación. ",
  introAgua:"Introduce hectáreas y riego actual para calcular ahorro de agua. ",
  introTronco:"Introduce el diámetro del tronco en cm. ",
  tronco:"Diámetro del tronco (cm)",
  smartQuestion:"¿Utilizarás AQUASOL AGRO Smart?",
  smartApp:"App sola (-10%)", smartSensors:"App + sensores (-20%)", smartNo:"No",
  smartExplain:"El uso de sensores de humedad a diferentes profundidades permite adaptar el riego a las necesidades reales del suelo y evitar riegos innecesarios.",
  smartAdicionalLabel:"Ahorro adicional estimado mediante optimización del riego: {pct}%*",
  smartDisclaimer:"*Estimación orientativa. El ahorro real depende del cultivo, suelo, clima, sistema de riego y gestión previa de la explotación.",
  consumoActual:"CONSUMO ACTUAL",
  ahorroAquasolSmart:"AHORRO CON AQUASOL",
  ahorroAdicionalSmart:"AHORRO ADICIONAL CON AQUASOL SMART",
  consumoFinalEstimado:"CONSUMO FINAL ESTIMADO",
  ahorroTotalAgua:"AHORRO TOTAL DE AGUA",
  finAquasolLabel:"Ahorro económico gracias a AQUASOL:",
  finSmartLabel:"Ahorro adicional gracias a AQUASOL Smart:",
  finTotalLabel:"AHORRO ECONÓMICO TOTAL",
  compSin:"SIN AQUASOL", compCon:"CON AQUASOL", compSmart:"CON AQUASOL + SMART",
  smartHowTitle:"¿Cómo consigue AQUASOL Smart ahorrar todavía más agua?",
  smartHowText:"Los sensores instalados en el suelo permiten conocer la evolución de la humedad a diferentes profundidades. AQUASOL Smart utiliza estos datos para ayudar a adaptar el riego a las necesidades reales del cultivo, evitando riegos innecesarios y aprovechando durante más tiempo el agua retenida en la zona radicular.",
  smartBenefit1:"Control de humedad del suelo",
  smartBenefit2:"Optimización del momento de riego",
  smartBenefit3:"Reducción de riegos innecesarios",
  bDefT:"Mejor crecimiento y calidad del cultivo",
  bDefD:"Además del ahorro de agua, puede favorecer una planta más vigorosa y cosechas de mayor calidad.",
  bRefT:"Menor mortalidad potencial", bRefD:"Ayuda a mejorar la supervivencia de plantas en zonas secas o post-incendio.",
  bVivT:"Plantas más uniformes y vigorosas", bVivD:"Favorece una humedad más estable en el sustrato.",
  bHortT:"Cultivo más uniforme y productivo", bHortD:"Ayuda a reducir el estrés hídrico y favorecer un desarrollo equilibrado.",
  bVinT:"Mejor establecimiento de la vid", bVinD:"Favorece el desarrollo radicular y reduce el estrés hídrico.",
  refCap:"CAPACIDAD DE RETENCIÓN", refBenef:"BENEFICIO PRINCIPAL",
  refEstres:"REDUCCIÓN POTENCIAL DE ESTRÉS HÍDRICO",
  refSuper:"MEJORA POTENCIAL DE SUPERVIVENCIA", refPlant:"PLANTAS QUE PODRÍAN BENEFICIARSE",
  indexBad:"Importantes pérdidas de agua", indexC:"Potencial de mejora", indexB:"Buen potencial de ahorro", indexA:"Muy buena retención de agua", indexAplus:"Excelente eficiencia hídrica",
  indexExplain:"El AQUASOL INDEX™ evalúa el potencial de ahorro de agua de la explotación según el cultivo, el suelo, el clima y el sistema de riego. Una nota más alta indica mejor retención de agua, menor estrés hídrico y mayor eficiencia de riego.",

  
  
  ahorroM2:'AHORRO POR m²',
  ahorroTotal:'AHORRO TOTAL',
  ahorroM3:'AHORRO POR m³ SUSTRATO',
  ahorroTotalHort:'AHORRO TOTAL',
  ahorroPlantaHort:'AHORRO POR PLANTA',
  
  reforestacionAviso:'Para reforestación, AQUASOL reduce la mortalidad de plantas y el número de riegos de arranque, no el consumo total de agua.',
  
  histTitle:'CÁLCULOS RECIENTES',
  histClear:'Borrar historial',
  quoteBtn:'Solicitar presupuesto con estos datos',
  autoRiegoBtn:'No sé mi consumo — estimar',
  autoRiegoTip:'Estimación automática según cultivo',
  
  year:'Año',
  roiMin:'ROI mínimo',
  roiMax:'ROI máximo',
  
  arbolJoven:'Árbol joven (+120 cm)',
  
  precio0agro:'Sin precio de agua introducido: mostramos los beneficios agronómicos del producto.',
  bAgro1T:'Reducción del estrés hídrico',
  bAgro1D:'Puede reducir el estrés hídrico hasta un {stress}.',
  bAgro2T:'Menor tasa de mortalidad de plantas',
  bAgro2D:'Hasta {mort} menos mortalidad en plantaciones jóvenes.',
  bAgro3T:'Mejor desarrollo radicular',
  bAgro3D:'Sistema radicular hasta {rac} más profundo y ramificado.',
  bAgro4T:'Producción de mayor calidad',
  bAgro4D:'Mejora del calibre del fruto hasta un {qual}.',
  bAgro5T:'Mayor uniformidad del cultivo',
  bAgro5D:'Hasta {uni}% menos variabilidad entre plantas.',
  bAgro6T:'Optimización del agua disponible',
  bAgro6D:'Retiene hasta 400× su peso en agua. Reduce pérdidas por evaporación un {evap}.',
  uAgua:"m³/año", uHa:"ha", uPlanta:"planta", perYear:"año",
  olivos:'Olivos',citricos:'Cítricos',vinedos:'Viñedos',horticultura:'Horticultura',
  viveros:'Viveros',almendros:'Almendros y otros',palmeras:'Palmeras',cerezos:'Cerezos',reforestacion:'Reforestación',
  manzano:'Manzanos',peral:'Perales',melocotonero:'Melocotoneros y otros'
};

TXT.fr = {
  back:"Retour",
  title:"CALCULE <span>TES ÉCONOMIES</span>",
  subtitle:"Calcule en moins de 30 secondes la dose, le format recommandé et le potentiel d'économie de ton exploitation.",
  cultivo:"Culture", producto:"Produit", aplicacion:"Type d'application",
  manualApp:"Application manuelle", mecanizada:"Application mécanisée",
  suelo:"Type de sol", franco:"Franc / équilibré", arenoso:"Sableux", pedregoso:"Caillouteux", arcilloso:"Argileux",
  salino:'Salin / alcalin',
  ecLabel:'Conductivité électrique (CE) du sol', ec0:'CE 0-2 (non salin)', ec2:'CE 2-4 (légèrement salin)', ec4:'CE 4-8 (modérément salin)', ec8:'CE 8-16 (fortement salin)',
  salinAviso:'⚠️ Sol salin : AQUASOL SAL est appliqué, avec une dose ajustée par un facteur ×{factor} selon la conductivité électrique (CE) du sol.',
  salinAdultoSat205:'⚠️ Avec une CE de 8-16, l\'utilisation d\'AQUASOL SAL est particulièrement recommandée pour les arbres adultes, l\'hydrogel standard perdant davantage en efficacité dans ces conditions de forte salinité.',
  selectEC:'Sélectionne le niveau de conductivité électrique (CE) du sol. ',
  bonusAviso:'⚙️ Dose ajustée selon les conditions de votre sol et climat.',
  clima:"Climat", medio:"Méditerranéen moyen", seco:"Sec", muyseco:"Très sec / sécheresse",
  edad:"Type de plante", joven:"Jeune plante / petite", desarrollo:"Plante en développement / moyenne", adulto:"Arbre adulte / grand",
  sistema:"Système d'irrigation", goteo:"Goutte-à-goutte", manual:"Manuel", aspersion:"Aspersion", sinriego:"Sans irrigation fixe",
  hectareas:"Hectares", m2:"Surface m²", sustrato:"Substrat m³", plantas:"Nombre de plantes",
  riego:"Irrigation actuelle m³/ha/an", precio:"Prix de l'eau "+CN+"/m³",
  calcular:"CALCULER L'ÉCONOMIE",
  impactBase:"Le produit aide à améliorer l'efficacité hydrique selon les conditions sélectionnées.",
  visualSin:"Consommation estimée sans AQUASOL", visualCon:"Consommation estimée avec AQUASOL",
  agua:"EAU ÉCONOMISÉE", dinero:"ÉCONOMIE FINANCIÈRE", eficiencia:"EFFICACITÉ HYDRIQUE",
  hectarea:"ÉCONOMIE PAR HECTARE", planta:"ÉCONOMIE PAR PLANTE",
  dosis:"DOSE INDICATIVE", dosisMec:"DOSE MÉCANISÉE",
  productoNecesario:"PRODUIT NÉCESSAIRE", formato:"FORMAT RECOMMANDÉ",
  coste:"COÛT PRODUIT", beneficio:"BÉNÉFICE AGRONOMIQUE",
  roi:"RETOUR POTENTIEL", roiSmall:"Ajusté selon la dégradation progressive estimée",
  leadTitle:"REÇOIS TES RÉSULTATS ET UN DEVIS PERSONNALISÉ",
  leadText:"Laisse tes coordonnées pour recevoir une proposition adaptée à ton exploitation.",
  empresa:"Entreprise", nombre:"Nom et prénom", telefono:"Téléphone",
  presupuesto:"DEMANDER UN DEVIS", imprimir:"IMPRIMER / PDF",
  note:"*Résultats indicatifs. HYDRO et ECO retiennent jusqu'à 400 fois leur poids en eau.",
  noAplica:"Non applicable", menorMortalidad:"Mortalité réduite", plantasTxt:"plantes",
  saco1:"1 sac de 1 kg", saco2:"1 sac de 2 kg", saco5:"1 sac de 5 kg", sacos25:"sac(s) de 25 kg",
  alertDatos:"Merci de compléter tes coordonnées.", alertTodos:"Merci de compléter toutes les données.",
  solicitud:"Demande AQUASOL AGRO",
  hastaReducir:"Selon ta sélection, AQUASOL peut aider à réduire la consommation d'eau jusqu'à environ ",
  selectCultivo:"Sélectionne une culture.", selectProducto:"Sélectionne un produit.",
  selectAplicacion:"Sélectionne un type d'application.", selectSuelo:"Sélectionne le type de sol.",
  selectClima:"Sélectionne le climat.", selectSistema:"Sélectionne le système d'irrigation.",
  selectEdad:"Sélectionne le type de plante.",
  sinRiegoAviso:"Sans irrigation fixe : pas de calcul d'économie d'eau. ",
  precio0:"Prix 0 : économie financière affichée à 0. ",
  introSustrato:"Indique le volume de substrat en m³. ",
  introPlantasHort:"Indique le nombre de plantes. ",
  introM2:"Indique la surface en m². ",
  introPlantasManual:"Indique le nombre de plantes. ",
  introHaMec:"Indique les hectares. ",
  validaTecnica:"Validation technique recommandée pour cette combinaison. ",
  introAgua:"Indique les hectares et l'irrigation actuelle pour calculer l'économie d'eau. ",
  introTronco:"Indique le diamètre du tronc en cm. ",
  tronco:"Diamètre du tronc (cm)",
  smartQuestion:"Utiliseras-tu AQUASOL AGRO Smart\u00a0?",
  smartApp:"App seule (-10%)", smartSensors:"App + capteurs (-20%)", smartNo:"Non",
  smartExplain:"L'utilisation de capteurs d'humidité à différentes profondeurs permet d'adapter l'irrigation aux besoins réels du sol et d'éviter les arrosages inutiles.",
  smartAdicionalLabel:"Économie supplémentaire estimée grâce à l'optimisation de l'irrigation\u00a0: {pct}%*",
  smartDisclaimer:"*Estimation indicative. L'économie réelle dépend de la culture, du sol, du climat, du système d'irrigation et de la gestion antérieure de l'exploitation.",
  consumoActual:"CONSOMMATION ACTUELLE",
  ahorroAquasolSmart:"ÉCONOMIE AVEC AQUASOL",
  ahorroAdicionalSmart:"ÉCONOMIE SUPPLÉMENTAIRE AVEC AQUASOL SMART",
  consumoFinalEstimado:"CONSOMMATION FINALE ESTIMÉE",
  ahorroTotalAgua:"ÉCONOMIE TOTALE D'EAU",
  finAquasolLabel:"Économie grâce à AQUASOL\u00a0:",
  finSmartLabel:"Économie supplémentaire grâce à AQUASOL Smart\u00a0:",
  finTotalLabel:"ÉCONOMIE FINANCIÈRE TOTALE",
  compSin:"SANS AQUASOL", compCon:"AVEC AQUASOL", compSmart:"AVEC AQUASOL + SMART",
  smartHowTitle:"Comment AQUASOL Smart permet-il d'économiser encore plus d'eau\u00a0?",
  smartHowText:"Les capteurs installés dans le sol permettent de connaître l'évolution de l'humidité à différentes profondeurs. AQUASOL Smart utilise ces données pour aider à adapter l'irrigation aux besoins réels de la culture, en évitant les arrosages inutiles et en profitant plus longtemps de l'eau retenue dans la zone racinaire.",
  smartBenefit1:"Contrôle de l'humidité du sol",
  smartBenefit2:"Optimisation du moment d'irrigation",
  smartBenefit3:"Réduction des arrosages inutiles",
  bDefT:"Meilleure croissance et qualité de culture",
  bDefD:"En plus de l'économie d'eau, peut favoriser une plante plus vigoureuse et des récoltes de meilleure qualité.",
  bRefT:"Mortalité potentiellement réduite", bRefD:"Aide à améliorer la survie des plants dans les zones sèches ou post-incendie.",
  bVivT:"Plantes plus uniformes et vigoureuses", bVivD:"Favorise une humidité plus stable dans le substrat.",
  bHortT:"Culture plus uniforme et productive", bHortD:"Aide à réduire le stress hydrique et favoriser un développement équilibré.",
  bVinT:"Meilleure implantation de la vigne", bVinD:"Favorise le développement racinaire et réduit le stress hydrique.",
  refCap:"CAPACITÉ DE RÉTENTION", refBenef:"BÉNÉFICE PRINCIPAL",
  refEstres:"RÉDUCTION POTENTIELLE DU STRESS HYDRIQUE",
  refSuper:"AMÉLIORATION POTENTIELLE DE LA SURVIE", refPlant:"PLANTES POUVANT EN BÉNÉFICIER",
  indexBad:"Importantes pertes d’eau", indexC:"Potentiel d’amélioration", indexB:"Bon potentiel d’économie", indexA:"Très bonne rétention d’eau", indexAplus:"Excellente efficacité hydrique",
  indexExplain:"L’AQUASOL INDEX™ évalue le potentiel d’économie d’eau de l’exploitation selon la culture, le sol, le climat et le système d’irrigation. Une note plus élevée indique une meilleure rétention d’eau, moins de stress hydrique et une meilleure efficacité d’irrigation.",

  
  
  ahorroM2:'ÉCONOMIE PAR m²',
  ahorroTotal:'ÉCONOMIE TOTALE',
  ahorroM3:'ÉCONOMIE PAR m³ SUBSTRAT',
  ahorroTotalHort:'ÉCONOMIE TOTALE',
  ahorroPlantaHort:'ÉCONOMIE PAR PLANTE',
  
  reforestacionAviso:"Pour le reboisement, AQUASOL réduit la mortalité des plants et le nombre d'arrosages de démarrage, pas la consommation totale d'eau.",
  
  histTitle:'CALCULS RÉCENTS',
  histClear:'Effacer historique',
  quoteBtn:'Demander un devis avec ces données',
  autoRiegoBtn:'Je ne connais pas ma consommation',
  autoRiegoTip:'Estimation automatique selon la culture',
  
  year:'Année',
  roiMin:'ROI minimum',
  roiMax:'ROI maximum',
  
  arbolJoven:'Jeune arbre (+120 cm)',
  
  precio0agro:"Sans prix de l'eau renseigné\xa0: nous affichons les bénéfices agronomiques du produit.",
  bAgro1T:'Réduction du stress hydrique',
  bAgro1D:"Peut réduire le stress hydrique jusqu'à {stress}.",
  bAgro2T:'Réduction du taux de mortalité des plants',
  bAgro2D:"Jusqu'à {mort} de mortalité en moins sur les jeunes plantations.",
  bAgro3T:'Meilleur développement racinaire',
  bAgro3D:"Système racinaire jusqu'à {rac} plus profond et ramifié.",
  bAgro4T:'Production de meilleure qualité',
  bAgro4D:"Amélioration du calibre des fruits jusqu'à {qual}.",
  bAgro5T:'Meilleure uniformité de la culture',
  bAgro5D:"Jusqu'à {uni}% de variabilité en moins entre plants.",
  bAgro6T:"Optimisation de l'eau disponible",
  bAgro6D:"Retient jusqu'à 400× son poids en eau. Réduit les pertes par évaporation de {evap}.",
  uAgua:"m³/an", uHa:"ha", uPlanta:"plante", perYear:"an",
  olivos:'Oliviers',citricos:'Agrumes',vinedos:'Vignes',horticultura:'Horticulture',
  viveros:'Pépinières',almendros:'Amandiers et autres',palmeras:'Palmiers',cerezos:'Cerisiers',reforestacion:'Reboisement',
  manzano:'Pommiers',peral:'Poiriers',melocotonero:'Pêchers et autres'
};

TXT.en = {
  back:"Back",
  title:"CALCULATE <span>YOUR SAVINGS</span>",
  subtitle:"Calculate in less than 30 seconds the dose, recommended format and potential savings for your farm.",
  cultivo:"Crop", producto:"Product", aplicacion:"Application type",
  manualApp:"Manual application", mecanizada:"Mechanized application",
  suelo:"Soil type", franco:"Loam / balanced", arenoso:"Sandy", pedregoso:"Stony", arcilloso:"Clay",
  salino:'Saline / alkaline',
  ecLabel:'Soil electrical conductivity (EC)', ec0:'EC 0-2 (not saline)', ec2:'EC 2-4 (slightly saline)', ec4:'EC 4-8 (moderately saline)', ec8:'EC 8-16 (strongly saline)',
  salinAviso:'⚠️ Saline soil: AQUASOL SAL is applied, with dose adjusted by a ×{factor} factor based on the soil\'s electrical conductivity (EC).',
  salinAdultoSat205:'⚠️ With EC 8-16, using AQUASOL SAL is especially recommended for adult trees, as the standard hydrogel loses more effectiveness in these high salinity conditions.',
  selectEC:'Select the soil\'s electrical conductivity (EC) level. ',
  bonusAviso:'⚙️ Dose adjusted according to your soil and climate conditions.',
  clima:"Climate", medio:"Medium Mediterranean", seco:"Dry", muyseco:"Very dry / drought",
  edad:"Plant type", joven:"Young / small plant", desarrollo:"Developing / medium plant", adulto:"Adult / large tree",
  sistema:"Irrigation system", goteo:"Drip irrigation", manual:"Manual", aspersion:"Sprinkler", sinriego:"No fixed irrigation",
  hectareas:"Hectares", m2:"Area m²", sustrato:"Substrate m³", plantas:"Number of plants",
  riego:"Current irrigation m³/ha/year", precio:"Water price "+CN+"/m³",
  calcular:"CALCULATE SAVINGS",
  impactBase:"The product helps improve water efficiency according to selected conditions.",
  visualSin:"Estimated consumption without AQUASOL", visualCon:"Estimated consumption with AQUASOL",
  agua:"WATER SAVED", dinero:"ECONOMIC SAVINGS", eficiencia:"WATER EFFICIENCY",
  hectarea:"SAVINGS PER HECTARE", planta:"SAVINGS PER PLANT",
  dosis:"INDICATIVE DOSE", dosisMec:"MECHANIZED DOSE",
  productoNecesario:"PRODUCT NEEDED", formato:"RECOMMENDED FORMAT",
  coste:"PRODUCT COST", beneficio:"AGRONOMIC BENEFIT",
  roi:"POTENTIAL RETURN", roiSmall:"Adjusted for estimated progressive degradation",
  leadTitle:"GET YOUR RESULTS AND A PERSONALIZED QUOTE",
  leadText:"Leave your details to receive a proposal adapted to your farm.",
  empresa:"Company", nombre:"Full name", telefono:"Phone",
  presupuesto:"REQUEST A QUOTE", imprimir:"PRINT / PDF",
  note:"*Indicative results. HYDRO and ECO retain up to 400 times their weight in water.",
  noAplica:"Not applicable", menorMortalidad:"Lower mortality", plantasTxt:"plants",
  saco1:"1 bag of 1 kg", saco2:"1 bag of 2 kg", saco5:"1 bag of 5 kg", sacos25:"bag(s) of 25 kg",
  alertDatos:"Please complete your details.", alertTodos:"Please complete all details.",
  solicitud:"AQUASOL AGRO request",
  hastaReducir:"Based on your selection, AQUASOL may help reduce irrigation water consumption by approximately ",
  selectCultivo:"Select a crop.", selectProducto:"Select a product.",
  selectAplicacion:"Select an application type.", selectSuelo:"Select the soil type.",
  selectClima:"Select the climate.", selectSistema:"Select the irrigation system.",
  selectEdad:"Select the plant type.",
  sinRiegoAviso:"No fixed irrigation: water savings not calculated. ",
  precio0:"Water price 0: economic savings shown as 0. ",
  introSustrato:"Enter substrate volume in m³. ",
  introPlantasHort:"Enter the number of plants. ",
  introM2:"Enter area in m². ",
  introPlantasManual:"Enter the number of plants. ",
  introHaMec:"Enter hectares. ",
  validaTecnica:"Technical validation recommended for this combination. ",
  introAgua:"Enter hectares and current irrigation to calculate water savings. ",
  introTronco:"Enter the trunk diameter in cm. ",
  tronco:"Trunk diameter (cm)",
  smartQuestion:"Will you use AQUASOL AGRO Smart?",
  smartApp:"App only (-10%)", smartSensors:"App + sensors (-20%)", smartNo:"No",
  smartExplain:"Using humidity sensors at different depths allows irrigation to be adapted to the soil's real needs and avoid unnecessary watering.",
  smartAdicionalLabel:"Estimated additional saving from irrigation optimization: {pct}%*",
  smartDisclaimer:"*Indicative estimate. The actual saving depends on the crop, soil, climate, irrigation system and previous management of the farm.",
  consumoActual:"CURRENT CONSUMPTION",
  ahorroAquasolSmart:"SAVINGS WITH AQUASOL",
  ahorroAdicionalSmart:"ADDITIONAL SAVINGS WITH AQUASOL SMART",
  consumoFinalEstimado:"ESTIMATED FINAL CONSUMPTION",
  ahorroTotalAgua:"TOTAL WATER SAVINGS",
  finAquasolLabel:"Savings thanks to AQUASOL:",
  finSmartLabel:"Additional savings thanks to AQUASOL Smart:",
  finTotalLabel:"TOTAL FINANCIAL SAVINGS",
  compSin:"WITHOUT AQUASOL", compCon:"WITH AQUASOL", compSmart:"WITH AQUASOL + SMART",
  smartHowTitle:"How does AQUASOL Smart save even more water?",
  smartHowText:"Sensors installed in the soil track moisture evolution at different depths. AQUASOL Smart uses this data to help adapt irrigation to the crop's real needs, avoiding unnecessary watering and making better use of the water retained in the root zone.",
  smartBenefit1:"Soil moisture control",
  smartBenefit2:"Irrigation timing optimization",
  smartBenefit3:"Reduction of unnecessary watering",
  bDefT:"Better growth and crop quality",
  bDefD:"In addition to water savings, can promote a more vigorous plant and higher quality harvests.",
  bRefT:"Potentially reduced mortality", bRefD:"Helps improve plant survival in dry or post-fire areas.",
  bVivT:"More uniform and vigorous plants", bVivD:"Promotes more stable moisture in the substrate.",
  bHortT:"More uniform and productive crop", bHortD:"Helps reduce water stress and promote balanced development.",
  bVinT:"Better vine establishment", bVinD:"Promotes root development and reduces water stress.",
  refCap:"RETENTION CAPACITY", refBenef:"MAIN BENEFIT",
  refEstres:"POTENTIAL REDUCTION OF WATER STRESS",
  refSuper:"POTENTIAL IMPROVEMENT OF SURVIVAL", refPlant:"PLANTS THAT COULD BENEFIT",
  indexBad:"Significant water losses", indexC:"Improvement potential", indexB:"Good savings potential", indexA:"Very good water retention", indexAplus:"Excellent water efficiency",
  indexExplain:"The AQUASOL INDEX™ evaluates the farm’s water-saving potential according to the crop, soil, climate and irrigation system. A higher grade indicates better water retention, lower water stress and higher irrigation efficiency.",

  
  
  ahorroM2:'SAVINGS PER m²',
  ahorroTotal:'TOTAL SAVINGS',
  ahorroM3:'SAVINGS PER m³ SUBSTRATE',
  ahorroTotalHort:'TOTAL SAVINGS',
  ahorroPlantaHort:'SAVINGS PER PLANT',
  
  reforestacionAviso:'For reforestation, AQUASOL reduces plant mortality and the number of starter waterings, not the total water consumption.',
  
  histTitle:'RECENT CALCULATIONS',
  histClear:'Clear history',
  quoteBtn:'Request a quote with this data',
  autoRiegoBtn:"I don't know my water use — estimate",
  autoRiegoTip:'Automatic estimate by crop',
  
  year:'Year',
  roiMin:'Min ROI',
  roiMax:'Max ROI',
  
  arbolJoven:'Young tree (+120 cm)',
  
  precio0agro:'No water price entered: showing the agronomic benefits of the product.',
  bAgro1T:'Reduction of water stress',
  bAgro1D:'Can reduce water stress by up to {stress}.',
  bAgro2T:'Lower plant mortality rate',
  bAgro2D:'Up to {mort} less mortality in young plantations.',
  bAgro3T:'Better root development',
  bAgro3D:'Root system up to {rac} deeper and more branched.',
  bAgro4T:'Higher quality production',
  bAgro4D:'Fruit size improvement of up to {qual}.',
  bAgro5T:'Greater crop uniformity',
  bAgro5D:'Up to {uni}% less variability between plants.',
  bAgro6T:'Optimization of available water',
  bAgro6D:'Retains up to 400× its weight in water. Reduces evaporation losses by {evap}.',
  uAgua:"m³/year", uHa:"ha", uPlanta:"plant", perYear:"year",
  olivos:'Olive trees',citricos:'Citrus',vinedos:'Vineyards',horticultura:'Horticulture',
  viveros:'Nurseries',almendros:'Almond trees and others',palmeras:'Palm trees',cerezos:'Cherry trees',reforestacion:'Reforestation',
  manzano:'Apple trees',peral:'Pear trees',melocotonero:'Peach trees and others'
};

TXT.pt = {
  back:"Voltar",
  title:"CALCULA <span>AS TUAS POUPANÇAS</span>",
  subtitle:"Calcula em menos de 30 segundos a dose, o formato recomendado e a poupança potencial da tua exploração.",
  cultivo:"Cultura", producto:"Produto", aplicacion:"Tipo de aplicação",
  manualApp:"Aplicação manual", mecanizada:"Aplicação mecanizada",
  suelo:"Tipo de solo", franco:"Franco / equilibrado", arenoso:"Arenoso", pedregoso:"Pedregoso", arcilloso:"Argiloso",
  salino:'Salino / alcalino',
  ecLabel:'Condutividade elétrica (CE) do solo', ec0:'CE 0-2 (não salino)', ec2:'CE 2-4 (ligeiramente salino)', ec4:'CE 4-8 (moderadamente salino)', ec8:'CE 8-16 (fortemente salino)',
  salinAviso:'⚠️ Solo salino: aplica-se AQUASOL SAL, com dose ajustada por um fator ×{factor} segundo a condutividade elétrica (CE) do solo.',
  salinAdultoSat205:'⚠️ Com CE 8-16, o uso de AQUASOL SAL é especialmente recomendável em árvores adultas, já que o hidrogel padrão perde mais eficácia nestas condições de alta salinidade.',
  selectEC:'Seleciona o nível de condutividade elétrica (CE) do solo. ',
  bonusAviso:'⚙️ Dose ajustada de acordo com as condições do seu solo e clima.',
  clima:"Clima", medio:"Mediterrânico médio", seco:"Seco", muyseco:"Muito seco / seca",
  edad:"Tipo de planta", joven:"Planta jovem / pequena", desarrollo:"Planta em desenvolvimento / média", adulto:"Árvore adulta / grande",
  sistema:"Sistema de rega", goteo:"Gota-a-gota", manual:"Manual", aspersion:"Aspersão", sinriego:"Sem rega fixa",
  hectareas:"Hectares", m2:"Superfície m²", sustrato:"Substrato m³", plantas:"Número de plantas",
  riego:"Rega atual m³/ha/ano", precio:"Preço da água "+CN+"/m³",
  calcular:"CALCULAR POUPANÇA",
  impactBase:"O produto ajuda a melhorar a eficiência hídrica segundo as condições selecionadas.",
  visualSin:"Consumo estimado sem AQUASOL", visualCon:"Consumo estimado com AQUASOL",
  agua:"ÁGUA POUPADA", dinero:"POUPANÇA ECONÓMICA", eficiencia:"EFICIÊNCIA HÍDRICA",
  hectarea:"POUPANÇA POR HECTARE", planta:"POUPANÇA POR PLANTA",
  dosis:"DOSE INDICATIVA", dosisMec:"DOSE MECANIZADA",
  productoNecesario:"PRODUTO NECESSÁRIO", formato:"FORMATO RECOMENDADO",
  coste:"CUSTO DO PRODUTO", beneficio:"BENEFÍCIO AGRONÓMICO",
  roi:"RETORNO POTENCIAL", roiSmall:"Ajustado segundo degradação progressiva estimada",
  leadTitle:"RECEBE OS TEUS RESULTADOS E UM ORÇAMENTO PERSONALIZADO",
  leadText:"Deixa os teus dados para receber uma proposta adaptada à tua exploração.",
  empresa:"Empresa", nombre:"Nome e apelido", telefono:"Telefone",
  presupuesto:"PEDIR ORÇAMENTO", imprimir:"IMPRIMIR / PDF",
  note:"*Resultados indicativos. HYDRO e ECO retêm até 400 vezes o seu peso em água.",
  noAplica:"Não aplicável", menorMortalidad:'Menor mortalidade de plantas',
  saco1:"1 saco de 1 kg", saco2:"1 saco de 2 kg", saco5:"1 saco de 5 kg", sacos25:"saco(s) de 25 kg",
  alertDatos:"Por favor completa os teus dados.", alertTodos:"Por favor completa todos os dados.",
  solicitud:"Pedido AQUASOL AGRO",
  hastaReducir:"Segundo a tua seleção, AQUASOL pode ajudar a reduzir o consumo de água até aproximadamente ",
  selectCultivo:"Seleciona uma cultura.", selectProducto:"Seleciona um produto.",
  selectAplicacion:"Seleciona um tipo de aplicação.", selectSuelo:"Seleciona o tipo de solo.",
  selectClima:"Seleciona o clima.", selectSistema:"Seleciona o sistema de rega.",
  selectEdad:"Seleciona o tipo de planta.",
  sinRiegoAviso:"Sem rega fixa: não se calcula poupança de água. ",
  precio0:"Preço 0: poupança económica mostrada a 0. ",
  introSustrato:"Introduz o volume de substrato em m³. ",
  introPlantasHort:"Introduz o número de plantas. ",
  introM2:"Introduz a superfície em m². ",
  introPlantasManual:"Introduz o número de plantas. ",
  introHaMec:"Introduz os hectares. ",
  validaTecnica:"Recomenda-se validação técnica para esta combinação. ",
  introAgua:"Introduz hectares e rega atual para calcular a poupança de água. ",
  introTronco:"Introduz o diâmetro do tronco em cm. ",
  tronco:"Diâmetro do tronco (cm)",
  smartQuestion:"Vais utilizar o AQUASOL AGRO Smart?",
  smartApp:"Só app (-10%)", smartSensors:"App + sensores (-20%)", smartNo:"Não",
  smartExplain:"O uso de sensores de humidade a diferentes profundidades permite adaptar a rega às necessidades reais do solo e evitar regas desnecessárias.",
  smartAdicionalLabel:"Poupança adicional estimada através da otimização da rega: {pct}%*",
  smartDisclaimer:"*Estimativa indicativa. A poupança real depende da cultura, do solo, do clima, do sistema de rega e da gestão anterior da exploração.",
  consumoActual:"CONSUMO ATUAL",
  ahorroAquasolSmart:"POUPANÇA COM AQUASOL",
  ahorroAdicionalSmart:"POUPANÇA ADICIONAL COM AQUASOL SMART",
  consumoFinalEstimado:"CONSUMO FINAL ESTIMADO",
  ahorroTotalAgua:"POUPANÇA TOTAL DE ÁGUA",
  finAquasolLabel:"Poupança graças ao AQUASOL:",
  finSmartLabel:"Poupança adicional graças ao AQUASOL Smart:",
  finTotalLabel:"POUPANÇA ECONÓMICA TOTAL",
  compSin:"SEM AQUASOL", compCon:"COM AQUASOL", compSmart:"COM AQUASOL + SMART",
  smartHowTitle:"Como consegue o AQUASOL Smart poupar ainda mais água?",
  smartHowText:"Os sensores instalados no solo permitem conhecer a evolução da humidade a diferentes profundidades. O AQUASOL Smart utiliza estes dados para ajudar a adaptar a rega às necessidades reais da cultura, evitando regas desnecessárias e aproveitando durante mais tempo a água retida na zona radicular.",
  smartBenefit1:"Controlo da humidade do solo",
  smartBenefit2:"Otimização do momento de rega",
  smartBenefit3:"Redução de regas desnecessárias",
  bDefT:"Melhor crescimento e qualidade da cultura",
  bDefD:"Para além da poupança de água, pode favorecer uma planta mais vigorosa e colheitas de maior qualidade.",
  bRefT:"Mortalidade potencialmente reduzida", bRefD:"Ajuda a melhorar a sobrevivência das plantas em zonas secas ou após incêndio.",
  bVivT:"Plantas mais uniformes e vigorosas", bVivD:"Favorece uma humidade mais estável no substrato.",
  bHortT:"Cultura mais uniforme e produtiva", bHortD:"Ajuda a reduzir o stress hídrico e favorecer um desenvolvimento equilibrado.",
  bVinT:"Melhor estabelecimento da vinha", bVinD:"Favorece o desenvolvimento radicular e reduz o stress hídrico.",
  refCap:"CAPACIDADE DE RETENÇÃO", refBenef:"BENEFÍCIO PRINCIPAL",
  refEstres:"REDUÇÃO POTENCIAL DO STRESS HÍDRICO",
  refSuper:"MELHORIA POTENCIAL DA SOBREVIVÊNCIA", refPlant:"PLANTAS QUE PODEM BENEFICIAR",
  indexBad:"Perdas importantes de água", indexC:"Potencial de melhoria", indexB:"Bom potencial de poupança", indexA:"Muito boa retenção de água", indexAplus:"Excelente eficiência hídrica",
  indexExplain:"O AQUASOL INDEX™ avalia o potencial de poupança de água da exploração segundo a cultura, o solo, o clima e o sistema de rega. Uma nota mais alta indica melhor retenção de água, menor stress hídrico e maior eficiência de rega.",

  
  
  ahorroM2:'POUPANÇA POR m²',
  ahorroTotal:'POUPANÇA TOTAL',
  ahorroM3:'POUPANÇA POR m³ SUBSTRATO',
  ahorroTotalHort:'POUPANÇA TOTAL',
  ahorroPlantaHort:'POUPANÇA POR PLANTA',
  
  reforestacionAviso:'Para reflorestamento, AQUASOL reduz a mortalidade de plantas e o número de regas de arranque, não o consumo total de água.',
  
  plantasTxt:'plantas',
  
  histTitle:'CÁLCULOS RECENTES',
  histClear:'Limpar histórico',
  quoteBtn:'Solicitar orçamento com estes dados',
  autoRiegoBtn:'Não sei o meu consumo — estimar',
  autoRiegoTip:'Estimativa automática por cultura',
  
  year:'Ano',
  roiMin:'ROI mínimo',
  roiMax:'ROI máximo',
  
  arbolJoven:'Árvore jovem (+120 cm)',
  
  precio0agro:'Sem preço da água introduzido: mostramos os benefícios agronômicos do produto.',
  bAgro1T:'Redução do estresse hídrico',
  bAgro1D:'Pode reduzir o estresse hídrico até {stress}.',
  bAgro2T:'Menor taxa de mortalidade de plantas',
  bAgro2D:'Até {mort} menos mortalidade em plantações jovens.',
  bAgro3T:'Melhor desenvolvimento radicular',
  bAgro3D:'Sistema radicular até {rac} mais profundo e ramificado.',
  bAgro4T:'Produção de maior qualidade',
  bAgro4D:'Melhoria do calibre dos frutos até {qual}.',
  bAgro5T:'Maior uniformidade da cultura',
  bAgro5D:'Até {uni}% menos variabilidade entre plantas.',
  bAgro6T:'Otimização da água disponível',
  bAgro6D:'Retém até 400× o seu peso em água. Reduz perdas por evaporação em {evap}.',
  uAgua:"m³/ano", uHa:"ha", uPlanta:"planta", perYear:"ano",
  olivos:'Oliveiras',citricos:'Cítricos',vinedos:'Vinhas',horticultura:'Horticultura',
  viveros:'Viveiros',almendros:'Amendoeiras e outros',palmeras:'Palmeiras',cerezos:'Cerejeiras',reforestacion:'Reflorestamento',
  manzano:'Macieiras',peral:'Pereiras',melocotonero:'Pessegueiros e outros'
};

TXT.ar = {
  back:"العودة",
  title:"\u0627\u062d\u0633\u0628 <span>\u0648\u0641\u0631\u0643</span>",
  subtitle:"\u0627\u062d\u0633\u0628 \u062e\u0644\u0627\u0644 \u0623\u0642\u0644 \u0645\u0646 30 \u062b\u0627\u0646\u064a\u0629 \u0627\u0644\u062c\u0631\u0639\u0629 \u0648\u0627\u0644\u0645\u0646\u062a\u062c \u0627\u0644\u0645\u0648\u0635\u0649 \u0628\u0647 \u0648\u0627\u0644\u062a\u0648\u0641\u064a\u0631 \u0627\u0644\u0645\u062d\u062a\u0645\u0644 \u0644\u0645\u0632\u0631\u0639\u062a\u0643.",
  cultivo:"\u0627\u0644\u0645\u062d\u0635\u0648\u0644", producto:"\u0627\u0644\u0645\u0646\u062a\u062c", aplicacion:"\u0646\u0648\u0639 \u0627\u0644\u062a\u0637\u0628\u064a\u0642",
  manualApp:"\u062a\u0637\u0628\u064a\u0642 \u064a\u062f\u0648\u064a", mecanizada:"\u062a\u0637\u0628\u064a\u0642 \u0622\u0644\u064a",
  suelo:"\u0646\u0648\u0639 \u0627\u0644\u062a\u0631\u0628\u0629", franco:"\u062a\u0631\u0628\u0629 \u0645\u062a\u0648\u0627\u0632\u0646\u0629", arenoso:"\u0631\u0645\u0644\u064a\u0629", pedregoso:"\u062d\u062c\u0631\u064a\u0629", arcilloso:"\u0637\u064a\u0646\u064a\u0629",
  salino:'ملحي / قلوي',
  ecLabel:'التوصيل الكهربائي (CE) للتربة', ec0:'CE 0-2 (غير ملحية)', ec2:'CE 2-4 (ملحية قليلاً)', ec4:'CE 4-8 (ملحية معتدلة)', ec8:'CE 8-16 (ملحية شديدة)',
  bonusAviso:'⚙️ تم تعديل الجرعة وفقاً لظروف التربة والمناخ.',
  salinAviso:'⚠️ تربة ملحية: يتم تطبيق AQUASOL SAL، مع جرعة معدَّلة بمعامل ×{factor} حسب التوصيل الكهربائي (CE) للتربة.',
  salinAdultoSat205:'⚠️ عند CE 8-16، يُنصح بشدة باستخدام AQUASOL SAL للأشجار البالغة، لأن الهيدروجيل القياسي يفقد فعاليته أكثر في ظروف الملوحة العالية هذه.',
  selectEC:'اختر مستوى التوصيل الكهربائي (CE) للتربة. ',
  clima:"\u0627\u0644\u0645\u0646\u0627\u062e", medio:"\u0645\u062a\u0648\u0633\u0637\u064a \u0645\u0639\u062a\u062f\u0644", seco:"\u062c\u0627\u0641", muyseco:"\u062c\u0627\u0641 \u062c\u062f\u0627 / \u062c\u0641\u0627\u0641",
  edad:"\u0646\u0648\u0639 \u0627\u0644\u0646\u0628\u0627\u062a", joven:"\u0646\u0628\u0627\u062a \u0635\u063a\u064a\u0631", desarrollo:"\u0646\u0628\u0627\u062a \u0641\u064a \u0645\u0631\u062d\u0644\u0629 \u0627\u0644\u0646\u0645\u0648", adulto:"\u0634\u062c\u0631\u0629 \u0628\u0627\u0644\u063a\u0629 / \u0643\u0628\u064a\u0631\u0629",
  sistema:"\u0646\u0638\u0627\u0645 \u0627\u0644\u0631\u064a", goteo:"\u062a\u0646\u0642\u064a\u0637", manual:"\u064a\u062f\u0648\u064a", aspersion:"\u0631\u0634", sinriego:"\u0628\u062f\u0648\u0646 \u0631\u064a \u062b\u0627\u0628\u062a",
  hectareas:"\u0647\u0643\u062a\u0627\u0631\u0627\u062a", m2:"\u0627\u0644\u0645\u0633\u0627\u062d\u0629 \u0645\u00b2", sustrato:"\u0627\u0644\u0631\u0643\u064a\u0632\u0629 \u0645\u00b3", plantas:"\u0639\u062f\u062f \u0627\u0644\u0646\u0628\u0627\u062a\u0627\u062a",
  riego:"\u0627\u0644\u0631\u064a \u0627\u0644\u062d\u0627\u0644\u064a \u0645\u00b3/\u0647\u0643/\u0633\u0646\u0629", precio:"\u0633\u0639\u0631 \u0627\u0644\u0645\u0627\u0621 "+CN+"/\u0645\u00b3",
  calcular:"\u0627\u062d\u0633\u0628 \u0627\u0644\u0648\u0641\u0631",
  impactBase:"\u064a\u0633\u0627\u0639\u062f \u0627\u0644\u0645\u0646\u062a\u062c \u0639\u0644\u0649 \u062a\u062d\u0633\u064a\u0646 \u0643\u0641\u0627\u0621\u0629 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0645\u064a\u0627\u0647 \u062d\u0633\u0628 \u0627\u0644\u0638\u0631\u0648\u0641 \u0627\u0644\u0645\u062e\u062a\u0627\u0631\u0629.",
  visualSin:"\u0627\u0644\u0627\u0633\u062a\u0647\u0644\u0627\u0643 \u0627\u0644\u0645\u0642\u062f\u0631 \u0628\u062f\u0648\u0646 AQUASOL", visualCon:"\u0627\u0644\u0627\u0633\u062a\u0647\u0644\u0627\u0643 \u0627\u0644\u0645\u0642\u062f\u0631 \u0645\u0639 AQUASOL",
  agua:"\u0627\u0644\u0645\u064a\u0627\u0647 \u0627\u0644\u0645\u0648\u0641\u0631\u0629", dinero:"\u0627\u0644\u062a\u0648\u0641\u064a\u0631 \u0627\u0644\u0627\u0642\u062a\u0635\u0627\u062f\u064a", eficiencia:"\u0643\u0641\u0627\u0621\u0629 \u0627\u0644\u0645\u064a\u0627\u0647",
  hectarea:"\u0627\u0644\u062a\u0648\u0641\u064a\u0631 \u0644\u0643\u0644 \u0647\u0643\u062a\u0627\u0631", planta:"\u0627\u0644\u062a\u0648\u0641\u064a\u0631 \u0644\u0643\u0644 \u0646\u0628\u0627\u062a",
  dosis:"\u062c\u0631\u0639\u0629 \u0625\u0631\u0634\u0627\u062f\u064a\u0629", dosisMec:"\u062c\u0631\u0639\u0629 \u0622\u0644\u064a\u0629",
  productoNecesario:"\u0627\u0644\u0645\u0646\u062a\u062c \u0627\u0644\u0645\u0637\u0644\u0648\u0628", formato:"\u0627\u0644\u0634\u0643\u0644 \u0627\u0644\u0645\u0648\u0635\u0649 \u0628\u0647",
  coste:"\u062a\u0643\u0644\u0641\u0629 \u0627\u0644\u0645\u0646\u062a\u062c", beneficio:"\u0641\u0627\u0626\u062f\u0629 \u0632\u0631\u0627\u0639\u064a\u0629",
  roi:"\u0627\u0644\u0639\u0627\u0626\u062f \u0627\u0644\u0645\u062d\u062a\u0645\u0644", roiSmall:"\u0645\u0639\u062f\u0644 \u062d\u0633\u0628 \u0627\u0644\u062a\u062f\u0647\u0648\u0631 \u0627\u0644\u062a\u062f\u0631\u064a\u062c\u064a \u0627\u0644\u0645\u0642\u062f\u0631",
  leadTitle:"\u0627\u062d\u0635\u0644 \u0639\u0644\u0649 \u0646\u062a\u0627\u0626\u062c\u0643 \u0648\u0639\u0631\u0636 \u0633\u0639\u0631 \u0645\u062e\u0635\u0635",
  leadText:"\u0627\u062a\u0631\u0643 \u0628\u064a\u0627\u0646\u0627\u062a\u0643 \u0644\u0644\u062d\u0635\u0648\u0644 \u0639\u0644\u0649 \u0639\u0631\u0636 \u0645\u0646\u0627\u0633\u0628 \u0644\u0645\u0632\u0631\u0639\u062a\u0643.",
  empresa:"\u0627\u0644\u0634\u0631\u0643\u0629", nombre:"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0643\u0627\u0645\u0644", telefono:"\u0627\u0644\u0647\u0627\u062a\u0641",
  presupuesto:"\u0637\u0644\u0628 \u0639\u0631\u0636 \u0623\u0633\u0639\u0627\u0631", imprimir:"\u0637\u0628\u0627\u0639\u0629 / PDF",
  note:"*\u064a\u062d\u062a\u0641\u0638 HYDRO \u0648ECO \u0628\u0645\u0627 \u064a\u0635\u0644 \u0625\u0644\u0649 400 \u0636\u0639\u0641 \u0648\u0632\u0646\u0647\u0645\u0627 \u0645\u0646 \u0627\u0644\u0645\u0627\u0621.",
  noAplica:"\u0644\u0627 \u064a\u0646\u0637\u0628\u0642", menorMortalidad:"\u0627\u0646\u062e\u0641\u0627\u0636 \u0627\u0644\u0646\u0641\u0648\u0642", plantasTxt:"\u0646\u0628\u0627\u062a\u0627\u062a",
  saco1:"\u0643\u064a\u0633 1 \u0643\u063a", saco2:"\u0643\u064a\u0633 2 \u0643\u063a", saco5:"\u0643\u064a\u0633 5 \u0643\u063a", sacos25:"\u0643\u064a\u0633/\u0623\u0643\u064a\u0627\u0633 25 \u0643\u063a",
  alertDatos:"\u064a\u0631\u062c\u0649 \u0625\u062f\u062e\u0627\u0644 \u0628\u064a\u0627\u0646\u0627\u062a\u0643.", alertTodos:"\u064a\u0631\u062c\u0649 \u0625\u062f\u062e\u0627\u0644 \u062c\u0645\u064a\u0639 \u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a.",
  solicitud:"\u0637\u0644\u0628 AQUASOL AGRO",
  hastaReducir:"\u062d\u0633\u0628 \u0627\u062e\u062a\u064a\u0627\u0631\u0643 \u064a\u0645\u0643\u0646 \u0623\u0646 \u064a\u0633\u0627\u0639\u062f AQUASOL \u0641\u064a \u062a\u0642\u0644\u064a\u0644 \u0627\u0633\u062a\u0647\u0644\u0627\u0643 \u0645\u064a\u0627\u0647 \u0627\u0644\u0631\u064a \u062d\u062a\u0649 \u062d\u0648\u0627\u0644\u064a ",
  selectCultivo:"\u0627\u062e\u062a\u0631 \u0627\u0644\u0645\u062d\u0635\u0648\u0644.", selectProducto:"\u0627\u062e\u062a\u0631 \u0627\u0644\u0645\u0646\u062a\u062c.",
  selectAplicacion:"\u0627\u062e\u062a\u0631 \u0646\u0648\u0639 \u0627\u0644\u062a\u0637\u0628\u064a\u0642.", selectSuelo:"\u0627\u062e\u062a\u0631 \u0646\u0648\u0639 \u0627\u0644\u062a\u0631\u0628\u0629.",
  selectClima:"\u0627\u062e\u062a\u0631 \u0627\u0644\u0645\u0646\u0627\u062e.", selectSistema:"\u0627\u062e\u062a\u0631 \u0646\u0638\u0627\u0645 \u0627\u0644\u0631\u064a.",
  selectEdad:"\u0627\u062e\u062a\u0631 \u0646\u0648\u0639 \u0627\u0644\u0646\u0628\u0627\u062a.",
  sinRiegoAviso:"\u0628\u062f\u0648\u0646 \u0631\u064a \u062b\u0627\u0628\u062a: \u0644\u0627 \u064a\u062d\u0633\u0628 \u062a\u0648\u0641\u064a\u0631 \u0627\u0644\u0645\u064a\u0627\u0647. ",
  precio0:"\u0627\u0644\u0633\u0639\u0631 0: \u0627\u0644\u062a\u0648\u0641\u064a\u0631 \u0627\u0644\u0627\u0642\u062a\u0635\u0627\u062f\u064a \u064a\u0638\u0647\u0631 \u0639\u0646\u062f 0. ",
  introSustrato:"\u0627\u062f\u062e\u0644 \u062d\u062c\u0645 \u0627\u0644\u0631\u0643\u064a\u0632\u0629 \u0628\u0627\u0644\u0645\u00b3. ",
  introPlantasHort:"\u0627\u062f\u062e\u0644 \u0639\u062f\u062f \u0627\u0644\u0646\u0628\u0627\u062a\u0627\u062a. ",
  introM2:"\u0627\u062f\u062e\u0644 \u0627\u0644\u0645\u0633\u0627\u062d\u0629 \u0628\u0627\u0644\u0645\u00b2. ",
  introPlantasManual:"\u0627\u062f\u062e\u0644 \u0639\u062f\u062f \u0627\u0644\u0646\u0628\u0627\u062a\u0627\u062a. ",
  introHaMec:"\u0627\u062f\u062e\u0644 \u0627\u0644\u0647\u0643\u062a\u0627\u0631\u0627\u062a. ",
  validaTecnica:"\u064a\u0648\u0635\u0649 \u0628\u0627\u0644\u062a\u062d\u0642\u0642 \u0627\u0644\u062a\u0642\u0646\u064a \u0644\u0647\u0630\u0627 \u0627\u0644\u062a\u0631\u0643\u064a\u0628. ",
  introAgua:"\u0627\u062f\u062e\u0644 \u0627\u0644\u0647\u0643\u062a\u0627\u0631\u0627\u062a \u0648\u0627\u0644\u0631\u064a \u0627\u0644\u062d\u0627\u0644\u064a \u0644\u062d\u0633\u0627\u0628 \u062a\u0648\u0641\u064a\u0631 \u0627\u0644\u0645\u064a\u0627\u0647. ",
  introTronco:"أدخل قطر الجذع بالسنتيمتر. ",
  tronco:"قطر الجذع (سم)",
  smartQuestion:"هل ستستخدم AQUASOL AGRO Smart؟",
  smartApp:"التطبيق فقط (-10%)", smartSensors:"التطبيق + المستشعرات (-20%)", smartNo:"لا",
  smartExplain:"يتيح استخدام مستشعرات الرطوبة على أعماق مختلفة تكييف الري مع الاحتياجات الفعلية للتربة وتجنب الري غير الضروري.",
  smartAdicionalLabel:"التوفير الإضافي المقدر بفضل تحسين الري: {pct}%*",
  smartDisclaimer:"*تقدير إرشادي. يعتمد التوفير الفعلي على المحصول والتربة والمناخ ونظام الري والإدارة السابقة للمزرعة.",
  consumoActual:"الاستهلاك الحالي",
  ahorroAquasolSmart:"التوفير مع AQUASOL",
  ahorroAdicionalSmart:"التوفير الإضافي مع AQUASOL SMART",
  consumoFinalEstimado:"الاستهلاك النهائي المقدر",
  ahorroTotalAgua:"إجمالي توفير المياه",
  finAquasolLabel:"التوفير بفضل AQUASOL:",
  finSmartLabel:"التوفير الإضافي بفضل AQUASOL Smart:",
  finTotalLabel:"إجمالي التوفير المالي",
  compSin:"بدون AQUASOL", compCon:"مع AQUASOL", compSmart:"مع AQUASOL + SMART",
  smartHowTitle:"كيف يوفر AQUASOL Smart مزيدًا من المياه؟",
  smartHowText:"تتيح المستشعرات المثبتة في التربة معرفة تطور الرطوبة على أعماق مختلفة. يستخدم AQUASOL Smart هذه البيانات للمساعدة في تكييف الري مع الاحتياجات الفعلية للمحصول، وتجنب الري غير الضروري والاستفادة لفترة أطول من المياه المحتجزة في منطقة الجذور.",
  smartBenefit1:"التحكم في رطوبة التربة",
  smartBenefit2:"تحسين توقيت الري",
  smartBenefit3:"تقليل الري غير الضروري",
  bDefT:"\u0646\u0645\u0648 \u0623\u0641\u0636\u0644 \u0648\u062c\u0648\u062f\u0629 \u0623\u0639\u0644\u0649 \u0644\u0644\u0645\u062d\u0635\u0648\u0644",
  bDefD:"\u0628\u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u062a\u0648\u0641\u064a\u0631 \u0627\u0644\u0645\u064a\u0627\u0647 \u064a\u0645\u0643\u0646 \u0623\u0646 \u064a\u0633\u0627\u0639\u062f \u0639\u0644\u0649 \u0646\u0628\u0627\u062a \u0623\u0642\u0648\u0649 \u0648\u0645\u062d\u0627\u0635\u064a\u0644 \u0623\u0639\u0644\u0649 \u062c\u0648\u062f\u0629.",
  bRefT:"\u0627\u0646\u062e\u0641\u0627\u0636 \u0645\u062d\u062a\u0645\u0644 \u0641\u064a \u0627\u0644\u0646\u0641\u0648\u0642",
  bRefD:"\u064a\u0633\u0627\u0639\u062f \u0639\u0644\u0649 \u062a\u062d\u0633\u064a\u0646 \u0628\u0642\u0627\u0621 \u0627\u0644\u0646\u0628\u0627\u062a\u0627\u062a \u0641\u064a \u0627\u0644\u0645\u0646\u0627\u0637\u0642 \u0627\u0644\u062c\u0627\u0641\u0629 \u0623\u0648 \u0628\u0639\u062f \u0627\u0644\u062d\u0631\u0627\u0626\u0642.",
  bVivT:"\u0646\u0628\u0627\u062a\u0627\u062a \u0623\u0643\u062b\u0631 \u062a\u062c\u0627\u0646\u0633\u0627 \u0648\u0642\u0648\u0629",
  bVivD:"\u064a\u0633\u0627\u0639\u062f \u0639\u0644\u0649 \u0627\u0633\u062a\u0642\u0631\u0627\u0631 \u0627\u0644\u0631\u0637\u0648\u0628\u0629 \u0641\u064a \u0627\u0644\u0631\u0643\u064a\u0632\u0629.",
  bHortT:"\u0645\u062d\u0635\u0648\u0644 \u0623\u0643\u062b\u0631 \u062a\u062c\u0627\u0646\u0633\u0627 \u0648\u0625\u0646\u062a\u0627\u062c\u064a\u0629",
  bHortD:"\u064a\u0633\u0627\u0639\u062f \u0639\u0644\u0649 \u062a\u0642\u0644\u064a\u0644 \u0627\u0644\u0625\u062c\u0647\u0627\u062f \u0627\u0644\u0645\u0627\u0626\u064a \u0648\u062a\u0639\u0632\u064a\u0632 \u0646\u0645\u0648 \u0645\u062a\u0648\u0627\u0632\u0646.",
  bVinT:"\u062a\u0623\u0633\u064a\u0633 \u0623\u0641\u0636\u0644 \u0644\u0644\u0643\u0631\u0645\u0629",
  bVinD:"\u064a\u0639\u0632\u0632 \u0646\u0645\u0648 \u0627\u0644\u062c\u0630\u0648\u0631 \u0648\u064a\u0633\u0627\u0639\u062f \u0639\u0644\u0649 \u062a\u0642\u0644\u064a\u0644 \u0627\u0644\u0625\u062c\u0647\u0627\u062f \u0627\u0644\u0645\u0627\u0626\u064a.",
  refCap:"\u0642\u062f\u0631\u0629 \u0627\u0644\u0627\u062d\u062a\u0641\u0627\u0638 \u0628\u0627\u0644\u0645\u0627\u0621", refBenef:"\u0627\u0644\u0641\u0627\u0626\u062f\u0629 \u0627\u0644\u0631\u0626\u064a\u0633\u064a\u0629",
  refEstres:"\u062a\u0642\u0644\u064a\u0644 \u0645\u062d\u062a\u0645\u0644 \u0644\u0644\u0625\u062c\u0647\u0627\u062f \u0627\u0644\u0645\u0627\u0626\u064a",
  refSuper:"\u062a\u062d\u0633\u0646 \u0645\u062d\u062a\u0645\u0644 \u0641\u064a \u0627\u0644\u0628\u0642\u0627\u0621", refPlant:"\u0646\u0628\u0627\u062a\u0627\u062a \u064a\u0645\u0643\u0646 \u0623\u0646 \u062a\u0633\u062a\u0641\u064a\u062f",
  indexBad:"فقدان مهم للمياه", indexC:"إمكانات للتحسين", indexB:"إمكانات جيدة للتوفير", indexA:"احتفاظ جيد جدًا بالمياه", indexAplus:"كفاءة مائية ممتازة",
  indexExplain:"يقيم AQUASOL INDEX™ إمكانات توفير المياه في الاستغلال الزراعي حسب المحصول والتربة والمناخ ونظام الري. تشير الدرجة الأعلى إلى احتفاظ أفضل بالمياه، وإجهاد مائي أقل، وكفاءة ري أعلى.",

  
  
  ahorroM2:'الوفر لكل م²',
  ahorroTotal:'الوفر الإجمالي',
  ahorroM3:'الوفر لكل م³ ركيزة',
  ahorroTotalHort:'الوفر الإجمالي',
  ahorroPlantaHort:'الوفر لكل نبتة',
  
  reforestacionAviso:'لإعادة التشجير، يقلل أكوا سول من وفيات النباتات وعدد عمليات الري الأولى، وليس إجمالي استهلاك المياه.',
  
  histTitle:'الحسابات الأخيرة',
  histClear:'مسح السجل',
  quoteBtn:'طلب عرض سعر بهذه البيانات',
  autoRiegoBtn:'لا أعرف استهلاكي — تقدير تلقائي',
  autoRiegoTip:'تقدير تلقائي حسب المحصول',
  
  year:'سنة',
  roiMin:'العائد الأدنى',
  roiMax:'العائد الأقصى',
  
  arbolJoven:'شجرة صغيرة (+120 سم)',
  
  precio0agro:'لم يتم إدخال سعر الماء: نعرض الفوائد الزراعية للمنتج.',
  bAgro1T:'تقليل الإجهاد المائي',
  bAgro1D:'يمكن تقليل الإجهاد المائي بنسبة {stress}.',
  bAgro2T:'تقليل معدل وفيات النباتات',
  bAgro2D:'تقليل الوفيات بنسبة {mort} في المزروعات الصغيرة.',
  bAgro3T:'تطور جذري أفضل',
  bAgro3D:'جذور أعمق وأكثر تفرعاً بنسبة {rac}.',
  bAgro4T:'إنتاج أعلى جودة',
  bAgro4D:'تحسن حجم الثمار بنسبة {qual}.',
  bAgro5T:'توحيد أكبر للمحصول',
  bAgro5D:'تقليل التباين بين النباتات بنسبة {uni}%.',
  bAgro6T:'تحسين استخدام المياه المتاحة',
  bAgro6D:'يحتجز 400× وزنه من الماء. يقلل فقدان الماء بالتبخر بنسبة {evap}.',
  uAgua:"\u0645\u00b3/\u0633\u0646\u0629", uHa:"\u0647\u0643", uPlanta:"\u0646\u0628\u062a\u0629", perYear:"سنة",
  olivos:"\u0632\u064a\u062a\u0648\u0646",citricos:"\u062d\u0645\u0636\u064a\u0627\u062a",vinedos:"\u0643\u0631\u0645\u0629",horticultura:"\u0628\u0633\u062a\u0646\u0629",
  viveros:"\u0645\u0634\u062a\u0644",almendros:"\u0623\u0634\u062c\u0627\u0631 \u0644\u0648\u0632 \u0648\u0623\u062e\u0631\u0649",palmeras:"\u0646\u062e\u064a\u0644",cerezos:"\u0643\u0631\u0632",reforestacion:"\u062a\u0634\u062c\u064a\u0631",
  manzano:"أشجار التفاح",peral:"أشجار الكمثرى",melocotonero:"أشجار الخوخ وغيرها"
};

TXT.ca = {
  back:"Tornar",
  title:"CALCULA <span>ELS TEUS ESTALVIS</span>",
  subtitle:"Calcula en menys de 30 segons la dosi, el format recomanat i l'estalvi potencial de la teva explotació.",
  cultivo:"Cultiu", producto:"Producte", aplicacion:"Tipus d'aplicació",
  manualApp:"Aplicació manual", mecanizada:"Aplicació mecanitzada",
  suelo:"Tipus de sòl", franco:"Franc / equilibrat", arenoso:"Sorenc", pedregoso:"Pedregós", arcilloso:"Argilós",
  salino:'Salí / alcalí',
  ecLabel:'Conductivitat elèctrica (CE) del sòl', ec0:'CE 0-2 (no salí)', ec2:'CE 2-4 (lleugerament salí)', ec4:'CE 4-8 (moderadament salí)', ec8:'CE 8-16 (fortament salí)',
  salinAviso:'⚠️ Sòl salí: s\'aplica AQUASOL SAL, amb dosi ajustada mitjançant un factor ×{factor} segons la conductivitat elèctrica (CE) del sòl.',
  salinAdultoSat205:'⚠️ Amb CE 8-16, l\'ús d\'AQUASOL SAL és especialment recomanable en arbres adults, ja que l\'hidrogel estàndard perd més eficàcia en aquestes condicions d\'alta salinitat.',
  selectEC:'Selecciona el nivell de conductivitat elèctrica (CE) del sòl. ',
  bonusAviso:'⚙️ Dosi ajustada segons les condicions del vostre sòl i clima.',
  clima:"Clima", medio:"Mediterrani mitjà", seco:"Sec", muyseco:"Molt sec / sequera",
  edad:"Tipus de planta", joven:"Planta jove / petita", desarrollo:"Planta en desenvolupament / mitjana", adulto:"Arbre adult / gran",
  sistema:"Sistema de reg", goteo:"Degoteig", manual:"Manual", aspersion:"Aspersió", sinriego:"Sense reg fix",
  hectareas:"Hectàrees", m2:"Superfície m²", sustrato:"Substrat m³", plantas:"Nombre de plantes",
  riego:"Reg actual m³/ha/any", precio:"Preu de l'aigua "+CN+"/m³",
  calcular:"CALCULAR ESTALVI",
  impactBase:"El producte ajuda a millorar l'eficiència hídrica segons les condicions seleccionades.",
  visualSin:"Consum estimat sense AQUASOL", visualCon:"Consum estimat amb AQUASOL",
  agua:"AIGUA ESTALVIADA", dinero:"ESTALVI ECONÒMIC", eficiencia:"EFICIÈNCIA HÍDRICA",
  hectarea:"ESTALVI PER HECTÀREA", planta:"ESTALVI PER PLANTA",
  dosis:"DOSI ORIENTATIVA", dosisMec:"DOSI MECANITZADA",
  productoNecesario:"PRODUCTE NECESSARI", formato:"FORMAT RECOMANAT",
  coste:"COST DEL PRODUCTE", beneficio:"BENEFICI AGRONÒMIC",
  roi:"RETORN POTENCIAL", roiSmall:"Segons degradació progressiva estimada",
  leadTitle:"REP ELS TEUS RESULTATS I UN PRESSUPOST PERSONALITZAT",
  leadText:"Deixa les teves dades per rebre una proposta adaptada a la teva explotació.",
  empresa:"Empresa", nombre:"Nom i cognom", telefono:"Telèfon",
  presupuesto:"SOL·LICITAR PRESSUPOST", imprimir:"IMPRIMIR / PDF",
  note:"*Resultats orientatius. HYDRO i ECO retenen fins a 400 vegades el seu pes en aigua.",
  noAplica:"No aplica", menorMortalidad:"Menor mortalitat", plantasTxt:"plantes",
  saco1:"1 sac d'1 kg", saco2:"1 sac de 2 kg", saco5:"1 sac de 5 kg", sacos25:"sac(s) de 25 kg",
  alertDatos:"Si us plau, completa les teves dades.", alertTodos:"Si us plau, completa totes les dades.",
  solicitud:"Sol·licitud AQUASOL AGRO",
  hastaReducir:"Segons la teva selecció, AQUASOL pot ajudar a reduir el consum d'aigua fins aproximadament un ",
  selectCultivo:"Selecciona un cultiu.", selectProducto:"Selecciona un producte.",
  selectAplicacion:"Selecciona tipus d'aplicació.", selectSuelo:"Selecciona tipus de sòl.",
  selectClima:"Selecciona el clima.", selectSistema:"Selecciona sistema de reg.",
  selectEdad:"Selecciona tipus de planta.",
  sinRiegoAviso:"Sense reg fix: no es calcula estalvi d'aigua. ",
  precio0:"Preu 0: estalvi econòmic mostrat a 0. ",
  introSustrato:"Introdueix el volum de substrat en m³. ",
  introPlantasHort:"Introdueix el nombre de plantes. ",
  introM2:"Introdueix la superfície en m². ",
  introPlantasManual:"Introdueix el nombre de plantes. ",
  introHaMec:"Introdueix les hectàrees. ",
  validaTecnica:"Es recomana validació tècnica per aquesta combinació. ",
  introAgua:"Introdueix hectàrees i reg actual per calcular l'estalvi d'aigua. ",
  introTronco:"Introdueix el diàmetre del tronc en cm. ",
  tronco:"Diàmetre del tronc (cm)",
  smartQuestion:"Utilitzaràs AQUASOL AGRO Smart?",
  smartApp:"Només l'app (-10%)", smartSensors:"App + sensors (-20%)", smartNo:"No",
  smartExplain:"L'ús de sensors d'humitat a diferents profunditats permet adaptar el reg a les necessitats reals del sòl i evitar regs innecessaris.",
  smartAdicionalLabel:"Estalvi addicional estimat mitjançant l'optimització del reg: {pct}%*",
  smartDisclaimer:"*Estimació orientativa. L'estalvi real depèn del cultiu, el sòl, el clima, el sistema de reg i la gestió prèvia de l'explotació.",
  consumoActual:"CONSUM ACTUAL",
  ahorroAquasolSmart:"ESTALVI AMB AQUASOL",
  ahorroAdicionalSmart:"ESTALVI ADDICIONAL AMB AQUASOL SMART",
  consumoFinalEstimado:"CONSUM FINAL ESTIMAT",
  ahorroTotalAgua:"ESTALVI TOTAL D'AIGUA",
  finAquasolLabel:"Estalvi gràcies a AQUASOL:",
  finSmartLabel:"Estalvi addicional gràcies a AQUASOL Smart:",
  finTotalLabel:"ESTALVI ECONÒMIC TOTAL",
  compSin:"SENSE AQUASOL", compCon:"AMB AQUASOL", compSmart:"AMB AQUASOL + SMART",
  smartHowTitle:"Com aconsegueix AQUASOL Smart estalviar encara més aigua?",
  smartHowText:"Els sensors instal·lats al sòl permeten conèixer l'evolució de la humitat a diferents profunditats. AQUASOL Smart utilitza aquestes dades per ajudar a adaptar el reg a les necessitats reals del cultiu, evitant regs innecessaris i aprofitant durant més temps l'aigua retinguda a la zona radicular.",
  smartBenefit1:"Control de la humitat del sòl",
  smartBenefit2:"Optimització del moment de reg",
  smartBenefit3:"Reducció de regs innecessaris",
  bDefT:"Millor creixement i qualitat del cultiu",
  bDefD:"A més de l'estalvi d'aigua, pot afavorir una planta més vigorosa i collites de major qualitat.",
  bRefT:"Mortalitat potencialment reduïda", bRefD:"Ajuda a millorar la supervivència de les plantes en zones seques o post-incendi.",
  bVivT:"Plantes més uniformes i vigoroses", bVivD:"Afavoreix una humitat més estable en el substrat.",
  bHortT:"Cultiu més uniforme i productiu", bHortD:"Ajuda a reduir l'estrès hídric i afavorir un desenvolupament equilibrat.",
  bVinT:"Millor establiment de la vinya", bVinD:"Afavoreix el desenvolupament radicular i redueix l'estrès hídric.",
  refCap:"CAPACITAT DE RETENCIÓ", refBenef:"BENEFICI PRINCIPAL",
  refEstres:"REDUCCIÓ POTENCIAL D'ESTRÈS HÍDRIC",
  refSuper:"MILLORA POTENCIAL DE SUPERVIVÈNCIA", refPlant:"PLANTES QUE PODRIEN BENEFICIAR-SE",
  indexBad:"Pèrdues importants d’aigua", indexC:"Potencial de millora", indexB:"Bon potencial d’estalvi", indexA:"Molt bona retenció d’aigua", indexAplus:"Excel·lent eficiència hídrica",
  indexExplain:"L’AQUASOL INDEX™ avalua el potencial d’estalvi d’aigua de l’explotació segons el cultiu, el sòl, el clima i el sistema de reg. Una nota més alta indica millor retenció d’aigua, menys estrès hídric i més eficiència de reg.",

  
  
  ahorroM2:'ESTALVI PER m²',
  ahorroTotal:'ESTALVI TOTAL',
  ahorroM3:'ESTALVI PER m³ SUBSTRAT',
  ahorroTotalHort:'ESTALVI TOTAL',
  ahorroPlantaHort:'ESTALVI PER PLANTA',
  
  reforestacionAviso:"Per a reforestació, AQUASOL redueix la mortalitat de plantes i el nombre de regs d'arrencada, no el consum total d'aigua.",
  
  histTitle:'CÀLCULS RECENTS',
  histClear:'Esborrar historial',
  quoteBtn:'Sol·licitar pressupost amb aquestes dades',
  autoRiegoBtn:'No sé el meu consum — estimar',
  autoRiegoTip:'Estimació automàtica per cultiu',
  
  year:'Any',
  roiMin:'ROI mínim',
  roiMax:'ROI màxim',
  
  arbolJoven:'Arbre jove (+120 cm)',
  
  precio0agro:"Sense preu de l'aigua introduït: mostrem els beneficis agronòmics del producte.",
  bAgro1T:"Reducció de l'estrès hídric",
  bAgro1D:"Pot reduir l'estrès hídric fins a {stress}.",
  bAgro2T:'Menor taxa de mortalitat de plantes',
  bAgro2D:'Fins a {mort} menys mortalitat en plantacions joves.',
  bAgro3T:'Millor desenvolupament radicular',
  bAgro3D:'Sistema radicular fins a {rac} més profund i ramificat.',
  bAgro4T:'Producció de millor qualitat',
  bAgro4D:'Millora del calibre del fruit fins a {qual}.',
  bAgro5T:'Major uniformitat del cultiu',
  bAgro5D:'Fins a {uni}% menys variabilitat entre plantes.',
  bAgro6T:"Optimització de l'aigua disponible",
  bAgro6D:'Reté fins a 400× el seu pes en aigua. Redueix pèrdues per evaporació en {evap}.',
  uAgua:"m³/any", uHa:"ha", uPlanta:"planta", perYear:"any",
  olivos:'Oliveres',citricos:'Cítrics',vinedos:'Vinyes',horticultura:'Horticultura',
  viveros:'Vivers',almendros:'Ametllers i altres',palmeras:'Palmeres',cerezos:'Cirerers',reforestacion:'Reforestació',
  manzano:'Pomeres',peral:'Perers',melocotonero:'Presseguers i altres'
};

TXT.el = {
  back:"Επιστροφή",
  title:"\u03a5\u03a0\u039f\u039b\u039f\u0393\u0399\u03a3\u0395 <span>\u03a4\u0397\u039d \u0395\u039e\u039f\u0399\u039a\u039f\u039d\u039f\u039c\u0397\u03a3\u0397</span>",
  subtitle:"\u03a5\u03c0\u03bf\u03bb\u03bf\u03b3\u03b9\u03c3\u03b5 \u03c3\u03b5 \u03bb\u03b9\u03b3\u03cc\u03c4\u03b5\u03c1\u03bf \u03b1\u03c0\u03cc 30 \u03b4\u03b5\u03c5\u03c4\u03b5\u03c1\u03cc\u03bb\u03b5\u03c0\u03c4\u03b1 \u03c4\u03b7 \u03b4\u03cc\u03c3\u03b7, \u03c4\u03b7 \u03c3\u03c5\u03bd\u03b9\u03c3\u03c4\u03ce\u03bc\u03b5\u03bd\u03b7 \u03bc\u03bf\u03c1\u03c6\u03ae \u03ba\u03b1\u03b9 \u03c4\u03b7\u03bd \u03c0\u03b9\u03b8\u03b1\u03bd\u03ae \u03b5\u03be\u03bf\u03b9\u03ba\u03bf\u03bd\u03cc\u03bc\u03b7\u03c3\u03b7.",
  cultivo:"\u039a\u03b1\u03bb\u03bb\u03b9\u03ad\u03c1\u03b3\u03b5\u03b9\u03b1", producto:"\u03a0\u03c1\u03bf\u03ca\u03cc\u03bd", aplicacion:"\u03a4\u03cd\u03c0\u03bf\u03c2 \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae\u03c2",
  manualApp:"\u03a7\u03b5\u03b9\u03c1\u03bf\u03ba\u03af\u03bd\u03b7\u03c4\u03b7 \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae", mecanizada:"\u039c\u03b7\u03c7\u03b1\u03bd\u03b9\u03ba\u03ae \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae",
  suelo:"\u03a4\u03cd\u03c0\u03bf\u03c2 \u03b5\u03b4\u03ac\u03c6\u03bf\u03c5\u03c2", franco:"\u0391\u03bc\u03bc\u03bf\u03b1\u03c1\u03b3\u03b9\u03bb\u03ce\u03b4\u03b5\u03c2", arenoso:"\u0391\u03bc\u03bc\u03ce\u03b4\u03b5\u03c2", pedregoso:"\u03a0\u03b5\u03c4\u03c1\u03ce\u03b4\u03b5\u03c2", arcilloso:"\u0391\u03c1\u03b3\u03b9\u03bb\u03ce\u03b4\u03b5\u03c2",
  salino:'Αλατούχο / αλκαλικό',
  ecLabel:'Ηλεκτρική αγωγιμότητα (EC) εδάφους', ec0:'EC 0-2 (μη αλμυρό)', ec2:'EC 2-4 (ελαφρώς αλμυρό)', ec4:'EC 4-8 (μέτρια αλμυρό)', ec8:'EC 8-16 (έντονα αλμυρό)',
  bonusAviso:'⚙️ Δόση προσαρμοσμένη σύμφωνα με τις συνθήκες εδάφους και κλίματος.',
  salinAviso:'⚠️ Αλμυρό έδαφος: εφαρμόζεται AQUASOL SAL, με δόση προσαρμοσμένη με συντελεστή ×{factor} ανάλογα με την ηλεκτρική αγωγιμότητα (EC) του εδάφους.',
  salinAdultoSat205:'⚠️ Με EC 8-16, η χρήση του AQUASOL SAL συνιστάται ιδιαίτερα για ώριμα δέντρα, καθώς το τυπικό υδρογέλη χάνει περισσότερη αποτελεσματικότητα σε αυτές τις συνθήκες υψηλής αλατότητας.',
  selectEC:'Επίλεξε το επίπεδο ηλεκτρικής αγωγιμότητας (EC) του εδάφους. ',
  clima:"\u039a\u03bb\u03af\u03bc\u03b1", medio:"\u039c\u03ad\u03c3\u03bf \u039c\u03b5\u03c3\u03bf\u03b3\u03b5\u03b9\u03b1\u03ba\u03cc", seco:"\u039e\u03b7\u03c1\u03cc", muyseco:"\u03a0\u03bf\u03bb\u03cd \u03be\u03b7\u03c1\u03cc / \u03be\u03b7\u03c1\u03b1\u03c3\u03af\u03b1",
  edad:"\u03a4\u03cd\u03c0\u03bf\u03c2 \u03c6\u03c5\u03c4\u03bf\u03cd", joven:"\u039d\u03b5\u03b1\u03c1\u03cc / \u03bc\u03b9\u03ba\u03c1\u03cc \u03c6\u03c5\u03c4\u03cc", desarrollo:"\u03a6\u03c5\u03c4\u03cc \u03c3\u03b5 \u03b1\u03bd\u03ac\u03c0\u03c4\u03c5\u03be\u03b7 / \u03bc\u03b5\u03c3\u03b1\u03af\u03bf", adulto:"\u03a9\u03c1\u03af\u03bc\u03bf \u03b4\u03ad\u03bd\u03c4\u03c1\u03bf / \u03bc\u03b5\u03b3\u03ac\u03bb\u03bf",
  sistema:"\u03a3\u03cd\u03c3\u03c4\u03b7\u03bc\u03b1 \u03ac\u03c1\u03b4\u03b5\u03c5\u03c3\u03b7\u03c2", goteo:"\u03a3\u03c4\u03b1\u03b3\u03bf\u03bd\u03b9\u03b4\u03b9\u03b1\u03ba\u03ae \u03ac\u03c1\u03b4\u03b5\u03c5\u03c3\u03b7", manual:"\u03a7\u03b5\u03b9\u03c1\u03bf\u03ba\u03af\u03bd\u03b7\u03c4\u03bf", aspersion:"\u039a\u03b1\u03c4\u03b1\u03b9\u03bf\u03bd\u03b9\u03c3\u03bc\u03cc\u03c2", sinriego:"\u03a7\u03c9\u03c1\u03af\u03c2 \u03ac\u03c1\u03b4\u03b5\u03c5\u03c3\u03b7",
  hectareas:"\u0395\u03ba\u03c4\u03ac\u03c1\u03b9\u03b1", m2:"\u0388\u03ba\u03c4\u03b1\u03c3\u03b7 m\u00b2", sustrato:"\u03a5\u03c0\u03cc\u03c3\u03c4\u03c1\u03c9\u03bc\u03b1 m\u00b3", plantas:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c6\u03c5\u03c4\u03ce\u03bd",
  riego:"\u03a4\u03c1\u03ad\u03c7\u03bf\u03c5\u03c3\u03b1 \u03ac\u03c1\u03b4\u03b5\u03c5\u03c3\u03b7 m\u00b3/ha/\u03ad\u03c4\u03bf\u03c2", precio:"\u03a4\u03b9\u03bc\u03ae \u03bd\u03b5\u03c1\u03bf\u03cd "+CN+"/m\u00b3",
  calcular:"\u03a5\u03a0\u039f\u039b\u039f\u0393\u0399\u03a3\u039c\u039f\u03a3 \u0395\u039e\u039f\u0399\u039a\u039f\u039d\u039f\u039c\u0397\u03a3\u0397\u03a3",
  impactBase:"\u03a4\u03bf \u03c0\u03c1\u03bf\u03ca\u03cc\u03bd \u03b2\u03bf\u03b7\u03b8\u03ac \u03c3\u03c4\u03b7 \u03b2\u03b5\u03bb\u03c4\u03af\u03c9\u03c3\u03b7 \u03c4\u03b7\u03c2 \u03c5\u03b4\u03b1\u03c4\u03b9\u03ba\u03ae\u03c2 \u03b1\u03c0\u03cc\u03b4\u03bf\u03c3\u03b7\u03c2.",
  visualSin:"\u0395\u03ba\u03c4\u03b9\u03bc\u03ce\u03bc\u03b5\u03bd\u03b7 \u03ba\u03b1\u03c4\u03b1\u03bd\u03ac\u03bb\u03c9\u03c3\u03b7 \u03c7\u03c9\u03c1\u03af\u03c2 AQUASOL", visualCon:"\u0395\u03ba\u03c4\u03b9\u03bc\u03ce\u03bc\u03b5\u03bd\u03b7 \u03ba\u03b1\u03c4\u03b1\u03bd\u03ac\u03bb\u03c9\u03c3\u03b7 \u03bc\u03b5 AQUASOL",
  agua:"\u039d\u0395\u03a1\u039f \u03a0\u039f\u03a5 \u0395\u039e\u039f\u0399\u039a\u039f\u039d\u039f\u039c\u0397\u0398\u0397\u039a\u0395", dinero:"\u039f\u0399\u039a\u039f\u039d\u039f\u039c\u0399\u039a\u0397 \u0395\u039e\u039f\u0399\u039a\u039f\u039d\u039f\u039c\u0397\u03a3\u0397", eficiencia:"\u03a5\u0394\u0391\u03a4\u0399\u039a\u0397 \u0391\u03a0\u039f\u0394\u039f\u03a3\u0397",
  hectarea:"\u0395\u039e\u039f\u0399\u039a\u039f\u039d\u039f\u039c\u0397\u03a3\u0397 \u0391\u039d\u0391 \u0395\u039a\u03a4\u0391\u03a1\u0399\u039f", planta:"\u0395\u039e\u039f\u0399\u039a\u039f\u039d\u039f\u039c\u0397\u03a3\u0397 \u0391\u039d\u0391 \u03a6\u03a5\u03a4\u039f",
  dosis:"\u0395\u039d\u0394\u0395\u0399\u039a\u03a4\u0399\u039a\u0397 \u0394\u039f\u03a3\u0397", dosisMec:"\u039c\u0397\u03a7\u0391\u039d\u0399\u039a\u0397 \u0394\u039f\u03a3\u0397",
  productoNecesario:"\u0391\u03a0\u0391\u0399\u03a4\u039f\u03a5\u039c\u0395\u039d\u039f \u03a0\u03a1\u039f\u0399\u039f\u039d", formato:"\u03a3\u03a5\u039d\u0399\u03a3\u03a4\u03a9\u039c\u0395\u039d\u0397 \u039c\u039f\u03a1\u03a6\u0397",
  coste:"\u039a\u039f\u03a3\u03a4\u039f\u03a3 \u03a0\u03a1\u039f\u0399\u039f\u039d\u03a4\u039f\u03a3", beneficio:"\u0393\u0395\u03a9\u03a1\u0393\u0399\u039a\u039f \u039f\u03a6\u0395\u039b\u039f\u03a3",
  roi:"\u03a0\u0399\u0398\u0391\u039d\u0397 \u0391\u03a0\u039f\u0394\u039f\u03a3\u0397", roiSmall:"\u03a0\u03c1\u03bf\u03c3\u03b1\u03c1\u03bc\u03bf\u03c3\u03bc\u03ad\u03bd\u03bf \u03b3\u03b9\u03b1 \u03b5\u03ba\u03c4\u03b9\u03bc\u03ce\u03bc\u03b5\u03bd\u03b7 \u03c0\u03c1\u03bf\u03bf\u03b4\u03b5\u03c5\u03c4\u03b9\u03ba\u03ae \u03c5\u03c0\u03bf\u03b2\u03ac\u03b8\u03bc\u03b9\u03c3\u03b7",
  leadTitle:"\u039b\u0391\u0392\u0395 \u03a4\u0391 \u0391\u03a0\u039f\u03a4\u0395\u039b\u0395\u03a3\u039c\u0391\u03a4\u0391 \u039a\u0391\u0399 \u03a0\u03a1\u039f\u03a3\u03a9\u03a0\u039f\u03a0\u039f\u0399\u0397\u039c\u0395\u039d\u0397 \u03a0\u03a1\u039f\u03a3\u03a6\u039f\u03a1\u0391",
  leadText:"\u0391\u03c6\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b1 \u03c3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03b1 \u03c3\u03b1\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bb\u03ac\u03b2\u03b5\u03c4\u03b5 \u03c0\u03c1\u03cc\u03c4\u03b1\u03c3\u03b7 \u03c0\u03c1\u03bf\u03c3\u03b1\u03c1\u03bc\u03bf\u03c3\u03bc\u03ad\u03bd\u03b7.",
  empresa:"\u0395\u03c4\u03b1\u03b9\u03c1\u03b5\u03af\u03b1", nombre:"\u038c\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03b9 \u03b5\u03c0\u03ce\u03bd\u03c5\u03bc\u03bf", telefono:"\u03a4\u03b7\u03bb\u03ad\u03c6\u03c9\u03bd\u03bf",
  presupuesto:"\u0391\u0399\u03a4\u0397\u03a3\u0397 \u03a0\u03a1\u039f\u03a3\u03a6\u039f\u03a1\u0391\u03a3", imprimir:"\u0395\u039a\u03a4\u03a5\u03a0\u03a9\u03a3\u0397 / PDF",
  note:"*\u0395\u03bd\u03b4\u03b5\u03b9\u03ba\u03c4\u03b9\u03ba\u03ac \u03b1\u03c0\u03bf\u03c4\u03b5\u03bb\u03ad\u03c3\u03bc\u03b1\u03c4\u03b1. HYDRO \u03ba\u03b1\u03b9 ECO \u03ad\u03c9\u03c2 400 \u03c6\u03bf\u03c1\u03ad\u03c2 \u03c4\u03bf \u03b2\u03ac\u03c1\u03bf\u03c2 \u03c4\u03bf\u03c5\u03c2.",
  noAplica:"\u0394\u03b5\u03bd \u03b5\u03c6\u03b1\u03c1\u03bc\u03cc\u03b6\u03b5\u03c4\u03b1\u03b9", menorMortalidad:"\u039c\u03b5\u03b9\u03c9\u03bc\u03ad\u03bd\u03b7 \u03b8\u03bd\u03b7\u03c3\u03b9\u03bc\u03cc\u03c4\u03b7\u03c4\u03b1", plantasTxt:"\u03c6\u03c5\u03c4\u03ac",
  saco1:"1 \u03c3\u03ac\u03ba\u03bf\u03c2 1 kg", saco2:"1 \u03c3\u03ac\u03ba\u03bf\u03c2 2 kg", saco5:"1 \u03c3\u03ac\u03ba\u03bf\u03c2 5 kg", sacos25:"\u03c3\u03ac\u03ba\u03bf\u03c2/\u03bf\u03b9 25 kg",
  alertDatos:"\u03a0\u03b1\u03c1\u03b1\u03ba\u03b1\u03bb\u03ce \u03c3\u03c5\u03bc\u03c0\u03bb\u03b7\u03c1\u03ce\u03c3\u03c4\u03b5 \u03c4\u03b1 \u03c3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03b1 \u03c3\u03b1\u03c2.", alertTodos:"\u03a0\u03b1\u03c1\u03b1\u03ba\u03b1\u03bb\u03ce \u03c3\u03c5\u03bc\u03c0\u03bb\u03b7\u03c1\u03ce\u03c3\u03c4\u03b5 \u03cc\u03bb\u03b1 \u03c4\u03b1 \u03c3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03b1.",
  solicitud:"\u0391\u03af\u03c4\u03b7\u03c3\u03b7 AQUASOL AGRO",
  hastaReducir:"\u0392\u03ac\u03c3\u03b5\u03b9 \u03c4\u03b7\u03c2 \u03b5\u03c0\u03b9\u03bb\u03bf\u03b3\u03ae\u03c2 \u03c3\u03b1\u03c2 \u03c4\u03bf AQUASOL \u03bc\u03c0\u03bf\u03c1\u03b5\u03af \u03bd\u03b1 \u03b2\u03bf\u03b7\u03b8\u03ae\u03c3\u03b5\u03b9 \u03c3\u03c4\u03b7 \u03bc\u03b5\u03af\u03c9\u03c3\u03b7 \u03ba\u03b1\u03c4\u03ac \u03c0\u03b5\u03c1\u03af\u03c0\u03bf\u03c5 ",
  selectCultivo:"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03ba\u03b1\u03bb\u03bb\u03b9\u03ad\u03c1\u03b3\u03b5\u03b9\u03b1.", selectProducto:"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c0\u03c1\u03bf\u03ca\u03cc\u03bd.",
  selectAplicacion:"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03cd\u03c0\u03bf \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae\u03c2.", selectSuelo:"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03cd\u03c0\u03bf \u03b5\u03b4\u03ac\u03c6\u03bf\u03c5\u03c2.",
  selectClima:"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03ba\u03bb\u03af\u03bc\u03b1.", selectSistema:"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c3\u03cd\u03c3\u03c4\u03b7\u03bc\u03b1 \u03ac\u03c1\u03b4\u03b5\u03c5\u03c3\u03b7\u03c2.",
  selectEdad:"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03cd\u03c0\u03bf \u03c6\u03c5\u03c4\u03bf\u03cd.",
  sinRiegoAviso:"\u03a7\u03c9\u03c1\u03af\u03c2 \u03ac\u03c1\u03b4\u03b5\u03c5\u03c3\u03b7: \u03b4\u03b5\u03bd \u03c5\u03c0\u03bf\u03bb\u03bf\u03b3\u03af\u03b6\u03b5\u03c4\u03b1\u03b9 \u03b5\u03be\u03bf\u03b9\u03ba\u03bf\u03bd\u03cc\u03bc\u03b7\u03c3\u03b7 \u03bd\u03b5\u03c1\u03bf\u03cd. ",
  precio0:"\u03a4\u03b9\u03bc\u03ae 0: \u03bf\u03b9\u03ba\u03bf\u03bd\u03bf\u03bc\u03b9\u03ba\u03ae \u03b5\u03be\u03bf\u03b9\u03ba\u03bf\u03bd\u03cc\u03bc\u03b7\u03c3\u03b7 \u03b5\u03bc\u03c6\u03b1\u03bd\u03af\u03b6\u03b5\u03c4\u03b1\u03b9 \u03c9\u03c2 0. ",
  introSustrato:"\u0395\u03b9\u03c3\u03ac\u03b3\u03b5\u03c4\u03b5 \u03c4\u03bf\u03bd \u03cc\u03b3\u03ba\u03bf \u03c5\u03c0\u03bf\u03c3\u03c4\u03c1\u03ce\u03bc\u03b1\u03c4\u03bf\u03c2 \u03c3\u03b5 m\u00b3. ",
  introPlantasHort:"\u0395\u03b9\u03c3\u03ac\u03b3\u03b5\u03c4\u03b5 \u03c4\u03bf\u03bd \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03c6\u03c5\u03c4\u03ce\u03bd. ",
  introM2:"\u0395\u03b9\u03c3\u03ac\u03b3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03ad\u03ba\u03c4\u03b1\u03c3\u03b7 \u03c3\u03b5 m\u00b2. ",
  introPlantasManual:"\u0395\u03b9\u03c3\u03ac\u03b3\u03b5\u03c4\u03b5 \u03c4\u03bf\u03bd \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03c6\u03c5\u03c4\u03ce\u03bd. ",
  introHaMec:"\u0395\u03b9\u03c3\u03ac\u03b3\u03b5\u03c4\u03b5 \u03c4\u03b1 \u03b5\u03ba\u03c4\u03ac\u03c1\u03b9\u03b1. ",
  validaTecnica:"\u03a3\u03c5\u03bd\u03b9\u03c3\u03c4\u03ac\u03c4\u03b1\u03b9 \u03c4\u03b5\u03c7\u03bd\u03b9\u03ba\u03ae \u03b5\u03c0\u03b1\u03bb\u03ae\u03b8\u03b5\u03c5\u03c3\u03b7 \u03b3\u03b9\u03b1 \u03b1\u03c5\u03c4\u03cc\u03bd \u03c4\u03bf\u03bd \u03c3\u03c5\u03bd\u03b4\u03c5\u03b1\u03c3\u03bc\u03cc. ",
  introAgua:"\u0395\u03b9\u03c3\u03ac\u03b3\u03b5\u03c4\u03b5 \u03b5\u03ba\u03c4\u03ac\u03c1\u03b9\u03b1 \u03ba\u03b1\u03b9 \u03c4\u03c1\u03ad\u03c7\u03bf\u03c5\u03c3\u03b1 \u03ac\u03c1\u03b4\u03b5\u03c5\u03c3\u03b7 \u03b3\u03b9\u03b1 \u03c4\u03bf\u03bd \u03c5\u03c0\u03bf\u03bb\u03bf\u03b3\u03b9\u03c3\u03bc\u03cc. ",
  introTronco:"Εισάγετε τη διάμετρο του κορμού σε cm. ",
  tronco:"Διάμετρος κορμού (cm)",
  smartQuestion:"Θα χρησιμοποιήσεις το AQUASOL AGRO Smart;",
  smartApp:"Μόνο η εφαρμογή (-10%)", smartSensors:"Εφαρμογή + αισθητήρες (-20%)", smartNo:"Όχι",
  smartExplain:"Η χρήση αισθητήρων υγρασίας σε διαφορετικά βάθη επιτρέπει την προσαρμογή της άρδευσης στις πραγματικές ανάγκες του εδάφους και την αποφυγή περιττής άρδευσης.",
  smartAdicionalLabel:"Εκτιμώμενη πρόσθετη εξοικονόμηση μέσω βελτιστοποίησης της άρδευσης: {pct}%*",
  smartDisclaimer:"*Ενδεικτική εκτίμηση. Η πραγματική εξοικονόμηση εξαρτάται από την καλλιέργεια, το έδαφος, το κλίμα, το σύστημα άρδευσης και την προηγούμενη διαχείριση της εκμετάλλευσης.",
  consumoActual:"ΤΡΕΧΟΥΣΑ ΚΑΤΑΝΑΛΩΣΗ",
  ahorroAquasolSmart:"ΕΞΟΙΚΟΝΟΜΗΣΗ ΜΕ AQUASOL",
  ahorroAdicionalSmart:"ΠΡΟΣΘΕΤΗ ΕΞΟΙΚΟΝΟΜΗΣΗ ΜΕ AQUASOL SMART",
  consumoFinalEstimado:"ΕΚΤΙΜΩΜΕΝΗ ΤΕΛΙΚΗ ΚΑΤΑΝΑΛΩΣΗ",
  ahorroTotalAgua:"ΣΥΝΟΛΙΚΗ ΕΞΟΙΚΟΝΟΜΗΣΗ ΝΕΡΟΥ",
  finAquasolLabel:"Εξοικονόμηση χάρη στο AQUASOL:",
  finSmartLabel:"Πρόσθετη εξοικονόμηση χάρη στο AQUASOL Smart:",
  finTotalLabel:"ΣΥΝΟΛΙΚΗ ΟΙΚΟΝΟΜΙΚΗ ΕΞΟΙΚΟΝΟΜΗΣΗ",
  compSin:"ΧΩΡΙΣ AQUASOL", compCon:"ΜΕ AQUASOL", compSmart:"ΜΕ AQUASOL + SMART",
  smartHowTitle:"Πώς καταφέρνει το AQUASOL Smart να εξοικονομεί ακόμα περισσότερο νερό;",
  smartHowText:"Οι αισθητήρες που είναι εγκατεστημένοι στο έδαφος επιτρέπουν τη γνώση της εξέλιξης της υγρασίας σε διαφορετικά βάθη. Το AQUASOL Smart χρησιμοποιεί αυτά τα δεδομένα για να βοηθήσει στην προσαρμογή της άρδευσης στις πραγματικές ανάγκες της καλλιέργειας, αποφεύγοντας την περιττή άρδευση και αξιοποιώντας για περισσότερο χρόνο το νερό που συγκρατείται στη ριζική ζώνη.",
  smartBenefit1:"Έλεγχος υγρασίας εδάφους",
  smartBenefit2:"Βελτιστοποίηση χρόνου άρδευσης",
  smartBenefit3:"Μείωση περιττής άρδευσης",
  bDefT:"\u039a\u03b1\u03bb\u03cd\u03c4\u03b5\u03c1\u03b7 \u03b1\u03bd\u03ac\u03c0\u03c4\u03c5\u03be\u03b7 \u03ba\u03b1\u03b9 \u03c0\u03bf\u03b9\u03cc\u03c4\u03b7\u03c4\u03b1",
  bDefD:"\u0395\u03ba\u03c4\u03cc\u03c2 \u03b1\u03c0\u03cc \u03c4\u03b7\u03bd \u03b5\u03be\u03bf\u03b9\u03ba\u03bf\u03bd\u03cc\u03bc\u03b7\u03c3\u03b7 \u03bd\u03b5\u03c1\u03bf\u03cd \u03bc\u03c0\u03bf\u03c1\u03b5\u03af \u03bd\u03b1 \u03c0\u03c1\u03bf\u03c9\u03b8\u03ae\u03c3\u03b5\u03b9 \u03b9\u03c3\u03c7\u03c5\u03c1\u03cc\u03c4\u03b5\u03c1\u03bf \u03c6\u03c5\u03c4\u03cc.",
  bRefT:"\u0394\u03c5\u03bd\u03b7\u03c4\u03b9\u03ba\u03ac \u03bc\u03b5\u03b9\u03c9\u03bc\u03ad\u03bd\u03b7 \u03b8\u03bd\u03b7\u03c3\u03b9\u03bc\u03cc\u03c4\u03b7\u03c4\u03b1",
  bRefD:"\u0392\u03bf\u03b7\u03b8\u03ac \u03c3\u03c4\u03b7 \u03b2\u03b5\u03bb\u03c4\u03af\u03c9\u03c3\u03b7 \u03c4\u03b7\u03c2 \u03b5\u03c0\u03b9\u03b2\u03af\u03c9\u03c3\u03b7\u03c2 \u03c6\u03c5\u03c4\u03ce\u03bd.",
  bVivT:"\u03a0\u03b9\u03bf \u03bf\u03bc\u03bf\u03b9\u03cc\u03bc\u03bf\u03c1\u03c6\u03b1 \u03ba\u03b1\u03b9 \u03b6\u03c9\u03b7\u03c1\u03ac \u03c6\u03c5\u03c4\u03ac",
  bVivD:"\u03a0\u03c1\u03bf\u03c9\u03b8\u03b5\u03af \u03c0\u03b9\u03bf \u03c3\u03c4\u03b1\u03b8\u03b5\u03c1\u03ae \u03c5\u03b3\u03c1\u03b1\u03c3\u03af\u03b1.",
  bHortT:"\u03a0\u03b9\u03bf \u03bf\u03bc\u03bf\u03b9\u03cc\u03bc\u03bf\u03c1\u03c6\u03b7 \u03ba\u03b1\u03b9 \u03c0\u03b1\u03c1\u03b1\u03b3\u03c9\u03b3\u03b9\u03ba\u03ae \u03ba\u03b1\u03bb\u03bb\u03b9\u03ad\u03c1\u03b3\u03b5\u03b9\u03b1",
  bHortD:"\u0392\u03bf\u03b7\u03b8\u03ac \u03c3\u03c4\u03b7 \u03bc\u03b5\u03af\u03c9\u03c3\u03b7 \u03c5\u03b4\u03b1\u03c4\u03b9\u03ba\u03ae\u03c2 \u03ba\u03b1\u03c4\u03b1\u03c0\u03cc\u03bd\u03b7\u03c3\u03b7\u03c2.",
  bVinT:"\u039a\u03b1\u03bb\u03cd\u03c4\u03b5\u03c1\u03b7 \u03b5\u03b3\u03ba\u03b1\u03c4\u03ac\u03c3\u03c4\u03b1\u03c3\u03b7 \u03b1\u03bc\u03c0\u03b5\u03bb\u03b9\u03bf\u03cd",
  bVinD:"\u03a0\u03c1\u03bf\u03c9\u03b8\u03b5\u03af \u03c1\u03b9\u03b6\u03b9\u03ba\u03ae \u03b1\u03bd\u03ac\u03c0\u03c4\u03c5\u03be\u03b7.",
  refCap:"\u0399\u039a\u0391\u039d\u039f\u03a4\u0397\u03a4\u0391 \u03a3\u03a5\u0393\u039a\u03a1\u0391\u03a4\u0397\u03a3\u0397\u03a3", refBenef:"\u039a\u03a5\u03a1\u0399\u039f \u039f\u03a6\u0395\u039b\u039f\u03a3",
  refEstres:"\u0394\u03a5\u039d\u0397\u03a4\u0399\u039a\u0397 \u039c\u0395\u0399\u03a9\u03a3\u0397 \u039a\u0391\u03a4\u0391\u03a0\u039f\u039d\u0397\u03a3\u0397\u03a3",
  refSuper:"\u0394\u03a5\u039d\u0397\u03a4\u0399\u039a\u0397 \u0392\u0395\u039b\u03a4\u0399\u03a9\u03a3\u0397 \u0395\u03a0\u0399\u0392\u0399\u03a9\u03a3\u0397\u03a3", refPlant:"\u03a6\u03a5\u03a4\u0391 \u03a0\u039f\u03a5 \u039c\u03a0\u039f\u03a1\u039f\u03a5\u039d \u039d\u0391 \u03a9\u03a6\u0395\u039b\u0397\u0398\u039f\u03a5\u039d",
  indexBad:"Σημαντικές απώλειες νερού", indexC:"Δυνατότητα βελτίωσης", indexB:"Καλό δυναμικό εξοικονόμησης", indexA:"Πολύ καλή συγκράτηση νερού", indexAplus:"Εξαιρετική υδατική απόδοση",
  indexExplain:"Το AQUASOL INDEX™ αξιολογεί το δυναμικό εξοικονόμησης νερού της εκμετάλλευσης ανάλογα με την καλλιέργεια, το έδαφος, το κλίμα και το σύστημα άρδευσης. Υψηλότερη βαθμολογία δείχνει καλύτερη συγκράτηση νερού, λιγότερο υδατικό στρες και μεγαλύτερη αποδοτικότητα άρδευσης.",

  
  
  ahorroM2:'ΕΞΟΙΚΟΝΟΜΗΣΗ ΑΝΑ m²',
  ahorroTotal:'ΣΥΝΟΛΙΚΗ ΕΞΟΙΚΟΝΟΜΗΣΗ',
  ahorroM3:'ΕΞΟΙΚΟΝΟΜΗΣΗ ΑΝΑ m³ ΥΠΟΣΤΡΩΜΑ',
  ahorroTotalHort:'ΣΥΝΟΛΙΚΗ ΕΞΟΙΚΟΝΟΜΗΣΗ',
  ahorroPlantaHort:'ΕΞΟΙΚΟΝΟΜΗΣΗ ΑΝΑ ΦΥΤΟ',
  
  reforestacionAviso:'Για αναδάσωση, το AQUASOL μειώνει τη θνησιμότητα φυτών και τον αριθμό αρδεύσεων εκκίνησης, όχι τη συνολική κατανάλωση νερού.',
  
  histTitle:'ΠΡΌΣΦΑΤΟΙ ΥΠΟΛΟΓΙΣΜΟΊ',
  histClear:'Εκκαθάριση ιστορικού',
  quoteBtn:'Αίτημα προσφοράς με αυτά τα δεδομένα',
  autoRiegoBtn:'Δεν γνωρίζω την κατανάλωσή μου',
  autoRiegoTip:'Αυτόματη εκτίμηση ανά καλλιέργεια',
  
  year:'Έτος',
  roiMin:'Ελάχ. ROI',
  roiMax:'Μέγ. ROI',
  
  arbolJoven:'Νεαρό δέντρο (+120 εκ.)',
  
  precio0agro:'Δεν εισήχθη τιμή νερού: εμφανίζουμε τα γεωργικά οφέλη του προϊόντος.',
  bAgro1T:'Μείωση υδατικής καταπόνησης',
  bAgro1D:'Μπορεί να μειώσει την υδατική καταπόνηση έως {stress}.',
  bAgro2T:'Χαμηλότερο ποσοστό θνησιμότητας φυτών',
  bAgro2D:'Έως {mort} λιγότερη θνησιμότητα σε νεαρές φυτείες.',
  bAgro3T:'Καλύτερη ανάπτυξη ριζικού συστήματος',
  bAgro3D:'Ριζικό σύστημα έως {rac} βαθύτερο και πιο διακλαδισμένο.',
  bAgro4T:'Παραγωγή υψηλότερης ποιότητας',
  bAgro4D:'Βελτίωση μεγέθους καρπού έως {qual}.',
  bAgro5T:'Μεγαλύτερη ομοιομορφία καλλιέργειας',
  bAgro5D:'Έως {uni}% λιγότερη μεταβλητότητα μεταξύ φυτών.',
  bAgro6T:'Βελτιστοποίηση διαθέσιμου νερού',
  bAgro6D:'Συγκρατεί έως 400× το βάρος του σε νερό. Μειώνει απώλειες εξάτμισης {evap}.',
  uAgua:"m\u00b3/\u03ad\u03c4\u03bf\u03c2", uHa:"ha", uPlanta:"\u03c6\u03c5\u03c4\u03cc", perYear:"έτος",
  olivos:'\u0395\u03bb\u03b1\u03b9\u03cc\u03b4\u03b5\u03bd\u03c4\u03c1\u03b1',citricos:'\u0395\u03c3\u03c0\u03b5\u03c1\u03b9\u03b4\u03bf\u03b5\u03b9\u03b4\u03ae',vinedos:'\u0391\u03bc\u03c0\u03b5\u03bb\u03ce\u03bd\u03b5\u03c2',horticultura:'\u039a\u03b7\u03c0\u03b5\u03c5\u03c4\u03b9\u03ba\u03ac',
  viveros:'\u03a6\u03c5\u03c4\u03ce\u03c1\u03b9\u03b1',almendros:'\u0391\u03bc\u03c5\u03b3\u03b4\u03b1\u03bb\u03b9\u03ad\u03c2 \u03ba\u03b1\u03b9 \u03ac\u03bb\u03bb\u03b1',palmeras:'\u03a6\u03bf\u03af\u03bd\u03b9\u03ba\u03b5\u03c2',cerezos:'\u039a\u03b5\u03c1\u03b1\u03c3\u03b9\u03ad\u03c2',reforestacion:'\u0391\u03bd\u03b1\u03b4\u03b1\u03c3\u03ce\u03c3\u03b5\u03b9\u03c2',
  manzano:'Μηλιές',peral:'Αχλαδιές',melocotonero:'Ροδακινιές και άλλα'
};

TXT.it = {
  back:"Indietro",
  title:"CALCOLA <span>I TUOI RISPARMI</span>",
  subtitle:"Calcola in meno di 30 secondi la dose, il formato consigliato e il risparmio potenziale della tua azienda agricola.",
  cultivo:"Coltura", producto:"Prodotto", aplicacion:"Tipo di applicazione",
  manualApp:"Applicazione manuale", mecanizada:"Applicazione meccanizzata",
  suelo:"Tipo di terreno", franco:"Franco / equilibrato", arenoso:"Sabbioso", pedregoso:"Sassoso", arcilloso:"Argilloso",
  salino:'Salino / alcalino',
  ecLabel:'Conducibilità elettrica (CE) del suolo', ec0:'CE 0-2 (non salino)', ec2:'CE 2-4 (leggermente salino)', ec4:'CE 4-8 (moderatamente salino)', ec8:'CE 8-16 (fortemente salino)',
  bonusAviso:'⚙️ Dose adattata alle condizioni del suolo e del clima.',
  salinAviso:'⚠️ Suolo salino: viene applicato AQUASOL SAL, con dose adattata da un fattore ×{factor} in base alla conducibilità elettrica (CE) del suolo.',
  salinAdultoSat205:'⚠️ Con CE 8-16, l\'uso di AQUASOL SAL è particolarmente consigliato per alberi adulti, poiché l\'idrogel standard perde più efficacia in queste condizioni di alta salinità.',
  selectEC:'Seleziona il livello di conducibilità elettrica (CE) del suolo. ',
  clima:"Clima", medio:"Mediterraneo medio", seco:"Secco", muyseco:"Molto secco / siccità",
  edad:"Tipo di pianta", joven:"Pianta giovane / piccola", desarrollo:"Pianta in sviluppo / media", adulto:"Albero adulto / grande",
  sistema:"Sistema di irrigazione", goteo:"Goccia a goccia", manual:"Manuale", aspersion:"Aspersione", sinriego:"Senza irrigazione fissa",
  hectareas:"Ettari", m2:"Superficie m²", sustrato:"Substrato m³", plantas:"Numero di piante",
  riego:"Irrigazione attuale m³/ha/anno", precio:"Prezzo acqua "+CN+"/m³",
  calcular:"CALCOLA RISPARMIO",
  impactBase:"Il prodotto aiuta a migliorare l'efficienza idrica secondo le condizioni selezionate.",
  visualSin:"Consumo stimato senza AQUASOL", visualCon:"Consumo stimato con AQUASOL",
  agua:"ACQUA RISPARMIATA", dinero:"RISPARMIO ECONOMICO", eficiencia:"EFFICIENZA IDRICA",
  hectarea:"RISPARMIO PER ETTARO", planta:"RISPARMIO PER PIANTA",
  dosis:"DOSE INDICATIVA", dosisMec:"DOSE MECCANIZZATA",
  productoNecesario:"PRODOTTO NECESSARIO", formato:"FORMATO CONSIGLIATO",
  coste:"COSTO PRODOTTO", beneficio:"BENEFICIO AGRONOMICO",
  roi:"RITORNO POTENZIALE", roiSmall:"Adeguato per degradazione progressiva stimata",
  leadTitle:"RICEVI I TUOI RISULTATI E UN PREVENTIVO PERSONALIZZATO",
  leadText:"Lascia i tuoi dati per ricevere una proposta adattata alla tua azienda.",
  empresa:"Azienda", nombre:"Nome e cognome", telefono:"Telefono",
  presupuesto:"RICHIEDI PREVENTIVO", imprimir:"STAMPA / PDF",
  note:"*Risultati indicativi. HYDRO e ECO trattengono fino a 400 volte il loro peso in acqua.",
  noAplica:"Non applicabile", menorMortalidad:"Mortalità ridotta", plantasTxt:"piante",
  saco1:"1 sacco da 1 kg", saco2:"1 sacco da 2 kg", saco5:"1 sacco da 5 kg", sacos25:"sacco/i da 25 kg",
  alertDatos:"Si prega di completare i propri dati.", alertTodos:"Si prega di completare tutti i dati.",
  solicitud:"Richiesta AQUASOL AGRO",
  hastaReducir:"In base alla tua selezione, AQUASOL può aiutare a ridurre il consumo di acqua di circa ",
  selectCultivo:"Seleziona una coltura.", selectProducto:"Seleziona un prodotto.",
  selectAplicacion:"Seleziona un tipo di applicazione.", selectSuelo:"Seleziona il tipo di terreno.",
  selectClima:"Seleziona il clima.", selectSistema:"Seleziona il sistema di irrigazione.",
  selectEdad:"Seleziona il tipo di pianta.",
  sinRiegoAviso:"Senza irrigazione fissa: risparmio idrico non calcolato. ",
  precio0:"Prezzo 0: risparmio economico mostrato a 0. ",
  introSustrato:"Inserisci il volume di substrato in m³. ",
  introPlantasHort:"Inserisci il numero di piante. ",
  introM2:"Inserisci la superficie in m². ",
  introPlantasManual:"Inserisci il numero di piante. ",
  introHaMec:"Inserisci gli ettari. ",
  validaTecnica:"Validazione tecnica consigliata per questa combinazione. ",
  introAgua:"Inserisci ettari e irrigazione attuale per calcolare il risparmio idrico. ",
  introTronco:"Inserisci il diametro del tronco in cm. ",
  tronco:"Diametro del tronco (cm)",
  smartQuestion:"Utilizzerai AQUASOL AGRO Smart?",
  smartApp:"Solo app (-10%)", smartSensors:"App + sensori (-20%)", smartNo:"No",
  smartExplain:"L'uso di sensori di umidità a diverse profondità consente di adattare l'irrigazione alle reali esigenze del suolo ed evitare irrigazioni inutili.",
  smartAdicionalLabel:"Risparmio aggiuntivo stimato grazie all'ottimizzazione dell'irrigazione: {pct}%*",
  smartDisclaimer:"*Stima indicativa. Il risparmio reale dipende dalla coltura, dal suolo, dal clima, dal sistema di irrigazione e dalla gestione precedente dell'azienda.",
  consumoActual:"CONSUMO ATTUALE",
  ahorroAquasolSmart:"RISPARMIO CON AQUASOL",
  ahorroAdicionalSmart:"RISPARMIO AGGIUNTIVO CON AQUASOL SMART",
  consumoFinalEstimado:"CONSUMO FINALE STIMATO",
  ahorroTotalAgua:"RISPARMIO IDRICO TOTALE",
  finAquasolLabel:"Risparmio grazie ad AQUASOL:",
  finSmartLabel:"Risparmio aggiuntivo grazie ad AQUASOL Smart:",
  finTotalLabel:"RISPARMIO ECONOMICO TOTALE",
  compSin:"SENZA AQUASOL", compCon:"CON AQUASOL", compSmart:"CON AQUASOL + SMART",
  smartHowTitle:"Come fa AQUASOL Smart a risparmiare ancora più acqua?",
  smartHowText:"I sensori installati nel suolo permettono di conoscere l'evoluzione dell'umidità a diverse profondità. AQUASOL Smart utilizza questi dati per aiutare ad adattare l'irrigazione alle reali esigenze della coltura, evitando irrigazioni inutili e sfruttando più a lungo l'acqua trattenuta nella zona radicale.",
  smartBenefit1:"Controllo dell'umidità del suolo",
  smartBenefit2:"Ottimizzazione del momento di irrigazione",
  smartBenefit3:"Riduzione delle irrigazioni inutili",
  bDefT:"Migliore crescita e qualità della coltura",
  bDefD:"Oltre al risparmio idrico, può favorire una pianta più vigorosa e raccolti di maggiore qualità.",
  bRefT:"Mortalità potenzialmente ridotta", bRefD:"Aiuta a migliorare la sopravvivenza delle piante in zone secche o post-incendio.",
  bVivT:"Piante più uniformi e vigorose", bVivD:"Favorisce una umidità più stabile nel substrato.",
  bHortT:"Coltura più uniforme e produttiva", bHortD:"Aiuta a ridurre lo stress idrico e favorire uno sviluppo equilibrato.",
  bVinT:"Migliore attecchimento della vite", bVinD:"Favorisce lo sviluppo radicale e riduce lo stress idrico.",
  refCap:"CAPACITÀ DI RITENZIONE", refBenef:"BENEFICIO PRINCIPALE",
  refEstres:"RIDUZIONE POTENZIALE DELLO STRESS IDRICO",
  refSuper:"MIGLIORAMENTO POTENZIALE DELLA SOPRAVVIVENZA", refPlant:"PIANTE CHE POTREBBERO BENEFICIARNE",
  indexBad:"Perdite importanti d’acqua", indexC:"Potenziale di miglioramento", indexB:"Buon potenziale di risparmio", indexA:"Ottima ritenzione idrica", indexAplus:"Eccellente efficienza idrica",
  indexExplain:"L’AQUASOL INDEX™ valuta il potenziale di risparmio idrico dell’azienda in base a coltura, suolo, clima e sistema di irrigazione. Un punteggio più alto indica migliore ritenzione idrica, minore stress idrico e maggiore efficienza di irrigazione.",

  
  
  ahorroM2:'RISPARMIO PER m²',
  ahorroTotal:'RISPARMIO TOTALE',
  ahorroM3:'RISPARMIO PER m³ SUBSTRATO',
  ahorroTotalHort:'RISPARMIO TOTALE',
  ahorroPlantaHort:'RISPARMIO PER PIANTA',
  
  reforestacionAviso:"Per il rimboschimento, AQUASOL riduce la mortalità delle piante e il numero di irrigazioni di avviamento, non il consumo totale d'acqua.",
  
  histTitle:'CALCOLI RECENTI',
  histClear:'Cancella cronologia',
  quoteBtn:'Richiedi preventivo con questi dati',
  autoRiegoBtn:'Non conosco il mio consumo — stima',
  autoRiegoTip:'Stima automatica per coltura',
  
  year:'Anno',
  roiMin:'ROI minimo',
  roiMax:'ROI massimo',
  
  arbolJoven:'Albero giovane (+120 cm)',
  
  precio0agro:"Senza prezzo dell'acqua inserito: mostriamo i benefici agronomici del prodotto.",
  bAgro1T:'Riduzione dello stress idrico',
  bAgro1D:'Può ridurre lo stress idrico fino a {stress}.',
  bAgro2T:'Riduzione del tasso di mortalità delle piante',
  bAgro2D:'Fino a {mort} meno mortalità nelle giovani piantagioni.',
  bAgro3T:'Migliore sviluppo radicale',
  bAgro3D:'Sistema radicale fino a {rac} più profondo e ramificato.',
  bAgro4T:'Produzione di migliore qualità',
  bAgro4D:'Miglioramento del calibro del frutto fino a {qual}.',
  bAgro5T:'Maggiore uniformità della coltura',
  bAgro5D:'Fino a {uni}% meno variabilità tra le piante.',
  bAgro6T:"Ottimizzazione dell'acqua disponibile",
  bAgro6D:'Trattiene fino a 400× il suo peso in acqua. Riduce le perdite per evaporazione del {evap}.',
  uAgua:"m³/anno", uHa:"ha", uPlanta:"pianta", perYear:"anno",
  olivos:'Ulivi',citricos:'Agrumi',vinedos:'Vigneti',horticultura:'Orticoltura',
  viveros:'Vivai',almendros:'Mandorli e altri',palmeras:'Palme',cerezos:'Ciliegi',reforestacion:'Rimboschimento',
  manzano:'Meli',peral:'Peri',melocotonero:'Peschi e altri'
};

TXT.tr = {
  back:"Geri dön",
  title:"TASARRUFLARINI <span>HESAPLA</span>",
  subtitle:"Dozu, önerilen ambalajı ve işletmen için potansiyel tasarrufu 30 saniyeden kısa sürede hesapla.",
  cultivo:"Ürün", producto:"Ürün tipi", aplicacion:"Uygulama tipi",
  manualApp:"Manuel uygulama", mecanizada:"Mekanize uygulama",
  suelo:"Toprak tipi", franco:"Dengeli toprak", arenoso:"Kumlu", pedregoso:"Taşlı", arcilloso:"Killi",
  salino:'Tuzlu / alkali',
  ecLabel:'Toprağın elektriksel iletkenliği (EC)', ec0:'EC 0-2 (tuzsuz)', ec2:'EC 2-4 (hafif tuzlu)', ec4:'EC 4-8 (orta tuzlu)', ec8:'EC 8-16 (güçlü tuzlu)',
  salinAviso:'⚠️ Tuzlu toprak: AQUASOL SAL uygulanır, doz toprağın elektriksel iletkenliğine (EC) göre ×{factor} faktörüyle ayarlanır.',
  salinAdultoSat205:'⚠️ EC 8-16 seviyesinde, yetişkin ağaçlar için AQUASOL SAL kullanımı özellikle önerilir, çünkü standart hidrojel bu yüksek tuzluluk koşullarında daha fazla verimlilik kaybeder.',
  selectEC:'Toprağın elektriksel iletkenlik (EC) seviyesini seçin. ',
  bonusAviso:'⚙️ Doz, toprak ve iklim koşullarınıza göre ayarlandı.',
  clima:"İklim", medio:"Orta Akdeniz", seco:"Kuru", muyseco:"Çok kuru / kuraklık",
  edad:"Bitki tipi", joven:"Genç / küçük bitki", desarrollo:"Gelişmekte olan / orta bitki", adulto:"Yetişkin / büyük ağaç",
  sistema:"Sulama sistemi", goteo:"Damla sulama", manual:"Manuel", aspersion:"Yağmurlama", sinriego:"Sabit sulama yok",
  hectareas:"Hektar", m2:"Alan m²", sustrato:"Substrat m³", plantas:"Bitki sayısı",
  riego:"Mevcut sulama m³/ha/yıl", precio:"Su fiyatı "+CN+"/m³",
  calcular:"TASARRUFU HESAPLA",
  impactBase:"Ürün, seçilen koşullara göre su verimliliği iyileştirmeye yardımcı olur.",
  visualSin:"AQUASOL olmadan tahmini tüketim", visualCon:"AQUASOL ile tahmini tüketim",
  agua:"TASARRUF EDİLEN SU", dinero:"EKONOMİK TASARRUF", eficiencia:"SU VERİMLİLİĞİ",
  hectarea:"HEKTAR BAŞINA TASARRUF", planta:"BİTKİ BAŞINA TASARRUF",
  dosis:"TAHMİNİ DOZ", dosisMec:"MEKANİZE DOZ",
  productoNecesario:"GEREKLİ ÜRÜN", formato:"ÖNERİLEN FORMAT",
  coste:"ÜRÜN MALİYETİ", beneficio:"AGRONOMİK FAYDA",
  roi:"POTANSİYEL GERİ DÖNÜŞ", roiSmall:"Tahmini ilerleyici bozunmaya göre düzeltilmiş",
  leadTitle:"SONUÇLARINI VE KİŞİSELLEŞTİRİLEN TEKLİFİ AL",
  leadText:"İşletmene uyarlanmış bir teklif almak için bilgilerini bırak.",
  empresa:"Şirket", nombre:"Ad soyad", telefono:"Telefon",
  presupuesto:"TEKLİF İSTE", imprimir:"YAZDIR / PDF",
  note:"*Gösterge niteliği taşıyan sonuçlar. HYDRO ve ECO suda ağırlıklarının 400 katına kadar tutabilir.",
  noAplica:"Geçerli değil", menorMortalidad:"Düşük ölüm oranı", plantasTxt:"bitki",
  saco1:"1 torba 1 kg", saco2:"1 torba 2 kg", saco5:"1 torba 5 kg", sacos25:"torba 25 kg",
  alertDatos:"Lütfen bilgilerinizi tamamlayın.", alertTodos:"Lütfen tüm verileri tamamlayın.",
  solicitud:"AQUASOL AGRO talebi",
  hastaReducir:"Seçiminize göre AQUASOL sulama suyu tüketimini yaklaşık olarak yüzde ",
  selectCultivo:"Bir ürün seçin.", selectProducto:"Bir ürün seçin.",
  selectAplicacion:"Bir uygulama türü seçin.", selectSuelo:"Toprak türünü seçin.",
  selectClima:"İklimi seçin.", selectSistema:"Sulama sistemini seçin.",
  selectEdad:"Bitki türünü seçin.",
  sinRiegoAviso:"Sabit sulama yok: su tasarrufu hesaplanmadı. ",
  precio0:"Fiyat 0: ekonomik tasarruf 0 olarak gösterildi. ",
  introSustrato:"Substrat hacmini m³ olarak girin. ",
  introPlantasHort:"Bitki sayısını girin. ",
  introM2:"Alanı m² olarak girin. ",
  introPlantasManual:"Bitki sayısını girin. ",
  introHaMec:"Hektarı girin. ",
  validaTecnica:"Bu kombinasyon için teknik doğrulama önerilir. ",
  introAgua:"Yıllık su tasarrufunu hesaplamak için hektar ve sulama bilgisi girin. ",
  introTronco:"Gövde çapını cm cinsinden girin. ",
  tronco:"Gövde çapı (cm)",
  smartQuestion:"AQUASOL AGRO Smart kullanacak mısınız?",
  smartApp:"Sadece uygulama (-10%)", smartSensors:"Uygulama + sensörler (-20%)", smartNo:"Hayır",
  smartExplain:"Farklı derinliklerdeki nem sensörlerinin kullanılması, sulamanın toprağın gerçek ihtiyaçlarına göre uyarlanmasını ve gereksiz sulamanın önlenmesini sağlar.",
  smartAdicionalLabel:"Sulama optimizasyonu ile tahmini ek tasarruf: %{pct}*",
  smartDisclaimer:"*Gösterge niteliğinde tahmin. Gerçek tasarruf; ürüne, toprağa, iklime, sulama sistemine ve işletmenin önceki yönetimine bağlıdır.",
  consumoActual:"MEVCUT TÜKETİM",
  ahorroAquasolSmart:"AQUASOL İLE TASARRUF",
  ahorroAdicionalSmart:"AQUASOL SMART İLE EK TASARRUF",
  consumoFinalEstimado:"TAHMİNİ NİHAİ TÜKETİM",
  ahorroTotalAgua:"TOPLAM SU TASARRUFU",
  finAquasolLabel:"AQUASOL sayesinde tasarruf:",
  finSmartLabel:"AQUASOL Smart sayesinde ek tasarruf:",
  finTotalLabel:"TOPLAM EKONOMİK TASARRUF",
  compSin:"AQUASOL OLMADAN", compCon:"AQUASOL İLE", compSmart:"AQUASOL + SMART İLE",
  smartHowTitle:"AQUASOL Smart daha da fazla suyu nasıl tasarruf ediyor?",
  smartHowText:"Toprağa yerleştirilen sensörler, farklı derinliklerdeki nem değişimini bilmeyi sağlar. AQUASOL Smart, bu verileri kullanarak sulamayı ürünün gerçek ihtiyaçlarına göre uyarlamaya yardımcı olur, gereksiz sulamayı önler ve kök bölgesinde tutulan sudan daha uzun süre yararlanılmasını sağlar.",
  smartBenefit1:"Toprak nem kontrolü",
  smartBenefit2:"Sulama zamanlamasının optimizasyonu",
  smartBenefit3:"Gereksiz sulamanın azaltılması",
  bDefT:"Daha iyi büyüme ve ürün kalitesi",
  bDefD:"Su tasarrufuna ek olarak daha güçlü bir bitki ve daha yüksek kaliteli hasatlar sağlayabilir.",
  bRefT:"Potansiyel olarak azaltılmış ölüm oranı", bRefD:"Kuru veya yangın sonrası alanlarda bitki hayatta kalmasını iyileştirmeye yardımcı olur.",
  bVivT:"Daha uniform ve güçlü bitkiler", bVivD:"Substrat içindeki daha stabil nem ortamını destekler.",
  bHortT:"Daha uniform ve verimli ürün", bHortD:"Su stresini azaltmaya ve dengeli bir gelişimi desteklemeye yardımcı olur.",
  bVinT:"Daha iyi asma tesisi", bVinD:"Kök gelişimini destekler ve su stresini azaltır.",
  refCap:"TUTMA KAPASİTESİ", refBenef:"ANA FAYDA",
  refEstres:"POTANSİYEL SU STRESİ AZALTMASI",
  refSuper:"POTANSİYEL HAYATTA KALMA İYİLEŞTİRMESİ", refPlant:"FAYDA GÖREBİLECEK BİTKİLER",
  indexBad:"Önemli su kayıpları", indexC:"İyileştirme potansiyeli", indexB:"İyi tasarruf potansiyeli", indexA:"Çok iyi su tutma", indexAplus:"Mükemmel su verimliliği",
  indexExplain:"AQUASOL INDEX™, işletmenin su tasarrufu potansiyelini ürün, toprak, iklim ve sulama sistemine göre değerlendirir. Daha yüksek not, daha iyi su tutma, daha düşük su stresi ve daha yüksek sulama verimliliği anlamına gelir.",

  
  
  ahorroM2:'m² BAŞINA TASARRUF',
  ahorroTotal:'TOPLAM TASARRUF',
  ahorroM3:'SUBSTRAT m³ BAŞINA TASARRUF',
  ahorroTotalHort:'TOPLAM TASARRUF',
  ahorroPlantaHort:'BİTKİ BAŞINA TASARRUF',
  
  reforestacionAviso:'Ağaçlandırma için AQUASOL, bitki ölümünü ve başlangıç sulama sayısını azaltır, toplam su tüketimini değil.',
  
  histTitle:'SON HESAPLAMALAR',
  histClear:'Geçmişi temizle',
  quoteBtn:'Bu verilerle teklif isteyin',
  autoRiegoBtn:'Tüketimimi bilmiyorum — tahmin et',
  autoRiegoTip:'Ürüne göre otomatik tahmin',
  
  year:'Yıl',
  roiMin:'Min ROI',
  roiMax:'Maks ROI',
  
  arbolJoven:'Genç ağaç (+120 cm)',
  
  precio0agro:'Su fiyatı girilmedi: ürünün tarımsal faydalarını gösteriyoruz.',
  bAgro1T:'Su stresinin azaltılması',
  bAgro1D:'Su stresini %{stress} oranında azaltabilir.',
  bAgro2T:'Bitki ölüm oranının düşürülmesi',
  bAgro2D:'Genç fidanlarda {mort} daha az ölüm oranı.',
  bAgro3T:'Daha iyi kök gelişimi',
  bAgro3D:'Kök sistemi {rac} daha derin ve dallı.',
  bAgro4T:'Daha kaliteli üretim',
  bAgro4D:'Meyve büyüklüğünde {qual} iyileşme.',
  bAgro5T:'Daha fazla ürün üniformitesi',
  bAgro5D:'Bitkiler arası değişkenlikte {uni}% azalma.',
  bAgro6T:'Mevcut suyun optimizasyonu',
  bAgro6D:'400× ağırlığında su tutar. Buharlaşma kayıplarını {evap} azaltır.',
  uAgua:"m³/yıl", uHa:"ha", uPlanta:"bitki", perYear:"yıl",
  olivos:'Zeytin ağaçları',citricos:'Narenciye',vinedos:'Bağ',horticultura:'Bahçecilik',
  viveros:'Fidanlık',almendros:'Badem ve diğerleri',palmeras:'Palmiye ağaçları',cerezos:'Kiraz ağaçları',reforestacion:'Ağaçlandırma',
  manzano:'Elma ağaçları',peral:'Armut ağaçları',melocotonero:'Şeftali ağaçları ve diğerleri'
};

// ── HELPER FUNCTIONS ──
var L = TXT[AA_LANG] || TXT.es;
function tr(k){ return L[k] !== undefined ? L[k] : (TXT.es[k] || k); }
function setHTML(id,val){ var el=document.getElementById(id); if(el) el.innerHTML=val; }
function setPH(id,val){ var el=document.getElementById(id); if(el) el.placeholder=val; }
function opt(v,t,sel){ return '<option value="'+v+'"'+(sel?' selected':'')+'>'+t+'</option>'; }
function def(t){ return '<option value="" selected disabled>'+t+'</option>'; }
function fmt(n){
  if(n>=10000) return Math.round(n/100)*100;
  if(n>=1000)  return Math.round(n/10)*10;
  if(n>=100)   return Math.round(n);
  if(n>=10)    return parseFloat(n.toFixed(1));
  if(n>=0.01)  return parseFloat(n.toFixed(2));
  if(n>=0.001) return parseFloat(n.toFixed(4));
  return parseFloat(n.toFixed(6));
}
function fmtD(n){ return n.toFixed(1); }





// ════════════════════════════════════════════════════════════
// GRÁFICO ROI — SVG natif, sans dépendance
// ════════════════════════════════════════════════════════════
function renderROIChart(rMin1, rMax1, dMin, dMax){
  var wrap = document.getElementById('aa_roi_chart_wrap');
  var container = document.getElementById('aa_roi_chart');
  if(!wrap || !container) return;
  wrap.style.display = 'block';

  var CN_local = typeof CN !== 'undefined' ? CN : '€';
  var years = [1,2,3,4,5];
  // ROI cumulé — valeurs négatives autorisées (coût > ahorro les premières années)
  var roiMin = years.map(function(y){ return Math.round(rMin1 + (dMin * (y-1))); });
  var roiMax = years.map(function(y){ return Math.round(rMax1 + (dMax * (y-1))); });
  var allVals = roiMin.concat(roiMax);
  var maxVal = Math.max.apply(null, allVals.concat([0]));
  var minVal = Math.min.apply(null, allVals.concat([0]));
  var range = maxVal - minVal || 1;

  var W=560, H=220, PL=90, PR=20, PT=20, PB=45;
  var chartW=W-PL-PR, chartH=H-PT-PB;
  var groupW=chartW/5, barW=Math.floor(groupW*0.28), gap=Math.floor(groupW*0.06);
  // Y position of zero line
  var zeroY = Math.round(PT + chartH * maxVal / range);

  var s = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 '+W+' '+H+'" width="'+W+'" height="'+H+'" style="max-width:100%;display:block;overflow:visible;">';

  // Grid lines + Y labels (5 steps from min to max)
  for(var g=0;g<=4;g++){
    var yv = Math.round(minVal + range*g/4);
    var ypx = Math.round(PT + chartH - chartH*(yv - minVal)/range);
    var isZero = (yv === 0 || (g > 0 && Math.sign(minVal + range*(g-1)/4) !== Math.sign(yv)));
    s += '<line x1="'+PL+'" y1="'+ypx+'" x2="'+(W-PR)+'" y2="'+ypx+'" stroke="'+(isZero?'#9ca3af':'#e5e7eb')+'" stroke-width="'+(isZero?'1.5':'1')+'"/>';
    s += '<text x="'+(PL-6)+'" y="'+(ypx+4)+'" text-anchor="end" font-size="9" fill="'+(isZero?'#374151':'#9ca3af')+'" font-family="Arial,sans-serif">'+fmt(yv)+CN_local+'</text>';
  }

  // Zero line (explicit)
  if(minVal < 0 && maxVal > 0){
    s += '<line x1="'+PL+'" y1="'+zeroY+'" x2="'+(W-PR)+'" y2="'+zeroY+'" stroke="#6b7280" stroke-width="1.5" stroke-dasharray="4,3"/>';
    s += '<text x="'+(PL-6)+'" y="'+(zeroY+4)+'" text-anchor="end" font-size="9" fill="#374151" font-weight="700" font-family="Arial,sans-serif">0</text>';
  }

  // Bars
  for(var i=0;i<5;i++){
    var xC=Math.round(PL+(i+0.5)*groupW);
    var x1=xC-barW-gap, x2=xC+gap;

    // Bar MIN
    var vMin = roiMin[i];
    var barYMin, barHMin;
    if(vMin >= 0){
      barHMin = Math.max(Math.round(chartH*vMin/range), 2);
      barYMin = zeroY - barHMin;
    } else {
      barHMin = Math.max(Math.round(chartH*Math.abs(vMin)/range), 2);
      barYMin = zeroY;
    }
    var fillMin = vMin >= 0 ? '#d4e8f7' : '#fcd5d5';
    var strokeMin = vMin >= 0 ? '#0b1733' : '#c0392b';
    s += '<rect x="'+x1+'" y="'+barYMin+'" width="'+barW+'" height="'+barHMin+'" rx="4" fill="'+fillMin+'" stroke="'+strokeMin+'" stroke-width="1.5"/>';
    var labelYMin = vMin >= 0 ? barYMin-4 : barYMin+barHMin+12;
    s += '<text x="'+(x1+Math.round(barW/2))+'" y="'+labelYMin+'" text-anchor="middle" font-size="9" fill="'+strokeMin+'" font-weight="700" font-family="Arial,sans-serif">'+fmt(vMin)+'</text>';

    // Bar MAX
    var vMax = roiMax[i];
    var barYMax, barHMax;
    if(vMax >= 0){
      barHMax = Math.max(Math.round(chartH*vMax/range), 2);
      barYMax = zeroY - barHMax;
    } else {
      barHMax = Math.max(Math.round(chartH*Math.abs(vMax)/range), 2);
      barYMax = zeroY;
    }
    var fillMax = vMax >= 0 ? '#b8e0a0' : '#fcd5d5';
    var strokeMax = vMax >= 0 ? '#579821' : '#c0392b';
    s += '<rect x="'+x2+'" y="'+barYMax+'" width="'+barW+'" height="'+barHMax+'" rx="4" fill="'+fillMax+'" stroke="'+strokeMax+'" stroke-width="1.5"/>';
    var labelYMax = vMax >= 0 ? barYMax-4 : barYMax+barHMax+12;
    s += '<text x="'+(x2+Math.round(barW/2))+'" y="'+labelYMax+'" text-anchor="middle" font-size="9" fill="'+strokeMax+'" font-weight="700" font-family="Arial,sans-serif">'+fmt(vMax)+'</text>';

    // X label
    s += '<text x="'+xC+'" y="'+(PT+chartH+16)+'" text-anchor="middle" font-size="11" fill="#6b7280" font-family="Arial,sans-serif">'+(tr('year')||'Año')+' '+(i+1)+'</text>';
  }

  // Axes
  s += '<line x1="'+PL+'" y1="'+(PT+chartH)+'" x2="'+(W-PR)+'" y2="'+(PT+chartH)+'" stroke="#9ca3af" stroke-width="1.5"/>';
  s += '<line x1="'+PL+'" y1="'+PT+'" x2="'+PL+'" y2="'+(PT+chartH)+'" stroke="#9ca3af" stroke-width="1.5"/>';

  // Legend
  var ly=H-8;
  s += '<rect x="'+PL+'" y="'+(ly-9)+'" width="11" height="11" rx="2" fill="#d4e8f7" stroke="#0b1733" stroke-width="1"/>';
  s += '<text x="'+(PL+15)+'" y="'+ly+'" font-size="10" fill="#374151" font-family="Arial,sans-serif">'+(tr('roiMin')||'ROI mínimo')+' ('+CN_local+')</text>';
  s += '<rect x="'+(PL+150)+'" y="'+(ly-9)+'" width="11" height="11" rx="2" fill="#b8e0a0" stroke="#579821" stroke-width="1"/>';
  s += '<text x="'+(PL+165)+'" y="'+ly+'" font-size="10" fill="#374151" font-family="Arial,sans-serif">'+(tr('roiMax')||'ROI máximo')+' ('+CN_local+')</text>';

  s += '</svg>';
  container.innerHTML = s;
}


// ════════════════════════════════════════════════════════════
// BÉNÉFICES AGRONOMIQUES DYNAMIQUES (prix eau = 0)
// ════════════════════════════════════════════════════════════
function calcAgroBenefits(ef, s, cl, c, aMin, aMax){
  var efMin = ef.min, efMax = ef.max;

  // ── 1. Réduction stress hydrique ──
  var stressMin = Math.round(efMin * 100);
  var stressMax = Math.round(efMax * 100);
  // Bonus sol arenoso/pedregoso → stress plus marqué → réduction plus importante
  if(s==='arenoso'||s==='pedregoso'||s==='salino') { stressMin+=5; stressMax+=10; }
  // Bonus climat très sec
  if(cl==='muyseco') { stressMin+=5; stressMax+=10; }
  stressMin = Math.min(stressMin, 55); stressMax = Math.min(stressMax, 65);
  var stress1 = stressMin+'-'+stressMax+'%';

  // ── 2. Mortalité plants ──
  // Plus élevé si jeune plantation / reforestacion
  var mortMin = 15, mortMax = 35;
  if(c==='reforestacion'){ mortMin=25; mortMax=50; }
  if(cl==='muyseco'||s==='arenoso') { mortMin+=5; mortMax+=5; }
  mortMin = Math.min(mortMin,40); mortMax = Math.min(mortMax,60);
  var mort1 = mortMin+'-'+mortMax+'%';

  // ── 3. Développement racinaire ──
  var racMin = 15, racMax = 25;
  if(s==='arenoso'||s==='pedregoso'){ racMin+=5; racMax+=8; }
  racMin = Math.min(racMin,30); racMax = Math.min(racMax,38);
  var rac1 = racMin+'-'+racMax+'%';

  // ── 4. Qualité production ──
  var qualMin = 5, qualMax = 12;
  if(c==='citricos'||c==='cerezos'||c==='vinedos'||c==='manzano'||c==='peral'){ qualMin=8; qualMax=18; }
  if(efMax>=0.25){ qualMin+=2; qualMax+=3; }
  qualMin = Math.min(qualMin,18); qualMax = Math.min(qualMax,25);
  var qual1 = qualMin+'-'+qualMax+'%';

  // ── 5. Uniformité ──
  var uniMin = 15, uniMax = 25;
  if(efMax>=0.25||s==='arenoso'){ uniMax+=5; }
  uniMax = Math.min(uniMax,35);
  var uni1 = uniMin+'-'+uniMax+'%';

  // ── 6. Rétention eau ──
  var evapMin = 20, evapMax = 35;
  if(s==='arenoso'||s==='pedregoso'){ evapMin=25; evapMax=40; }
  if(cl==='muyseco'){ evapMax+=5; }
  evapMin = Math.min(evapMin,35); evapMax = Math.min(evapMax,50);
  var evap1 = evapMin+'-'+evapMax+'%';

  // ── m³ économisés pour le bénéfice eau ──
  var aguaTxt = aMin>0 ? Math.round(aMin)+' - '+Math.round(aMax)+' m³/'+tr('perYear') : '';

  return [
    { t: tr('bAgro1T'), d: tr('bAgro1D').replace('{stress}', stress1) },
    { t: tr('bAgro2T'), d: tr('bAgro2D').replace('{mort}', mort1) },
    { t: tr('bAgro3T'), d: tr('bAgro3D').replace('{rac}', rac1) },
    { t: tr('bAgro4T'), d: tr('bAgro4D').replace('{qual}', qual1) },
    { t: tr('bAgro5T'), d: tr('bAgro5D').replace('{uni}', uniMax) },
    { t: tr('bAgro6T'), d: tr('bAgro6D').replace('{evap}', evap1) },
  ];
}

// ── BACK BUTTON ──
function isAquasolCalculatorPage(){
  var path = (window.location.pathname || '').toLowerCase();

  return (
    path.indexOf('/pages/calculadora') !== -1 ||
    path.indexOf('/pages/calculateur') !== -1 ||
    path.indexOf('/pages/calculator') !== -1 ||
    path.indexOf('/pages/calcolatore') !== -1 ||
    path.indexOf('/pages/calculadora-ahorro') !== -1 ||
    path.indexOf('/pages/calculateur-economies') !== -1 ||
    path.indexOf('/pages/calculate-your-savings') !== -1 ||
    path.indexOf('/pages/calculo') !== -1 ||
    path.indexOf('/pages/حاسبة') !== -1
  );
}

function findCalculatorPageTitle(){
  var candidates = document.querySelectorAll('main h1, main .main-page-title, main .page-title, .shopify-section h1, h1');
  for(var i=0;i<candidates.length;i++){
    var txt = (candidates[i].innerText || candidates[i].textContent || '').toLowerCase();
    if(
      txt.indexOf('calcul') !== -1 ||
      txt.indexOf('ahorro') !== -1 ||
      txt.indexOf('économie') !== -1 ||
      txt.indexOf('economies') !== -1 ||
      txt.indexOf('savings') !== -1 ||
      txt.indexOf('حساب') !== -1 ||
      txt.indexOf('حاسبة') !== -1
    ){
      return candidates[i];
    }
  }
  return document.querySelector('main h1, h1');
}

function ensureBackButton(){
  if(!isAquasolCalculatorPage()) return;
  if(document.getElementById('aa_back_btn')) return;

  var calculator =
    document.getElementById('aquasol-calculator') ||
    document.querySelector('.aquasol-calculator') ||
    document.querySelector('.aa-container');

  var title = findCalculatorPageTitle();

  if(!calculator && !title) return;

  var wrap = document.createElement('div');
  wrap.className = 'aa-back-wrap';
  wrap.innerHTML =
    '<a href="/pages/cultivos" id="aa_back_btn" class="aa-back-btn">' +
    '<span class="aa-back-icon">←</span>' +
    '<span id="aa_back_text"></span>' +
    '</a>';

  if(title && title.parentNode){
    title.parentNode.insertBefore(wrap, title);
  } else if(calculator){
    calculator.insertBefore(wrap, calculator.firstChild);
  }

  if(!document.getElementById('aa_back_style')){
    var st = document.createElement('style');
    st.id = 'aa_back_style';
    st.textContent =
      '.aa-back-wrap{display:flex!important;justify-content:flex-start!important;align-items:center!important;width:100%!important;margin:0 0 24px!important;padding:0!important;text-align:left!important;}' +
      '.aa-back-btn{display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:8px!important;background:#f7faf5!important;color:#0b1733!important;border:1px solid #dff0d4!important;padding:12px 22px!important;border-radius:40px!important;text-decoration:none!important;font-weight:800!important;font-size:16px!important;box-shadow:0 5px 18px rgba(0,0,0,.06)!important;transition:.3s!important;}' +
      '.aa-back-btn:hover{transform:translateX(-5px)!important;background:#eaf6e3!important;}' +
      '.aa-back-icon{font-size:18px!important;line-height:1!important;}' +
      '.aa-rtl .aa-back-wrap{justify-content:flex-end!important;text-align:right!important;}' +
      '.aa-rtl .aa-back-btn{direction:rtl!important;}' +
      '.aa-rtl .aa-back-btn:hover{transform:translateX(5px)!important;}';
    document.head.appendChild(st);
  }

  var btn = document.getElementById('aa_back_btn');
  if(btn){
    btn.addEventListener('click', function(e){
      if(document.referrer && document.referrer.indexOf(location.hostname) !== -1){
        e.preventDefault();
        history.back();
      }
    });
  }

  if(document.getElementById('aa_back_text')){
    setHTML('aa_back_text', tr('back'));
  }
}


// ── APPLY TRANSLATIONS ──
function applyTranslations(){
  ensureBackButton();
  if(document.getElementById('aa_back_text')) setHTML('aa_back_text', tr('back'));
setHTML('aa_title', tr('title'));
  setHTML('aa_subtitle', tr('subtitle'));
  setHTML('aa_calcular', tr('calcular'));
  setHTML('aa_visual_sin', tr('visualSin'));
  setHTML('aa_visual_con', tr('visualCon'));
  setHTML('aa_impactText', tr('impactBase'));
  setHTML('aa_label_agua', tr('agua'));
  setHTML('aa_label_dinero', tr('dinero'));
  setHTML('aa_label_eficiencia', tr('eficiencia'));
  setHTML('aa_label_hectarea', tr('hectarea'));
  setHTML('aa_label_planta', tr('planta'));
  setHTML('aa_label_dosis', tr('dosis'));
  setHTML('aa_label_producto_necesario', tr('productoNecesario'));
  setHTML('aa_label_formato', tr('formato'));
  setHTML('aa_label_coste', tr('coste'));
  setHTML('aa_label_beneficio', tr('beneficio'));
  setHTML('aa_label_roi', tr('roi'));
  setHTML('aa_roiSmall', tr('roiSmall'));
  setHTML('aa_lead_title', tr('leadTitle'));
  setHTML('aa_lead_text', tr('leadText'));
  setHTML('aa_presupuesto', tr('presupuesto'));
  setHTML('aa_imprimir', tr('imprimir'));
  setHTML('aa_note', tr('note'));
  setPH('aa_hectareas', tr('hectareas'));
  setPH('aa_m2', tr('m2'));
  setPH('aa_sustrato', tr('sustrato'));
  setPH('aa_plantas', tr('plantas'));
  setPH('aa_riego', tr('riego'));
  setPH('aa_tronco', tr('tronco'));
  setHTML('aa_smart_question', tr('smartQuestion'));
  setHTML('aa_smart_app', tr('smartApp'));
  setHTML('aa_smart_sensors', tr('smartSensors'));
  setHTML('aa_smart_no', tr('smartNo'));
  setHTML('aa_smart_explain', tr('smartExplain'));
  setHTML('aa_smart_disclaimer', tr('smartDisclaimer'));
  setHTML('aa_lbl_consumoActual', tr('consumoActual'));
  setHTML('aa_lbl_ahorroAquasol', tr('ahorroAquasolSmart'));
  setHTML('aa_lbl_ahorroSmart', tr('ahorroAdicionalSmart'));
  setHTML('aa_lbl_consumoFinal', tr('consumoFinalEstimado'));
  setHTML('aa_lbl_ahorroTotalAgua', tr('ahorroTotalAgua'));
  setHTML('aa_lbl_finAquasol', tr('finAquasolLabel'));
  setHTML('aa_lbl_finSmart', tr('finSmartLabel'));
  setHTML('aa_lbl_finTotal', tr('finTotalLabel'));
  setHTML('aa_lbl_compSin', tr('compSin'));
  setHTML('aa_lbl_compCon', tr('compCon'));
  setHTML('aa_lbl_compSmart', tr('compSmart'));
  setHTML('aa_lbl_smartHowTitle', tr('smartHowTitle'));
  setHTML('aa_smartHowText', tr('smartHowText'));
  setHTML('aa_smartBenefit1', '💧 '+tr('smartBenefit1'));
  setHTML('aa_smartBenefit2', '⏱️ '+tr('smartBenefit2'));
  setHTML('aa_smartBenefit3', '🚫 '+tr('smartBenefit3'));
  // New feature button labels
  var autoBtn = document.getElementById('aa_autoRiegoBtn');
  if(autoBtn) autoBtn.textContent = tr('autoRiegoBtn');
  var shareBtn = document.getElementById('aa_share_btn');
  if(shareBtn) shareBtn.textContent = tr('shareCopied') ? '🔗 Compartir resultados' : '🔗 Share';
  var quoteBtn = document.getElementById('aa_quote_btn');
  if(quoteBtn) quoteBtn.textContent = tr('quoteBtn');
  var histBox = document.getElementById('aa_historial');
  if(histBox) renderHistory();
  setPH('aa_precio', tr('precio'));
  // Update precio placeholder avec devise locale
  var prEl = document.getElementById('aa_precio');
  if(prEl && CN && CN !== '€'){
    prEl.placeholder = tr('precio');
  }
  setPH('aa_empresa', tr('empresa'));
  setPH('aa_nombre', tr('nombre'));
  setPH('aa_telefono', tr('telefono'));
  setPH('aa_email', 'Email');

  document.getElementById('aa_cultivo').innerHTML =
    def(tr('cultivo')) +
    opt('olivos','\ud83e\uded2 '+tr('olivos')) +
    opt('citricos','\ud83c\udf4a '+tr('citricos')) +
    opt('vinedos','\ud83c\udf47 '+tr('vinedos')) +
    opt('horticultura','\ud83e\udd6c '+tr('horticultura')) +
    opt('viveros','\ud83e\udeb4 '+tr('viveros')) +
    opt('almendros_otros','\ud83c\udf33 '+tr('almendros')) +
    opt('manzano','\ud83c\udf4e '+tr('manzano')) +
    opt('peral','\ud83c\udf50 '+tr('peral')) +
    opt('melocotonero','\ud83c\udf51 '+tr('melocotonero')) +
    opt('palmeras','\ud83c\udf34 '+tr('palmeras')) +
    opt('cerezos','\ud83c\udf52 '+tr('cerezos')) +
    opt('reforestacion','\ud83c\udf32 '+tr('reforestacion'));

  document.getElementById('aa_aplicacion').innerHTML =
    def(tr('aplicacion')) + opt('manual',tr('manualApp')) + opt('mecanizada',tr('mecanizada'));
  document.getElementById('aa_suelo').innerHTML =
    def(tr('suelo')) + opt('franco',tr('franco')) + opt('arenoso',tr('arenoso')) +
    opt('pedregoso',tr('pedregoso')) + opt('arcilloso',tr('arcilloso')) +
    opt('salino',tr('salino'));
  var ecEl = document.getElementById('aa_ec');
  if(ecEl){
    ecEl.innerHTML = def(tr('ecLabel')) + opt('0',tr('ec0')) + opt('2',tr('ec2')) + opt('4',tr('ec4')) + opt('8',tr('ec8'));
  }
  document.getElementById('aa_clima').innerHTML =
    def(tr('clima')) + opt('medio',tr('medio')) + opt('seco',tr('seco')) + opt('muyseco',tr('muyseco'));
  // Edad options: for reforestacion, replace 'adulto' with 'arbol_joven'
  var cultivo_val = document.getElementById('aa_cultivo').value;
  if(cultivo_val === 'reforestacion'){
    document.getElementById('aa_edad').innerHTML =
      def(tr('edad')) + opt('joven',tr('joven')) + opt('desarrollo',tr('desarrollo')) + opt('adulto',tr('arbolJoven'));
  } else {
    document.getElementById('aa_edad').innerHTML =
      def(tr('edad')) + opt('joven',tr('joven')) + opt('desarrollo',tr('desarrollo')) + opt('adulto',tr('adulto'));
  }

  if(AA_LANG === 'ar'){ document.getElementById('aquasol-calculator').classList.add('aa-rtl'); }
  var b = getBeneficio('');
  setHTML('aa_beneficioResultado', b.t);
  setHTML('aa_beneficioDetalle', b.d);
}

// ── AQUASOL SMART (app + capteurs d'humidité) ──
// Hypothèse d'économie d'eau additionnelle, appliquée SUR l'eau restante après AQUASOL
// (calcul multiplicatif, pas additif). Facilement modifiable ici quand les essais terrain
// fourniront des résultats réels.
// App seule : pas de données d'humidité du sol → économie plus modeste (5%).
// App + capteurs : optimisation réelle du riego grâce aux données de terrain (15%).
var AQUASOL_SMART_CONFIG = {
  estimatedWaterSavingApp: 0.05,     // App sola, sans capteurs
  estimatedWaterSavingSensors: 0.15, // App + capteurs
  minEstimatedSaving: 0.10,
  maxEstimatedSaving: 0.25
};
var APP_WATER_SAVING_RATE = AQUASOL_SMART_CONFIG.estimatedWaterSavingSensors;

function isSmartSelected(){
  var tier = getSmartTier();
  return tier !== 'none';
}

// Renvoie le taux d'économie d'eau additionnelle selon le palier Smart choisi
function getSmartWaterSavingRate(){
  var tier = getSmartTier();
  if(tier === 'sensors') return AQUASOL_SMART_CONFIG.estimatedWaterSavingSensors;
  if(tier === 'app') return AQUASOL_SMART_CONFIG.estimatedWaterSavingApp;
  return 0;
}

// Renvoie 'none' | 'app' | 'sensors' selon le bouton actif dans le toggle à 3 options
function getSmartTier(){
  var sensorsBtn = document.getElementById('aa_smart_sensors');
  var appBtn = document.getElementById('aa_smart_app');
  if(sensorsBtn && sensorsBtn.classList.contains('active')) return 'sensors';
  if(appBtn && appBtn.classList.contains('active')) return 'app';
  return 'none';
}

// Remise produit selon le palier : app seule = -10%, app + capteurs = -20%
function getSmartDiscountRate(){
  var tier = getSmartTier();
  if(tier === 'sensors') return 0.20;
  if(tier === 'app') return 0.10;
  return 0;
}

// conBase = consommation initiale (m³), hydrogelRate = ef.max (fraction économisée par AQUASOL seul)
function updateSmartSection(conBase, hydrogelRate, pr){
  var section = document.getElementById('aa_smart_results');
  if(!section) return; // le bloc HTML n'a pas encore été ajouté à la page

  if(!conBase || conBase<=0 || !hydrogelRate || hydrogelRate<=0){
    section.style.display = 'none';
    return;
  }

  var smartTier = getSmartTier();
  var smartOn = smartTier !== 'none';
  var appRate = getSmartWaterSavingRate();

  var remainingAfterHydrogel = conBase * (1 - hydrogelRate);
  var waterSavedHydrogel = conBase - remainingAfterHydrogel;
  var finalConsumption = remainingAfterHydrogel * (1 - appRate);
  var waterSavedApp = remainingAfterHydrogel - finalConsumption;
  var totalWaterSaved = conBase - finalConsumption;
  var totalSavingRate = totalWaterSaved / conBase;

  setHTML('aa_consumoActualResultado', fmt(conBase)+' '+tr('uAgua'));
  setHTML('aa_ahorroAquasolSmartResultado', fmt(waterSavedHydrogel)+' '+tr('uAgua'));
  setHTML('aa_ahorroSmartResultado', fmt(waterSavedApp)+' '+tr('uAgua'));
  setHTML('aa_consumoFinalResultado', fmt(finalConsumption)+' '+tr('uAgua'));
  setHTML('aa_ahorroTotalAguaResultado', fmt(totalWaterSaved)+' '+tr('uAgua')+' ('+Math.round(totalSavingRate*100)+'%)');

  setHTML('aa_compSinVal', fmt(conBase)+' '+tr('uAgua'));
  setHTML('aa_compConVal', fmt(remainingAfterHydrogel)+' '+tr('uAgua'));
  setHTML('aa_compSmartVal', fmt(finalConsumption)+' '+tr('uAgua'));

  var adicionalRow = document.getElementById('aa_smart_adicional_row');
  if(adicionalRow) adicionalRow.style.display = smartOn ? '' : 'none';
  var compSmartCol = document.getElementById('aa_comp_smart_col');
  if(compSmartCol) compSmartCol.style.display = smartOn ? '' : 'none';
  var smartHow = document.getElementById('aa_smart_how');
  if(smartHow) smartHow.style.display = smartOn ? '' : 'none';
  var adicionalLabel = document.getElementById('aa_smart_adicional_label');
  if(adicionalLabel){
    adicionalLabel.style.display = smartOn ? '' : 'none';
    setHTML('aa_smart_adicional_label', tr('smartAdicionalLabel').replace('{pct}', Math.round(appRate*100)));
  }

  var finCard = document.getElementById('aa_smart_financial');
  if(finCard){
    if(pr>0){
      finCard.style.display = '';
      setHTML('aa_finAquasolResultado', fmt(waterSavedHydrogel*pr)+' '+CN+'/'+tr('perYear'));
      setHTML('aa_finSmartResultado', fmt(waterSavedApp*pr)+' '+CN+'/'+tr('perYear'));
      setHTML('aa_finTotalResultado', fmt(totalWaterSaved*pr)+' '+CN+'/'+tr('perYear'));
      var finSmartRow = document.getElementById('aa_fin_smart_row');
      if(finSmartRow) finSmartRow.style.display = smartOn ? '' : 'none';
    } else {
      finCard.style.display = 'none';
    }
  }

  section.style.display = 'block';
}

// ── PRICES EN EUR (base) ──
// Prix HT d'origine (sans remise) — mise à jour du 16/09/2026
var PRICES_EUR = {
  hydro:{kg1:18.90,kg2:17.45,kg5:16.50,kg25:14.90},
  eco:{kg1:17.90,kg2:16.45,kg5:14.50,kg25:13.90},
  sal:{kg1:21.90,kg2:19.95,kg5:17.98,kg25:15.96}
};

// Prix convertis en devise locale (recalculés à chaque fois que CN change)
function getLocalPrices() {
  var p = {};
  ['hydro','eco','sal'].forEach(function(prod) {
    p[prod] = {};
    ['kg1','kg2','kg5','kg25'].forEach(function(fmt) {
      p[prod][fmt] = toLocalCurrency(PRICES_EUR[prod][fmt]);
    });
  });
  return p;
}

// Alias pour compatibilité
var PRICES = PRICES_EUR;

function updateProducts(){
  var c = document.getElementById('aa_cultivo').value;
  var suelo = document.getElementById('aa_suelo') ? document.getElementById('aa_suelo').value : '';
  var p = document.getElementById('aa_producto');
  p.innerHTML = def(tr('producto'));
  // Sol salin : AQUASOL SAL devient le produit par défaut et unique, quel que soit le cultivo
  if(suelo === 'salino' && c){
    p.innerHTML += opt('sal','AQUASOL SAL');
    p.value = 'sal';
    return;
  }
  if(c==='horticultura'){
    p.innerHTML += opt('eco','AQUASOL ECO');
    p.value = 'eco';
  }
  else if(c==='viveros'){
    p.innerHTML += opt('eco','AQUASOL ECO') + opt('hydro','AQUASOL HYDRO');
    p.value = 'eco';
  }
  else if(c){
    p.innerHTML += opt('hydro','AQUASOL HYDRO');
    p.value = 'hydro';
  }
}

function updateSistema(){
  var c = document.getElementById('aa_cultivo').value;
  var s = document.getElementById('aa_sistema');
  if(c==='reforestacion'){ s.innerHTML = opt('sinriego',tr('sinriego'),true); s.value='sinriego'; }
  else{ s.innerHTML = def(tr('sistema'))+opt('goteo',tr('goteo'))+opt('manual',tr('manual'))+opt('aspersion',tr('aspersion'))+opt('sinriego',tr('sinriego')); }
}

function isArbol(c){ return ['olivos','citricos','vinedos','almendros_otros','palmeras','cerezos','reforestacion','manzano','peral','melocotonero'].includes(c); }

function updateCampos(){
  var c = document.getElementById('aa_cultivo').value;
  var a = document.getElementById('aa_aplicacion').value;
  var e = document.getElementById('aa_edad') ? document.getElementById('aa_edad').value : '';
  ['aa_hectareas','aa_m2','aa_sustrato','aa_plantas','aa_edad','aa_riego','aa_precio'].forEach(function(id){
    document.getElementById(id).classList.add('aa-hidden');
  });
  // Champ diamètre du tronc : uniquement pour les arbres adultes (hors reforestación,
  // qui utilise une catégorie de taille fixe et non une mesure de tronc)
  var troncoField = document.getElementById('aa_tronco');
  if(troncoField){
    if(isArbol(c) && c!=='reforestacion' && e==='adulto'){
      troncoField.classList.remove('aa-hidden');
    } else {
      troncoField.classList.add('aa-hidden');
    }
  }
  // Champ CE (conductivité électrique) : uniquement si le sol sélectionné est "salino"
  var ecField = document.getElementById('aa_ec');
  if(ecField){
    var sueloVal = document.getElementById('aa_suelo') ? document.getElementById('aa_suelo').value : '';
    if(sueloVal === 'salino'){
      ecField.classList.remove('aa-hidden');
    } else {
      ecField.classList.add('aa-hidden');
    }
  }
  if(c==='viveros'){
    ['aa_sustrato','aa_riego','aa_precio'].forEach(function(id){ document.getElementById(id).classList.remove('aa-hidden'); });
    // Placeholder spécifique viveros pour le riego
    var rEl = document.getElementById('aa_riego');
    if(rEl) rEl.placeholder = 'Riego m³/ha/año';
  }
  else if(c==='horticultura'&&a==='manual'){
    ['aa_hectareas','aa_plantas','aa_riego','aa_precio'].forEach(function(id){ document.getElementById(id).classList.remove('aa-hidden'); });
    // Placeholder riego = m³ total de l'exploitation/an
    var rEl = document.getElementById('aa_riego');
    if(rEl) rEl.placeholder = 'Riego m³/ha/año';
  }
  else if(c==='horticultura'&&a==='mecanizada'){ ['aa_hectareas','aa_riego','aa_precio'].forEach(function(id){ document.getElementById(id).classList.remove('aa-hidden'); }); }
  else if(c==='reforestacion'&&a==='manual'){ ['aa_plantas','aa_edad'].forEach(function(id){ document.getElementById(id).classList.remove('aa-hidden'); }); }
  else if(c==='reforestacion'&&a==='mecanizada'){ ['aa_hectareas','aa_plantas','aa_edad'].forEach(function(id){ document.getElementById(id).classList.remove('aa-hidden'); }); }
  else if(isArbol(c)){ ['aa_hectareas','aa_plantas','aa_edad','aa_riego','aa_precio'].forEach(function(id){ document.getElementById(id).classList.remove('aa-hidden'); }); }
}

// ── DOSIS POR ÁRBOL (aplicación manual) ──
// Doses officielles fournisseur, vérifiées sur les pages produit (cultivos) — corrigées le 15/09/2026
// joven / desarrollo : poids fixe par árbol
// adulto : dose VARIABLE = tasa (g) × diámetro del tronco (cm). Ex: olivo adulto 50cm = 10*50 = 500g
// Exception reforestación : "adulto" ici représente "árbol joven +120cm", poids fixe (50g), pas une mesure de tronc.
function dosisArbol(c,e,diametro){
  var t={
    olivos:          {joven:10, desarrollo:100, adulto:10},
    citricos:        {joven:10, desarrollo:100, adulto:10},
    almendros_otros: {joven:10, desarrollo:100, adulto:10},
    cerezos:         {joven:10, desarrollo:100, adulto:10},
    vinedos:         {joven:10, desarrollo:80,  adulto:10},
    palmeras:        {joven:15, desarrollo:150, adulto:10},
    reforestacion:   {joven:10, desarrollo:20,  adulto:50}, // adulto = valeur fixe (árbol joven +120cm)
    manzano:         {joven:12, desarrollo:120, adulto:12},
    peral:           {joven:12, desarrollo:120, adulto:12},
    melocotonero:    {joven:7,  desarrollo:70,  adulto:7}
  };
  if(!t[c]){
    return e==='adulto' ? 10*(diametro||0) : 10;
  }
  if(e==='adulto'){
    if(c==='reforestacion') return t[c].adulto; // valeur fixe, pas de multiplication
    return t[c].adulto * (diametro||0);
  }
  return t[c][e]!==undefined ? t[c][e] : 10;
}
function dosisHortManual(p){ return 10; } // 10g/plante (source fournisseur)
function dosisHortMec(p){ return p==='eco'?62:0; } // 50-75 kg/ha → 62 kg/ha (source fournisseur)

// Densité de plantation assumée (plantes/ha) par culture, utilisée uniquement pour convertir
// la dose par arbre en dose mécanisée par hectare (kg/ha). Déduite des doses fournisseur d'origine.
var AA_MEC_DENSITY = {
  olivos:120, citricos:200, almendros_otros:150, cerezos:400,
  vinedos:3330, palmeras:50, manzano:150, peral:150, melocotonero:150
};
// Taux adulte (g par cm de diamètre de tronc) — identique à dosisArbol adulto ci-dessus
var AA_ADULT_RATE = {
  olivos:10, citricos:10, almendros_otros:10, cerezos:10, vinedos:10,
  palmeras:10, manzano:12, peral:12, melocotonero:7
};

function dosisMec(p,c,e,diametro){
  if(c==='horticultura') return{d:dosisHortMec(p),u:'kg/ha',t:'ha'};
  if(c==='viveros')      return{d:1.6,u:'kg/m³',t:'sustrato'}; // 1.2-2.0 kg/m³ → 1.6 (source fournisseur)
  if(c==='reforestacion') return{d:10.0,u:'kg/ha',t:'ha'};

  // joven/desarrollo : dose fixe par arbre (g) × densité(pl/ha) / 1000
  var MEC_JOVEN = {olivos:1.2, citricos:2.0, almendros_otros:1.5, cerezos:4.0, vinedos:33.3, palmeras:0.75, manzano:1.8, peral:1.8, melocotonero:1.05};
  var MEC_DESARROLLO = {olivos:12.0, citricos:20.0, almendros_otros:15.0, cerezos:40.0, vinedos:266.4, palmeras:7.5, manzano:18.0, peral:18.0, melocotonero:10.5};

  if(e==='joven')      return {d: MEC_JOVEN[c]!==undefined ? MEC_JOVEN[c] : 50, u:'kg/ha', t:'ha'};
  if(e==='desarrollo') return {d: MEC_DESARROLLO[c]!==undefined ? MEC_DESARROLLO[c] : 100, u:'kg/ha', t:'ha'};

  // adulto : dose variable selon le diamètre du tronc
  var rate = AA_ADULT_RATE[c] !== undefined ? AA_ADULT_RATE[c] : 10;
  var density = AA_MEC_DENSITY[c] !== undefined ? AA_MEC_DENSITY[c] : 150;
  var d = rate * (diametro||0) * density / 1000;
  return {d:d, u:'kg/ha', t:'ha'};
}

function getBeneficio(c){
  if(c==='reforestacion')return{t:tr('bRefT'),d:tr('bRefD')};
  if(c==='viveros')return{t:tr('bVivT'),d:tr('bVivD')};
  if(c==='horticultura')return{t:tr('bHortT'),d:tr('bHortD')};
  if(c==='vinedos')return{t:tr('bVinT'),d:tr('bVinD')};
  return{t:tr('bDefT'),d:tr('bDefD')};
}

function getEficiencia(c,s,cl,e,sis){
  var min=0.10,max=0.20;
  if(c==='olivos'){min=0.15;max=0.25;} if(c==='citricos'){min=0.12;max=0.22;}
  if(c==='vinedos'){min=0.10;max=0.18;} if(c==='horticultura'){min=0.10;max=0.22;}
  if(c==='viveros'){min=0.10;max=0.20;} if(c==='almendros_otros'){min=0.12;max=0.22;}
  if(c==='palmeras'){min=0.12;max=0.24;} if(c==='cerezos'){min=0.12;max=0.22;}
  if(c==='manzano'||c==='peral'){min=0.10;max=0.20;}
  if(c==='melocotonero'){min=0.10;max=0.18;}
  if(c==='reforestacion')return{min:0,max:0};
  if(s==='arenoso'){min+=0.04;max+=0.08;} if(s==='pedregoso'){min+=0.03;max+=0.06;}
  if(s==='franco'){min+=0.01;max+=0.03;} if(s==='arcilloso'){min-=0.03;max-=0.01;}
  // Sol salin: efficacité normale car doses x3 compensent
  if(cl==='seco'){min+=0.02;max+=0.04;} if(cl==='muyseco'){min+=0.04;max+=0.07;}
  if(e==='joven'){min+=0.03;max+=0.06;} if(e==='desarrollo'){min+=0.02;max+=0.04;}
  if(sis==='goteo'){min+=0.02;max+=0.05;} if(sis==='manual'){min+=0.01;max+=0.03;}
  if(sis==='sinriego'){min=0;max=0;}
  min=Math.max(0,Math.min(min,0.50)); max=Math.max(min,Math.min(max,0.50));
  return{min:min,max:max};
}

function getRef(s,cl){ var sm=5,sx=15,em=5,ex=15; if(cl==='muyseco'){sm+=2;sx+=3;em+=2;ex+=3;} if(s==='arenoso'||s==='pedregoso'){sm+=2;sx+=3;em+=2;ex+=3;} return{sMin:Math.min(sm,15),sMax:Math.min(sx,21),eMin:Math.min(em,15),eMax:Math.min(ex,21)}; }

function calcFormato(kg,p){
  var PRICES_LOCAL = getLocalPrices();
  var pr=PRICES_LOCAL[p]||{kg1:0,kg2:0,kg5:0,kg25:0};
  if(kg<=0)return{f:'-',coste:0,precioKg:0};
  var coste,precioKg;
  if(kg<=1){  coste=pr.kg1;  precioKg=pr.kg1; return{f:tr('saco1'),  coste:coste, precioKg:precioKg}; }
  if(kg<=2){  coste=2*pr.kg2; precioKg=pr.kg2; return{f:tr('saco2'),  coste:coste, precioKg:precioKg}; }
  if(kg<=5){  coste=5*pr.kg5; precioKg=pr.kg5; return{f:tr('saco5'),  coste:coste, precioKg:precioKg}; }
  var n=Math.ceil(kg/25); coste=n*25*pr.kg25; precioKg=pr.kg25;
  return{f:n+' '+tr('sacos25'), coste:coste, precioKg:precioKg};
  // Note: coste & precioKg are in EUR — converted at display time with fmtCurr()
}

function showROI(c,rMax){ return['olivos','citricos','cerezos','palmeras','horticultura','almendros_otros','manzano','peral','melocotonero'].includes(c)&&rMax>0; }


function ensureAquasolIndexCard(){
  var existing = document.getElementById('aa_indexResultado');
  if(existing){
    if(!document.getElementById('aa_indexTexto')){
      existing.insertAdjacentHTML('afterend','<small id="aa_indexTexto"></small>');
    }
    if(!document.getElementById('aa_indexExplicacion')){
      var host = existing.closest('.result-card') || existing.parentNode;
      if(host){
        host.insertAdjacentHTML('beforeend','<small id="aa_indexExplicacion"></small>');
      }
    }
    return;
  }

  var results = document.querySelector('.results');
  if(!results) return;

  var card = document.createElement('div');
  card.className = 'result-card aquasol-index-card';
  card.innerHTML =
    '<b>AQUASOL INDEX™</b>' +
    '<strong id="aa_indexResultado">🔴 E</strong>' +
    '<small id="aa_indexTexto"></small>' +
    '<small id="aa_indexExplicacion"></small>';

  results.insertBefore(card, results.children[3] || null);
}

function getIndexPercentFromDisplay(){
  var el = document.getElementById('aa_eficienciaResultado');
  if(!el) return 0;
  var txt = (el.innerText || el.textContent || '').replace(/,/g,'.');
  var nums = txt.match(/\d+(?:\.\d+)?/g);
  if(!nums || !nums.length) return 0;
  return Math.max.apply(null, nums.map(function(n){ return parseFloat(n) || 0; }));
}

function updateAquasolIndex(maxPercent){
  ensureAquasolIndexCard();

  maxPercent = parseFloat(maxPercent);
  if(isNaN(maxPercent) || maxPercent < 0){
    maxPercent = getIndexPercentFromDisplay();
  }

  var indice = '🔴 E';
  var texto = tr('indexBad');

  if(maxPercent >= 40){
    indice = '🟢 A';
    texto = tr('indexAplus');
  } else if(maxPercent >= 30){
    indice = '🔵 B';
    texto = tr('indexA');
  } else if(maxPercent >= 20){
    indice = '🟡 C';
    texto = tr('indexB');
  } else if(maxPercent >= 10){
    indice = '🟠 D';
    texto = tr('indexC');
  }

  setHTML('aa_indexResultado', indice);
  setHTML('aa_indexTexto', texto);
  setHTML('aa_indexExplicacion', tr('indexExplain'));
}

function updateAquasolIndexFromDisplay(){
  updateAquasolIndex(getIndexPercentFromDisplay());
}

function resetDefaultResultsByLang(){
  // Reset graphique ROI
  var chartWrap = document.getElementById('aa_roi_chart_wrap');
  if(chartWrap) chartWrap.style.display = 'none';
  var chartDiv = document.getElementById('aa_roi_chart');
  if(chartDiv) chartDiv.innerHTML = '';
  // Reset section agro
  var agroS = document.getElementById('aa_agro_section');
  if(agroS) agroS.style.display = 'none';
  // Remettre les cartes visibles par défaut
  var hectareaCard = document.getElementById('aa_hectareaResultado');
  if(hectareaCard){ var hc = hectareaCard.closest('.result-card'); if(hc) hc.style.display=''; }
  var plantaCard = document.getElementById('aa_plantaResultado');
  if(plantaCard){ var pc = plantaCard.closest('.result-card'); if(pc) pc.style.display=''; }
  setHTML('aa_aguaResultado','0 '+tr('uAgua'));
  setHTML('aa_dineroResultado','0 '+CN+'/'+tr('perYear'));
  setHTML('aa_eficienciaResultado','0%');
  setHTML('aa_hectareaResultado','0 '+CN+'/'+tr('uHa'));
  setHTML('aa_plantaResultado','0 '+CN+'/'+tr('uPlanta'));
  setHTML('aa_dosisResultado','0');
  setHTML('aa_productoResultado','0 kg');
  setHTML('aa_formatoResultado','-');
  setHTML('aa_costeResultado','0 '+CN);

  var b = getBeneficio('');
  setHTML('aa_beneficioResultado', b.t);
  setHTML('aa_beneficioDetalle', b.d);

  updateAquasolIndex(0);
}


function calcular(){
  var p=document.getElementById('aa_producto').value;
  var a=document.getElementById('aa_aplicacion').value;
  var c=document.getElementById('aa_cultivo').value;
  var s=document.getElementById('aa_suelo').value;
  var cl=document.getElementById('aa_clima').value;
  var e=document.getElementById('aa_edad').value;
  var sis=document.getElementById('aa_sistema').value;
  var troncoEl=document.getElementById('aa_tronco');
  var tronco = troncoEl ? (parseFloat(troncoEl.value)||0) : 0;

  document.getElementById('aa_roiCard').style.display='none';
  document.getElementById('aa_costeCard').style.display='none';
  updateCampos();

  var err=[];
  if(!c) err.push(tr('selectCultivo'));
  if(!p) err.push(tr('selectProducto'));
  if(!a) err.push(tr('selectAplicacion'));
  if(!s) err.push(tr('selectSuelo'));
  if(!cl) err.push(tr('selectClima'));
  if(!sis) err.push(tr('selectSistema'));
  if(err.length>0){ var av=document.getElementById('aa_aviso'); av.style.display='block'; av.innerHTML=err.join(' '); return; }

  var ha=parseFloat(document.getElementById('aa_hectareas').value)||0;
  var m2=parseFloat(document.getElementById('aa_m2').value)||0;
  var sus=parseFloat(document.getElementById('aa_sustrato').value)||0;
  var pl=parseFloat(document.getElementById('aa_plantas').value)||0;
  var ri=parseFloat(document.getElementById('aa_riego').value)||0;
  var pr=parseFloat(document.getElementById('aa_precio').value)||0;
  var aviso='';
  var esRef=c==='reforestacion';

  if(esRef){
    setHTML('aa_label_agua',tr('refCap')); setHTML('aa_label_dinero',tr('refBenef'));
    setHTML('aa_label_eficiencia',tr('refEstres')); setHTML('aa_label_hectarea',tr('refSuper'));
    setHTML('aa_label_planta',tr('refPlant')); sis='sinriego';
  } else {
    setHTML('aa_label_agua',tr('agua')); setHTML('aa_label_dinero',tr('dinero'));
    setHTML('aa_label_eficiencia',tr('eficiencia'));
    if(c==='viveros'){
      setHTML('aa_label_hectarea', tr('ahorroTotal'));
      setHTML('aa_label_planta', tr('ahorroM3'));
    } else if(c==='horticultura'){
      setHTML('aa_label_hectarea', tr('hectarea'));
      setHTML('aa_label_planta', a==='manual' ? tr('planta') : tr('ahorroM2'));
    } else {
      setHTML('aa_label_hectarea', tr('hectarea'));
      setHTML('aa_label_planta', tr('planta'));
    }
  }

  var b=getBeneficio(c); setHTML('aa_beneficioResultado',b.t); setHTML('aa_beneficioDetalle',b.d);

  var ef=getEficiencia(c,s,cl,e,sis);

  // ── BASE DE CALCUL selon el tipo de cultura ──
  var conBase; // consommation de référence pour calculer l'ahorro
  if(c==='viveros'){
    // Viveros : riego en m³/m³ sustrato
    // On estime consommation totale = sustrato * riego (m³ eau par m³ substrat)
    conBase = sus * ri;
  } else if(c==='horticultura' && a==='manual'){
    // Horticultura manual : riego = m³/ha/an (même unité que les autres cultures)
    // conBase = ha × ri
    // Si ha=0 mais pl>0 : estimation depuis nb plantes
    conBase = (ha > 0 && ri > 0) ? ha * ri : (pl > 0 ? pl * 0.02 : 0);
  } else if(c==='horticultura' && a==='mecanizada'){
    // Horticultura mecanizada : surface en hectares
    conBase = (ha > 0 && ri > 0) ? ha * ri : (ha * 300);
  } else {
    // Arboriculture : ha * riego standard
    conBase = ha * ri;
  }

  var aMin=conBase*ef.min, aMax=conBase*ef.max;
  var dMin=aMin*pr, dMax=aMax*pr;
  if(sis==='sinriego'){ aMin=0;aMax=0;dMin=0;dMax=0; if(!esRef)aviso+=tr('sinRiegoAviso'); }
  if(c==='reforestacion'){ aMin=0;aMax=0;dMin=0;dMax=0; aviso+=tr('reforestacionAviso'); }
  var pr0mode = (pr===0 && sis!=='sinriego' && !esRef);
  if(pr0mode){ dMin=0;dMax=0; } // no aviso

  var dosis=0,uDosis='',pkgKg=0;
  if(c==='viveros'){ dosis=1.6;uDosis='kg/m³';pkgKg=sus*dosis; setHTML('aa_label_dosis',tr('dosis')); if(sus<=0)aviso+=tr('introSustrato'); }
  else if(c==='horticultura'&&a==='manual'){ dosis=dosisHortManual(p);uDosis='g/'+tr('uPlanta');pkgKg=(pl*dosis)/1000; setHTML('aa_label_dosis',tr('dosis')); if(pl<=0)aviso+=tr('introPlantasHort'); }
  else if(c==='horticultura'&&a==='mecanizada'){ dosis=dosisHortMec(p);uDosis='kg/ha';pkgKg=ha*dosis; setHTML('aa_label_dosis',tr('dosisMec')); if(ha<=0)aviso+=tr('introHaMec'); }
  else if(a==='manual'){
    if(!e)aviso+=tr('selectEdad');
    if(e==='adulto' && c!=='reforestacion' && tronco<=0) aviso+=tr('introTronco');
    dosis=dosisArbol(c,e,tronco);uDosis='g/'+tr('uPlanta');pkgKg=(pl*dosis)/1000; setHTML('aa_label_dosis',tr('dosis')); if(pl<=0)aviso+=tr('introPlantasManual');
  }
  else if(a==='mecanizada'){
    if(!e)aviso+=tr('selectEdad');
    if(e==='adulto' && c!=='reforestacion' && tronco<=0) aviso+=tr('introTronco');
    var dm=dosisMec(p,c,e,tronco);dosis=dm.d;uDosis=dm.u; setHTML('aa_label_dosis',tr('dosisMec')); if(dm.t==='ha'){pkgKg=ha*dosis;if(ha<=0)aviso+=tr('introHaMec');} if(dosis===0)aviso+=tr('validaTecnica');
  }

  // Validation données manquantes
  if(c==='viveros' && sus<=0) aviso+=tr('introSustrato');
  else if(c==='viveros' && ri<=0) aviso+=tr('introAgua');
  else if(c==='horticultura' && a==='manual' && pl<=0) aviso+=tr('introPlantasHort');
  else if(c==='horticultura' && a==='manual' && ri<=0 && pl>0) aviso+=tr('introAgua');
  else if(c==='horticultura' && a==='mecanizada' && ha<=0) aviso+=tr('introHaMec');
  else if(c==='horticultura' && a==='mecanizada' && ri<=0 && ha>0) aviso+=tr('introAgua');
  else if(c!=='viveros' && c!=='horticultura' && !esRef && (ha<=0||ri<=0) && sis!=='sinriego') aviso+=tr('introAgua');

  // Ahorro por unidad
  // Calcul des ahorros par unité selon le type de culture
  var haMin, haMax, plMin, plMax;
  if(c==='viveros'){
    // Viveros : haMin/haMax = ahorro TOTAL, plMin/plMax = ahorro par m³ sustrato
    haMin = dMin;
    haMax = dMax;
    var pm3Min = sus>0 ? dMin/sus : 0;
    var pm3Max = sus>0 ? dMax/sus : 0;
    plMin = pm3Min;
    plMax = pm3Max;
  } else if(c==='horticultura'){
    if(a==='mecanizada'){
      // Mecanizada: ahorro par ha
      haMin = ha>0 ? dMin/ha : 0;
      haMax = ha>0 ? dMax/ha : 0;
      plMin = ha>0 ? dMin/ha : 0;
      plMax = ha>0 ? dMax/ha : 0;
    } else {
      // Manual: ahorro par ha ET par plante
      haMin = ha>0 ? dMin/ha : 0;
      haMax = ha>0 ? dMax/ha : 0;
      plMin = pl>0 ? dMin/pl : 0;
      plMax = pl>0 ? dMax/pl : 0;
    }
  } else {
    haMin = ha>0 ? dMin/ha : 0;
    haMax = ha>0 ? dMax/ha : 0;
    plMin = pl>0 ? dMin/pl : 0;
    plMax = pl>0 ? dMax/pl : 0;
  }
  // Ajustements de dose selon sol et climat (cumulatifs)
  // Sol arenoso: +20%, pedregoso: +10%
  // Clima seco: +10%, muyseco: +20%
  // Ces bonus se cumulent
  if(sis!=='sinriego' && s!=='salino'){
    var bonusDose = 0;
    if(s==='arenoso') bonusDose += 0.20;
    if(s==='pedregoso') bonusDose += 0.10;
    if(cl==='seco') bonusDose += 0.10;
    if(cl==='muyseco') bonusDose += 0.20;
    if(bonusDose > 0){
      dosis = dosis * (1 + bonusDose);
      pkgKg = pkgKg * (1 + bonusDose);
      aviso += tr('bonusAviso');
    }
  }

  // Sol salin : facteur selon la conductividad eléctrica (CE), pas un ×3 fixe
  if(s==='salino' && sis!=='sinriego'){
    var ecEl = document.getElementById('aa_ec');
    var ecVal = ecEl ? ecEl.value : '';
    var EC_FACTORS = {'0':1, '2':1.5, '4':2, '8':2.5};
    if(!ecVal) aviso += tr('selectEC');
    var ecFactor = EC_FACTORS[ecVal] !== undefined ? EC_FACTORS[ecVal] : 1;
    var esArbolAdultoEC8 = ecVal==='8' && e==='adulto' && c!=='reforestacion' && isArbol(c);
    if(ecFactor > 1 || esArbolAdultoEC8){
      pkgKg = pkgKg * ecFactor;
      dosis = dosis * ecFactor;
    }
    if(esArbolAdultoEC8){
      aviso += tr('salinAdultoSat205');
    } else if(ecFactor > 1){
      aviso += tr('salinAviso').replace('{factor}', ecFactor);
    }
  }
  var fo=calcFormato(pkgKg,p);
  var smartDiscountRate = getSmartDiscountRate();
  var smartDiscountActive = smartDiscountRate > 0 && fo.precioKg > 0;
  if(smartDiscountActive){
    fo.coste = fo.coste * (1 - smartDiscountRate);
    fo.precioKg = fo.precioKg * (1 - smartDiscountRate);
  }
  var cMn=p==='eco'?1.8:2.4, cMx=p==='eco'?2.8:3.05;
  var costeLoc=fo.coste; var rMin=(dMin*cMn)-costeLoc, rMax=(dMax*cMx)-costeLoc;

  setHTML('aa_dosisResultado', fmt(dosis)+' '+uDosis);
  setHTML('aa_productoResultado', fmtD(pkgKg)+' kg');
  setHTML('aa_formatoResultado', fo.f);
  setHTML('aa_costeResultado', fo.precioKg ? fmt(fo.coste)+' '+CN+(smartDiscountActive?' 🎁 -'+Math.round(smartDiscountRate*100)+'% Smart':'') : 'X '+CN);
  setHTML('aa_label_roi',tr('roi')); setHTML('aa_roiSmall',tr('roiSmall'));

  if(esRef){
    var rf=getRef(s,cl);
    var pMin=pl*(rf.sMin/100), pMax=pl*(rf.sMax/100);
    setHTML('aa_aguaResultado',tr('noAplica'));
    setHTML('aa_dineroResultado',tr('menorMortalidad'));
    setHTML('aa_eficienciaResultado',rf.eMin+' - '+rf.eMax+'%');
    updateAquasolIndex(rf.eMax);
    setHTML('aa_hectareaResultado',rf.sMin+' - '+rf.sMax+'%');
    setHTML('aa_plantaResultado',fmt(pMin)+' - '+fmt(pMax)+' '+tr('plantasTxt'));
    document.getElementById('aa_visual').classList.remove('active');
  } else {
    setHTML('aa_aguaResultado',fmt(aMin)+' - '+fmt(aMax)+' '+tr('uAgua'));
    setHTML('aa_dineroResultado',fmt(dMin)+' - '+fmt(dMax)+' '+CN+'/'+tr('perYear'));
    setHTML('aa_eficienciaResultado',Math.round(ef.min*100)+' - '+Math.round(ef.max*100)+'%');
    updateAquasolIndex(Math.round(ef.max*100));
    var _hcEl = document.getElementById('aa_hectareaResultado');
    var _hcCard = _hcEl ? _hcEl.closest('.result-card') : null;
    if(c==='viveros'){
      // Viveros: masquer carte ha, afficher /m³ sustrato
      if(_hcCard) _hcCard.style.display='none';
      setHTML('aa_plantaResultado', fmt(plMin)+' - '+fmt(plMax)+' '+CN+'/m³');
    } else if(c==='horticultura' && a==='manual'){
      // Hort manual: carte ha seulement si ha saisi, sinon masquée
      if(ha > 0){
        if(_hcCard) _hcCard.style.display='';
        setHTML('aa_hectareaResultado', fmt(haMin)+' - '+fmt(haMax)+' '+CN+'/'+tr('uHa'));
      } else {
        if(_hcCard) _hcCard.style.display='none';
      }
      setHTML('aa_plantaResultado', fmt(plMin)+' - '+fmt(plMax)+' '+CN+'/'+tr('uPlanta'));
    } else {
      // Autres: afficher carte ha
      if(_hcCard) _hcCard.style.display='';
      setHTML('aa_hectareaResultado', fmt(haMin)+' - '+fmt(haMax)+' '+CN+'/'+tr('uHa'));
      if(c==='horticultura' && a==='mecanizada'){
        // Masquer carte planta pour hort mec (doublon avec carte ha)
        var plantaCard = document.getElementById('aa_plantaResultado');
        if(plantaCard){ var pCard = plantaCard.closest('.result-card'); if(pCard) pCard.style.display='none'; }
      } else {
        // Restaurer la carte planta pour les autres cultures
        var plantaCard2 = document.getElementById('aa_plantaResultado');
        if(plantaCard2){ var pCard2 = plantaCard2.closest('.result-card'); if(pCard2) pCard2.style.display=''; }
        setHTML('aa_plantaResultado', fmt(plMin)+' - '+fmt(plMax)+' '+CN+'/'+tr('uPlanta'));
      }
    }
    var rMin5=Math.max(0,rMin+(dMin*4)), rMax5=rMax+(dMax*4);
    if(showROI(c, Math.max(rMax, rMax5))){
      document.getElementById('aa_costeCard').style.display='block';
      document.getElementById('aa_roiCard').style.display='block';
      setHTML('aa_roiResultado',fmt(Math.max(0,rMin5))+' - '+fmt(Math.max(0,rMax5))+' '+CN);
    }
    var cCA=Math.max(0,Math.round((1-ef.max)*100));
    setHTML('aa_consumoConAquasol',cCA+'%');
    setHTML('aa_impactText',tr('hastaReducir')+Math.round(ef.max*100)+'%.');
    document.getElementById('aa_visual').classList.add('active');
  }

  // ── Mode sans prix eau (pr=0): masquer argent, afficher bénéfices agro ──
  if(pr0mode){
    // Masquer les cartes monétaires
    // Masquer cartes monétaires sauf ROI (géré par showROI)
    var moneyCards = ['aa_dineroResultado','aa_hectareaResultado','aa_plantaResultado','aa_costeResultado'];
    moneyCards.forEach(function(id){
      var el = document.getElementById(id);
      if(el){ var card = el.closest('.result-card'); if(card) card.style.display='none'; }
    });
    // Masquer coste (pas le roi qui est géré par showROI)
    var cC = document.getElementById('aa_costeCard');
    if(cC) cC.style.display='none';
    // Afficher message informatif
    // pas d'aviso pour mode prix=0
    // Calcul dynamique des bénéfices selon les paramètres saisis
    var agro = calcAgroBenefits(ef, s, cl, c, aMin, aMax);

    // Masquer la carte bénéfice standard
    var benefCard = document.getElementById('aa_beneficioResultado');
    if(benefCard){ var bc = benefCard.closest('.result-card'); if(bc) bc.style.display='none'; }

    // Emojis pour chaque bénéfice
    var agro_emojis = ['🌿','🌱','🌳','🍊','📊','💧'];

    // Afficher section indépendante sous les résultats
    var agro_section = document.getElementById('aa_agro_section');
    if(!agro_section){
      agro_section = document.createElement('div');
      agro_section.id = 'aa_agro_section';
      var resultsDiv = document.querySelector('.results');
      if(resultsDiv && resultsDiv.parentNode){
        resultsDiv.parentNode.insertBefore(agro_section, resultsDiv.nextSibling);
      }
    }
    var bHtml = '<div style="margin:28px 0 0;">';
    bHtml += '<div style="font-size:13px;font-weight:800;color:#0b1733;letter-spacing:.5px;margin-bottom:16px;text-align:left;">🌿 '+tr('bAgro1T').replace(/[🌿🌱🌳🍊📊💧]/g,'').trim().toUpperCase().split(' ').slice(0,3).join(' ')+'</div>';
    bHtml = '<div style="margin:28px 0 0;">';
    bHtml += '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:16px;">';
    agro.forEach(function(b, i){
      var emoji = agro_emojis[i] || '✅';
      bHtml += '<div style="background:linear-gradient(135deg,#ffffff,#f0fae8);border:1.5px solid #c8e8b0;border-radius:20px;padding:20px 18px;box-shadow:0 6px 18px rgba(0,0,0,.06);position:relative;overflow:hidden;">';
      bHtml += '<div style="position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,#0b63ce,#5f9827);"></div>';
      bHtml += '<div style="font-size:32px;margin-bottom:10px;">'+emoji+'</div>';
      bHtml += '<b style="color:#0b1733;font-size:13px;letter-spacing:.3px;display:block;margin-bottom:8px;">'+b.t+'</b>';
      bHtml += '<span style="font-size:12px;color:#4b5563;line-height:1.6;">'+b.d+'</span>';
      bHtml += '</div>';
    });
    bHtml += '</div></div>';
    agro_section.innerHTML = bHtml;
    agro_section.style.display = 'block';
    // Responsive grid
    if(window.innerWidth < 700){
      agro_section.querySelector('div > div[style*="grid-template-columns:repeat(3"]').style.gridTemplateColumns = '1fr';
    }
    // Garder ahorro eau visible
    setHTML('aa_label_agua', tr('agua'));
  } else {
    // Restaurer les cartes monétaires
    var moneyCards2 = ['aa_dineroResultado','aa_hectareaResultado','aa_plantaResultado','aa_costeResultado'];
    moneyCards2.forEach(function(id){
      var el = document.getElementById(id);
      if(el){ var card = el.closest('.result-card'); if(card) card.style.display=''; }
    });
    // Restaurer carte bénéfice standard
    var benefCard2 = document.getElementById('aa_beneficioResultado');
    if(benefCard2){ var bc2 = benefCard2.closest('.result-card'); if(bc2) bc2.style.display=''; }
    // Masquer section agro
    var as = document.getElementById('aa_agro_section');
    if(as) as.style.display = 'none';
  }

  var avisoEl=document.getElementById('aa_aviso');
  avisoEl.style.display=aviso?'block':'none';
  avisoEl.innerHTML=aviso;

  // ── Graphique ROI ──
  if(typeof rMin !== 'undefined' && typeof rMax !== 'undefined' && typeof rMin5 !== 'undefined' && showROI(c, Math.max(rMax,rMax5)) && Math.max(rMax,rMax5) > 0){
    renderROIChart(rMin, rMax, dMin, dMax);
  } else {
    var cw = document.getElementById('aa_roi_chart_wrap');
    if(cw) cw.style.display = 'none';
  }

  // ── Feature 7: Save to history ──
  if(!esRef && dMin > 0){
    saveToHistory(getHistoryData());
  }

  // ── AQUASOL Smart (app + capteurs) — couche d'optimisation additionnelle, calcul multiplicatif ──
  updateSmartSection(esRef ? 0 : conBase, esRef ? 0 : ef.max, pr);
}

function datosOK(){ return document.getElementById('aa_empresa').value&&document.getElementById('aa_nombre').value&&document.getElementById('aa_telefono').value&&document.getElementById('aa_email').value; }

// ── INIT ──
applyTranslations();
updateProducts();
updateSistema();
updateCampos();
ensureAquasolIndexCard();
resetDefaultResultsByLang();
var aaEfNode=document.getElementById('aa_eficienciaResultado');
if(aaEfNode && window.MutationObserver){
  new MutationObserver(function(){ updateAquasolIndexFromDisplay(); }).observe(aaEfNode,{childList:true,characterData:true,subtree:true});
}

// Prevent negative values
['aa_hectareas','aa_m2','aa_sustrato','aa_plantas','aa_riego','aa_precio','aa_tronco'].forEach(function(id){
  var el = document.getElementById(id);
  if(el){
    el.setAttribute('min','0');
    el.addEventListener('input',function(){ if(parseFloat(this.value)<0) this.value=0; });
  }
});

document.getElementById('aa_cultivo').addEventListener('change',function(){
    updateProducts(); updateSistema(); updateCampos();
    // Refresh edad options (reforestacion uses arbol_joven instead of adulto)
    var cv = document.getElementById('aa_cultivo').value;
    var edadEl = document.getElementById('aa_edad');
    if(edadEl){
      if(cv === 'reforestacion'){
        edadEl.innerHTML = def(tr('edad')) + opt('joven',tr('joven')) + opt('desarrollo',tr('desarrollo')) + opt('adulto',tr('arbolJoven'));
      } else {
        edadEl.innerHTML = def(tr('edad')) + opt('joven',tr('joven')) + opt('desarrollo',tr('desarrollo')) + opt('adulto',tr('adulto'));
      }
    }
  });
document.getElementById('aa_aplicacion').addEventListener('change', updateCampos);
document.getElementById('aa_edad').addEventListener('change', updateCampos);
document.getElementById('aa_suelo').addEventListener('change', function(){ updateProducts(); updateCampos(); });
document.getElementById('aa_calcular').addEventListener('click', function(){ calcular(); setTimeout(updateAquasolIndexFromDisplay,50); });

// ── AQUASOL Smart toggle (No / App seule -10% / App + capteurs -20%) ──
(function(){
  var noBtn = document.getElementById('aa_smart_no');
  var appBtn = document.getElementById('aa_smart_app');
  var sensorsBtn = document.getElementById('aa_smart_sensors');
  if(!noBtn || !appBtn || !sensorsBtn) return; // bloc HTML pas encore ajouté à la page
  function setSmartChoice(tier){
    noBtn.classList.toggle('active', tier === 'none');
    appBtn.classList.toggle('active', tier === 'app');
    sensorsBtn.classList.toggle('active', tier === 'sensors');
    // Si un calcul a déjà été fait, on rafraîchit immédiatement les résultats
    var already = document.getElementById('aa_cultivo').value;
    if(already) calcular();
  }
  noBtn.addEventListener('click', function(){ setSmartChoice('none'); });
  appBtn.addEventListener('click', function(){ setSmartChoice('app'); });
  sensorsBtn.addEventListener('click', function(){ setSmartChoice('sensors'); });
})();

document.getElementById('aa_imprimir').addEventListener('click',function(){
  if(!datosOK()){ alert(tr('alertDatos')); return; }
  // Mode prix=0: exclure les champs monétaires du PDF
  var pr_val = parseFloat(document.getElementById('aa_precio').value)||0;
  var pr0print = (pr_val === 0);
  var campos = [
    ['aa_label_agua','aa_aguaResultado'],
    ['aa_label_eficiencia','aa_eficienciaResultado'],
    ['aa_indexResultado','aa_indexTexto'],
    ['aa_label_dosis','aa_dosisResultado'],
    ['aa_label_producto_necesario','aa_productoResultado'],
    ['aa_label_formato','aa_formatoResultado'],
    ['aa_label_beneficio','aa_beneficioResultado']
  ];
  if(!pr0print){
    campos.splice(1,0,['aa_label_dinero','aa_dineroResultado']);
    campos.push(['aa_label_hectarea','aa_hectareaResultado']);
    campos.push(['aa_label_planta','aa_plantaResultado']);
  }
  var rows='';
  campos.forEach(function(pair){
    var lbl=document.getElementById(pair[0]); var val=document.getElementById(pair[1]);
    if(pair[0]==='aa_indexResultado'){
      if(lbl&&val){
        rows+='<tr><td style="padding:10px 14px;font-weight:600;color:#0b1733;border-bottom:1px solid #eee;width:50%">AQUASOL INDEX™</td><td style="padding:10px 14px;color:#1a1a1a;border-bottom:1px solid #eee">'+lbl.innerText+' - '+val.innerText+'</td></tr>';
      }
    }
    else if(lbl&&val&&val.innerText&&val.innerText!=='0'&&val.innerText!=='-'){
      rows+='<tr><td style="padding:10px 14px;font-weight:600;color:#0b1733;border-bottom:1px solid #eee;width:50%">'+lbl.innerText+'</td><td style="padding:10px 14px;color:#1a1a1a;border-bottom:1px solid #eee">'+val.innerText+'</td></tr>';
    }
  });
  var costeCard=document.getElementById('aa_costeCard'); var roiCard=document.getElementById('aa_roiCard');
  if(costeCard&&costeCard.style.display!=='none') rows+='<tr><td style="padding:10px 14px;font-weight:600;color:#0b1733;border-bottom:1px solid #eee">'+document.getElementById('aa_label_coste').innerText+'</td><td style="padding:10px 14px;color:#1a1a1a;border-bottom:1px solid #eee">'+document.getElementById('aa_costeResultado').innerText+'</td></tr>';
  if(roiCard&&roiCard.style.display!=='none') rows+='<tr><td style="padding:10px 14px;font-weight:600;color:#0b1733;border-bottom:1px solid #eee">'+document.getElementById('aa_label_roi').innerText+'</td><td style="padding:10px 14px;color:#1a1a1a;border-bottom:1px solid #eee">'+document.getElementById('aa_roiResultado').innerText+'</td></tr>';
  var aviso=document.getElementById('aa_aviso');
  var avisoTxt=(aviso&&aviso.style.display!=='none')?'<p style="margin-top:20px;padding:14px;background:#fff8e6;border-radius:10px;color:#6b4b00;font-size:13px">'+aviso.innerText+'</p>':'';
  var html='<!DOCTYPE html><html><head><meta charset="UTF-8"><title>AQUASOL AGRO</title><style>body{font-family:Arial,sans-serif;padding:30px;color:#1a1a1a;max-width:700px;margin:0 auto}h1{color:#0b1733;font-size:24px}h2{color:#5f9827;font-size:16px;font-weight:normal}table{width:100%;border-collapse:collapse}.footer{margin-top:30px;font-size:12px;color:#888;text-align:center}</style></head><body>'
    +'<h1>AQUASOL AGRO</h1><h2>'+tr('leadTitle')+'</h2>'
    +'<p style="margin-bottom:20px;font-size:14px"><strong>'+tr('empresa')+':</strong> '+document.getElementById('aa_empresa').value+' &nbsp;|&nbsp; <strong>'+tr('nombre')+':</strong> '+document.getElementById('aa_nombre').value+' &nbsp;|&nbsp; <strong>'+tr('telefono')+':</strong> '+document.getElementById('aa_telefono').value+'</p>'
    +'<table>'+rows+'</table>'+avisoTxt
    +'<div class="footer">www.aquasolagro.com &nbsp;|&nbsp; info@aquasolagro.com &nbsp;|&nbsp; +34 680 704 013</div>'
    +'</body></html>';
  var win=window.open('','_blank'); win.document.write(html); win.document.close(); win.focus();
  setTimeout(function(){ win.print(); },500);
});

document.getElementById('aa_presupuesto').addEventListener('click',function(){
  if(!datosOK()){ alert(tr('alertTodos')); return; }
  var msg=tr('solicitud')+'\n\n';
  msg+=tr('empresa')+': '+document.getElementById('aa_empresa').value+'\n';
  msg+=tr('nombre')+': '+document.getElementById('aa_nombre').value+'\n';
  msg+=tr('telefono')+': '+document.getElementById('aa_telefono').value+'\n';
  msg+='Email: '+document.getElementById('aa_email').value+'\n\n';
  var sel=function(id){ var el=document.getElementById(id); return el.options[el.selectedIndex]?el.options[el.selectedIndex].text:''; };
  msg+=tr('cultivo')+': '+sel('aa_cultivo')+'\n';
  msg+=tr('producto')+': '+sel('aa_producto')+'\n';
  msg+=tr('aplicacion')+': '+sel('aa_aplicacion')+'\n';
  msg+=tr('suelo')+': '+sel('aa_suelo')+'\n';
  msg+=tr('clima')+': '+sel('aa_clima')+'\n';
  msg+=tr('sistema')+': '+sel('aa_sistema')+'\n\n';
  msg+=tr('dosis')+': '+document.getElementById('aa_dosisResultado').innerText+'\n';
  msg+=tr('productoNecesario')+': '+document.getElementById('aa_productoResultado').innerText+'\n';
  msg+=tr('formato')+': '+document.getElementById('aa_formatoResultado').innerText+'\n';
  msg+=document.getElementById('aa_label_agua').innerText+': '+document.getElementById('aa_aguaResultado').innerText+'\n';
  msg+=document.getElementById('aa_label_dinero').innerText+': '+document.getElementById('aa_dineroResultado').innerText+'\n';
  msg+=document.getElementById('aa_label_eficiencia').innerText+': '+document.getElementById('aa_eficienciaResultado').innerText+'\n';
  if(document.getElementById('aa_indexResultado')){ msg+='AQUASOL INDEX™: '+document.getElementById('aa_indexResultado').innerText+' - '+document.getElementById('aa_indexTexto').innerText+'\n'; }
  var url='https://wa.me/34680704013?text='+encodeURIComponent(msg);
  window.open(url,'_blank');
});

});

// ════════════════════════════════════════════════════════════
// FEATURE 4 — RIEGO AUTOMÁTICO (estimación por cultivo)
// ════════════════════════════════════════════════════════════
var RIEGO_EST = {
  olivos:          {joven:1200, desarrollo:2000, adulto:3000},
  citricos:        {joven:2500, desarrollo:4000, adulto:6000},
  almendros_otros: {joven:800,  desarrollo:1500, adulto:2500},
  cerezos:         {joven:1500, desarrollo:2500, adulto:3500},
  vinedos:         {joven:800,  desarrollo:1200, adulto:1800},
  palmeras:        {joven:2000, desarrollo:3500, adulto:5000},
  horticultura:    {joven:3000, desarrollo:4000, adulto:5000},
  viveros:         {joven:200,  desarrollo:200,  adulto:200},
  reforestacion:   {joven:400,  desarrollo:400,  adulto:400},
  manzano:         {joven:2000, desarrollo:3200, adulto:4500},
  peral:           {joven:2000, desarrollo:3200, adulto:4500},
  melocotonero:    {joven:1800, desarrollo:2800, adulto:4000},
};

function autoRiego(){
  var c = document.getElementById('aa_cultivo').value;
  var e = document.getElementById('aa_edad').value || 'adulto';
  var riEl = document.getElementById('aa_riego');
  if(!c || !riEl) return;
  var est = RIEGO_EST[c];
  if(!est) return;
  var val = est[e] || est.adulto;
  riEl.value = val;
  riEl.style.borderColor = '#7EB63A';
  riEl.title = 'Valor estimado — puedes ajustarlo';
  // Flash animation
  riEl.style.transition = 'background .3s';
  riEl.style.background = 'rgba(126,182,58,.12)';
  setTimeout(function(){ riEl.style.background = ''; }, 1000);
}

// ════════════════════════════════════════════════════════════
// FEATURE 3 — COMPARTIR RESULTADOS VÍA URL
// ════════════════════════════════════════════════════════════










// ════════════════════════════════════════════════════════════
// FEATURE 7 — HISTORIAL DE CÁLCULOS (localStorage)
// ════════════════════════════════════════════════════════════
var HIST_KEY = 'aquasol_hist';

function saveToHistory(data){
  try{
    var hist = JSON.parse(localStorage.getItem(HIST_KEY)||'[]');
    data.date = new Date().toLocaleDateString();
    data.ts = Date.now();
    hist.unshift(data);
    if(hist.length > 5) hist = hist.slice(0,5);
    localStorage.setItem(HIST_KEY, JSON.stringify(hist));
    renderHistory();
  }catch(e){}
}

function getHistoryData(){
  var c=document.getElementById('aa_cultivo').value;
  var ha=document.getElementById('aa_hectareas').value;
  var ri=document.getElementById('aa_riego').value;
  var pr=document.getElementById('aa_precio').value;
  var prVal = parseFloat(pr)||0;
  var dMin = prVal>0 && document.getElementById('aa_dineroResultado') ? document.getElementById('aa_dineroResultado').innerText : '';
  var agua = document.getElementById('aa_aguaResultado') ? document.getElementById('aa_aguaResultado').innerText : '';
  var display = prVal>0 ? dMin : agua;
  return {cultivo:c, ha:ha, riego:ri, precio:pr, ahorro:display};
}

function renderHistory(){
  var box = document.getElementById('aa_historial');
  if(!box) return;
  try{
    var hist = JSON.parse(localStorage.getItem(HIST_KEY)||'[]');
    if(!hist.length){ box.style.display='none'; return; }
    box.style.display='block';
    var html = '<div style="font-size:12px;font-weight:700;color:#0b1733;letter-spacing:1px;margin-bottom:10px;">'+tr('histTitle')+'</div>';
    hist.forEach(function(h,i){
      html += '<div style="display:flex;align-items:center;justify-content:space-between;padding:10px 14px;background:#fff;border-radius:12px;margin-bottom:8px;border:1px solid #e0efd8;font-size:13px;cursor:pointer;" onclick="loadHistory('+i+')">';
      html += '<span>'+h.date+' — '+h.cultivo+' '+h.ha+'ha</span>';
      html += '<span style="color:#579821;font-weight:700;">'+h.ahorro+'</span>';
      html += '</div>';
    });
    html += '<div style="text-align:right;margin-top:6px;"><span onclick="clearHistory()" style="font-size:11px;color:#aaa;cursor:pointer;">'+tr('histClear')+'</span></div>';
    box.innerHTML = html;
  }catch(e){}
}

function loadHistory(i){
  try{
    var hist = JSON.parse(localStorage.getItem(HIST_KEY)||'[]');
    var h = hist[i]; if(!h) return;
    var map = {cultivo:'aa_cultivo',ha:'aa_hectareas',riego:'aa_riego',precio:'aa_precio'};
    Object.keys(map).forEach(function(k){
      var el=document.getElementById(map[k]); if(el&&h[k]) el.value=h[k];
    });
    updateCampos(); setTimeout(calcular,200);
  }catch(e){}
}

function clearHistory(){
  try{ localStorage.removeItem(HIST_KEY); renderHistory(); }catch(e){}
}



// ════════════════════════════════════════════════════════════
// FEATURE 6 — SOLICITAR PRESUPUESTO PRÉ-REMPLI
// ════════════════════════════════════════════════════════════
function openQuoteForm(){
  var c = document.getElementById('aa_cultivo').value;
  var ha = document.getElementById('aa_hectareas').value;
  var prod = document.getElementById('aa_productoResultado') ? document.getElementById('aa_productoResultado').innerText : '';
  var fmt_r = document.getElementById('aa_formatoResultado') ? document.getElementById('aa_formatoResultado').innerText : '';
  var pr_wa = parseFloat(document.getElementById('aa_precio').value)||0;
  var ahorro = pr_wa > 0 && document.getElementById('aa_dineroResultado') ? document.getElementById('aa_dineroResultado').innerText : '';
  var agua_wa = document.getElementById('aa_aguaResultado') ? document.getElementById('aa_aguaResultado').innerText : '';
  var empresa = document.getElementById('aa_empresa').value;
  var nombre = document.getElementById('aa_nombre').value;
  var telefono = document.getElementById('aa_telefono').value;
  var email = document.getElementById('aa_email').value;

  var subject = encodeURIComponent('Solicitud de presupuesto AQUASOL — '+c+' '+ha+'ha');
  var body = encodeURIComponent(
    'Hola,\n\nHe calculado mis necesidades con la calculadora AQUASOL:\n\n' +
    '• Cultivo: ' + c + '\n' +
    '• Superficie: ' + ha + ' ha\n' +
    '• Producto necesario: ' + prod + '\n' +
    '• Formato recomendado: ' + fmt_r + '\n' +
    (pr_wa > 0 ? '• Ahorro estimado: ' + ahorro + '/año\\n' : '• Agua ahorrada: ' + agua_wa + '\\n') + '\\n' +
    (empresa ? '• Empresa: ' + empresa + '\\n' : '') +
    (nombre  ? '• Nombre: '  + nombre  + '\\n' : '') +
    (telefono? '• Teléfono: '+ telefono+ '\\n' : '') +
    (email   ? '• Email: '   + email   + '\\n' : '') +
    '\\nQuedo a su disposición para cualquier consulta.\\n\\nGracias.'
  );

  var wa = 'https://wa.me/34680704013?text=' + body;
  window.open(wa, '_blank');
}